import { createElementBlock as n, openBlock as l, normalizeProps as it, guardReactiveProps as vt, renderSlot as K, mergeProps as $e, ref as C, createCommentVNode as b, createElementVNode as a, useCssVars as Ie, computed as R, toRefs as ae, onMounted as ke, onUnmounted as lt, normalizeStyle as g, normalizeClass as J, unref as t, createBlock as F, Fragment as X, resolveDynamicComponent as ge, createVNode as D, toDisplayString as w, withCtx as q, createTextVNode as _, renderList as re, useAttrs as gt, withDirectives as fe, withModifiers as Ke, vShow as be, Transition as at, nextTick as Le, createStaticVNode as qt, withKeys as _e, Teleport as ot, watch as jt, vModelCheckbox as Ne, resolveComponent as We, markRaw as he, createSlots as Mt, TransitionGroup as It, isRef as Bt } from "vue";
const ne = (e, i) => {
  const o = e.__vccOpts || e;
  for (const [c, s] of i)
    o[c] = s;
  return o;
}, Ft = {};
function Lt(e, i) {
  return l(), n("button", it(vt(e.$attrs)), [
    K(e.$slots, "default")
  ], 16);
}
const ji = /* @__PURE__ */ ne(Ft, [["render", Lt]]), Dt = {};
function At(e, i) {
  return l(), n("span", $e({ class: "rounded py-0.5 px-1 flex items-center justify-center" }, e.$attrs), [
    K(e.$slots, "default")
  ], 16);
}
const Ee = /* @__PURE__ */ ne(Dt, [["render", At]]), Ht = { class: "absolute flex items-center justify-center top-0 bottom-0 right-0 left-0" }, Et = {
  viewBox: "0,0,24,24",
  width: "32",
  height: "32",
  fill: "white",
  xmlns: "http://www.w3.org/2000/svg",
  class: "inline-block"
}, Nt = {
  key: 0,
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M16.054 10.149a.6.6 0 01.82-.218 2.885 2.885 0 01-.002 4.997.6.6 0 11-.6-1.039 1.685 1.685 0 000-2.92.6.6 0 01-.218-.82z"
}, Wt = {
  key: 1,
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M17.193 8.167a.6.6 0 01.82-.219 5.17 5.17 0 012.587 4.48 5.17 5.17 0 01-2.588 4.481.6.6 0 11-.6-1.039A3.97 3.97 0 0019.4 12.43a3.97 3.97 0 00-1.988-3.442.6.6 0 01-.219-.82zM8.571 8.4a.6.6 0 01.6.6v6.857a.6.6 0 01-1.2 0V9a.6.6 0 01.6-.6z"
}, Rt = ["autoplay", "muted", "src"], zt = {
  __name: "JVideoBanner",
  props: {
    autoplay: {
      type: Boolean,
      default: !1
    },
    videoSource: {
      type: String,
      required: !0
    },
    canControlAudio: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const i = C(!0), o = (c) => {
      c.preventDefault(), i.value = !i.value;
    };
    return (c, s) => (l(), n("div", Ht, [
      e.canControlAudio ? (l(), n("button", {
        key: 0,
        "aria-label": "Control Audio",
        class: "btn-control-audio absolute top-0 right-0 m-3 z-20 transition delay-1000 ease-out duration-300",
        onClick: o
      }, [
        (l(), n("svg", Et, [
          i.value ? b("", !0) : (l(), n("path", Nt)),
          i.value ? b("", !0) : (l(), n("path", Wt)),
          s[0] || (s[0] = a("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M10.795 6.711c1.723-1.206 4.09.027 4.09 2.13v7.175c0 2.103-2.367 3.336-4.09 2.13l-2.413-1.689H7.43a4.029 4.029 0 010-8.057h.953l2.413-1.689zm2.89 2.13c0-1.132-1.274-1.796-2.202-1.147L8.76 9.6H7.429a2.829 2.829 0 100 5.657H8.76l2.722 1.906c.928.65 2.203-.015 2.203-1.147V8.84z"
          }, null, -1))
        ]))
      ])) : b("", !0),
      a("video", {
        autoplay: e.autoplay,
        playsinline: "",
        "webkit-playsinline": "",
        muted: i.value,
        loop: "",
        src: e.videoSource
      }, null, 8, Rt)
    ]));
  }
};
function rt(e) {
  if (!e) return {};
  const i = window.getComputedStyle(e)["overflow-y"], o = window.getComputedStyle(e)["overflow-x"];
  return {
    vertical: (i === "scroll" || i === "auto") && e.scrollHeight > e.clientHeight,
    horizontal: (o === "scroll" || o === "auto") && e.scrollWidth > e.clientWidth
  };
}
function Be(e, i, o, c = !1) {
  const s = new window.IntersectionObserver(
    ([r]) => {
      if (r.isIntersecting) {
        i && (o ? i(o) : i(), c && s.unobserve(e));
        return;
      }
    },
    {
      root: null,
      threshold: 0.1
      // set offset 0.1 means trigger if atleast 10% of element in viewport
    }
  );
  if (e)
    s.observe(e);
  else
    throw i;
}
let ut = null;
const ht = (e) => {
  ut = setTimeout(() => {
    e.value = !0;
  }, 1e3);
}, bt = (e) => {
  clearTimeout(ut), e.value = !1;
}, Vt = (e, i) => {
  e && (ut = e.addEventListener("mouseenter", function() {
    ht(i);
  }), e.addEventListener("mouseleave", function() {
    bt(i);
  }));
}, Jt = (e) => {
  e && (e.removeEventListener("mouseenter", ht), e.removeEventListener("mouseleave", bt));
}, Pt = { class: "w-2/3 sm:w-1/2 pb-5 z-10" }, Ut = {
  key: 0,
  class: ""
}, Gt = ["innerHTML"], Zt = {
  key: 4,
  class: "j-tag font-semibold text-xs sm:text-base flex items-center mb-2"
}, Kt = { class: "w-full" }, Xt = { key: 2 }, Qt = {
  __name: "JBanner",
  props: {
    data: {
      type: Object,
      required: !0
    },
    hasOverlay: {
      type: Boolean,
      required: !1,
      default: !1
    },
    customWrapper: {
      type: [String, Object],
      required: !1,
      default: "div"
    },
    titleStyle: {
      type: Object,
      default: {}
    },
    descriptionStyle: {
      type: Object,
      required: !1,
      default: {}
    },
    metricsStyle: {
      type: Object,
      required: !1,
      default: {}
    },
    contentStyle: {
      type: Object,
      required: !1,
      default: {}
    },
    contentClasses: {
      type: String,
      required: !1,
      default: "items-start justify-end text-left"
    },
    buttonAlignment: {
      type: String,
      required: !1,
      default: "justify-start items-end text-center"
    },
    wrapperStyle: {
      type: Object,
      required: !1,
      default: {
        height: "500px"
      }
    },
    hasInteraction: {
      type: Boolean,
      required: !1,
      default: !0
    },
    autoplay: {
      Boolean,
      required: !1,
      default: !1
    },
    canControlAudio: {
      Boolean,
      required: !1,
      default: !1
    },
    buttons: {
      type: Array,
      default: []
    },
    buttonCustomWrapper: {
      type: [String, Object],
      required: !1,
      default: "div"
    }
  },
  setup(e) {
    Ie((x) => ({
      bf109614: k.value,
      "61e30a8c": M.value
    }));
    const i = e, {
      data: o,
      customWrapper: c,
      hasOverlay: s,
      width: r,
      autoplay: y,
      canControlAudio: d,
      wrapperStyle: m
    } = ae(i), u = C(!0), h = C(!1), f = C(null), p = C(null), v = C(y.value), S = R(() => u.value ? "auto" : ""), j = () => {
      let x = rt(f.value);
      if (f.value) {
        const T = f.value.querySelector(":first-child");
        T && (x = rt(T));
      }
      x != null && x.vertical && (h.value = !0);
    };
    ke(() => {
      var x;
      try {
        f.value && Be(f.value, j, null, !0);
      } catch (T) {
        console.error("check show more issues", T, f.value);
      }
      y.value || !((x = o.value) != null && x.videoSrc) || Vt(p.value, v);
    }), lt(() => {
      var x;
      y.value || !((x = o.value) != null && x.videoSrc) || Jt(p.value);
    });
    const $ = (x) => {
      x.preventDefault(), u.value = !u.value;
    }, N = R(() => {
      var x, T;
      if ((x = o.value) != null && x.videoSrc && y.value) return null;
      if ((T = o.value) != null && T.img) return `url(${o.value.img})`;
      if (v.value) return "unset";
    }), k = R(
      () => {
        var x, T;
        return ((x = m.value) == null ? void 0 : x.borderColorOnHover) || ((T = m.value) == null ? void 0 : T.borderColor);
      }
    ), M = R(
      () => {
        var x, T;
        return ((x = m.value) == null ? void 0 : x.borderColorOnActive) || ((T = m.value) == null ? void 0 : T.borderColor);
      }
    );
    return (x, T) => {
      var O, E;
      return l(), n("div", {
        class: J(["j-banner overflow-hidden", [
          t(s) ? "overlay" : null,
          t(y) || v.value ? "is-video" : null
        ]]),
        ref_key: "jBannerRef",
        ref: p,
        style: g({
          backgroundImage: N.value,
          ...u.value ? { ...t(m) } : { ...t(m), height: S.value, aspectRatio: "unset" },
          minHeight: "100%"
        })
      }, [
        v.value ? (l(), F(zt, {
          key: 0,
          "video-source": t(o).videoSrc,
          autoplay: t(y) || v.value,
          canControlAudio: t(d)
        }, null, 8, ["video-source", "autoplay", "canControlAudio"])) : b("", !0),
        t(o) ? (l(), n(X, { key: 1 }, [
          (l(), F(ge(t(c)), {
            class: "flex h-full z-10 absolute top-0 right-0 bottom-0 left-0",
            to: t(o).imgTo ? t(o).imgTo : "/not-set",
            target: t(c) === "a" ? "_blank" : null,
            href: t(o).imgTo,
            "aria-label": `Read more ${t(o).description}`
          }, null, 8, ["to", "target", "href", "aria-label"])),
          a("div", {
            class: J(["slider-content h-full flex flex-col container mx-auto top-0 left-0 right-0 bottom-0", [
              e.contentClasses,
              u.value && (t(m).aspectRatio || t(m).height !== "auto") ? "absolute" : "relative"
            ]]),
            style: g(e.contentStyle)
          }, [
            a("div", Pt, [
              (O = t(o).socialMedia) != null && O.items && ((E = t(o).socialMedia) != null && E.items.length) ? (l(), n("div", Ut, [
                D(t(Tt), {
                  data: t(o).socialMedia,
                  customWrapper: e.hasInteraction ? "a" : "div"
                }, null, 8, ["data", "customWrapper"])
              ])) : b("", !0),
              t(o).title ? (l(), n("h1", {
                key: 1,
                class: "j-title",
                style: g(e.titleStyle)
              }, w(t(o).title), 5)) : b("", !0),
              t(o).description ? (l(), n("div", {
                key: 2,
                class: J(["j-description mb-2", {
                  "truncate-3-lines": u.value,
                  "ql-editor p-0": t(o).isRichText
                }]),
                ref_key: "jdescription",
                ref: f,
                style: g(e.descriptionStyle),
                innerHTML: t(o).description
              }, null, 14, Gt)) : b("", !0),
              t(o).tags ? (l(), n("h4", {
                key: 3,
                class: "j-tag mb-2",
                style: g(e.metricsStyle)
              }, w(t(o).tags) + ". ", 5)) : b("", !0),
              t(o).text ? (l(), n("h4", Zt, w(t(o).text), 1)) : b("", !0),
              h.value ? (l(), F(t(se), {
                key: 5,
                class: "md:text-base j-banner-show-more flex text-base",
                onClick: $,
                style: g(e.descriptionStyle),
                "aria-label": u.value ? `${t(o).showMoreButtonText}` : `${t(o).showLessButtonText}`
              }, {
                default: q(() => [
                  _(w(u.value ? t(o).showMoreButtonText : t(o).showLessButtonText), 1)
                ]),
                _: 1
              }, 8, ["style", "aria-label"])) : b("", !0)
            ]),
            a("div", Kt, [
              t(o).userEngagements ? (l(), F(t(Ot), {
                key: 0,
                subscribe: t(o).userEngagements.subscribe,
                like: t(o).userEngagements.like,
                dislike: t(o).userEngagements.dislike,
                watchLater: t(o).userEngagements.watchLater
              }, null, 8, ["subscribe", "like", "dislike", "watchLater"])) : b("", !0)
            ]),
            K(x.$slots, "tonos-buttons", {}, void 0, !0),
            a("div", {
              class: J(["w-full flex flex-wrap", e.buttonAlignment])
            }, [
              K(x.$slots, "buttons", {}, () => [
                (l(!0), n(X, null, re(e.buttons, (I) => (l(), F(t(He), {
                  class: "z-10",
                  key: I.id,
                  data: I,
                  type: I.props.type,
                  "custom-wrapper": I.props.linkType === 1 ? "a" : e.buttonCustomWrapper,
                  style: g(I.style),
                  icon: I.icon,
                  text: I.props.text,
                  url: I.props.url
                }, null, 8, ["data", "type", "custom-wrapper", "style", "icon", "text", "url"]))), 128))
              ], !0)
            ], 2)
          ], 6)
        ], 64)) : (l(), n("div", Xt, "..."))
      ], 6);
    };
  }
}, Yt = /* @__PURE__ */ ne(Qt, [["__scopeId", "data-v-d01beaa6"]]), _t = {
  key: 0,
  class: "flex h-full"
}, el = { class: "w-2/3 sm:w-1/2 pb-5" }, tl = {
  key: 0,
  class: ""
}, ll = ["innerHTML"], al = {
  key: 4,
  class: "j-tag font-semibold text-xs sm:text-base flex items-center mb-2"
}, ol = { class: "w-full" }, nl = { class: "w-full flex flex-wrap" }, sl = { key: 1 }, rl = {
  __name: "JBannerSceleton",
  props: {
    data: {
      type: Object,
      required: !0
    },
    hasOverlay: {
      type: Boolean,
      required: !1,
      default: !1
    },
    customWrapper: {
      type: String,
      required: !1,
      default: "div"
    },
    titleStyle: {
      type: Object,
      default: {}
    },
    descriptionStyle: {
      type: Object,
      required: !1,
      default: {}
    },
    metricsStyle: {
      type: Object,
      required: !1,
      default: {}
    },
    contentStyle: {
      type: Object,
      required: !1,
      default: {}
    },
    contentClasses: {
      type: String,
      required: !1,
      default: "items-start justify-end text-left"
    },
    wrapperStyle: {
      type: Object,
      required: !1,
      default: {
        height: "500px"
      }
    },
    hasInteraction: {
      type: Boolean,
      required: !1,
      default: !0
    },
    autoplay: {
      Boolean,
      required: !1,
      default: !1
    },
    canControlAudio: {
      Boolean,
      required: !1,
      default: !1
    },
    buttons: {
      type: Array,
      default: []
    }
  },
  setup(e) {
    const i = e, { data: o, customWrapper: c, hasOverlay: s, width: r, autoplay: y, canControlAudio: d } = ae(i), m = C(!0);
    C(!1);
    const u = C(null);
    return R(() => m ? "auto" : ""), (h, f) => {
      var p, v;
      return l(), n("div", {
        class: "j-banner j-banner-sceleton overflow-hidden",
        style: g({ ...e.wrapperStyle, minHeight: "100%" })
      }, [
        t(o) ? (l(), n("div", _t, [
          a("div", {
            class: J(["slider-content flex flex-col container mx-auto", e.contentClasses]),
            style: g(e.contentStyle)
          }, [
            a("div", el, [
              (p = t(o).socialMedia) != null && p.items && ((v = t(o).socialMedia) != null && v.items.length) ? (l(), n("div", tl, [
                D(t(Tt), {
                  data: t(o).socialMedia,
                  customWrapper: e.hasInteraction ? "a" : "div"
                }, null, 8, ["data", "customWrapper"])
              ])) : b("", !0),
              t(o).title ? (l(), n("h1", {
                key: 1,
                class: "j-title",
                style: g(e.titleStyle)
              }, w(t(o).title), 5)) : b("", !0),
              t(o).description ? (l(), n("div", {
                key: 2,
                class: J(["j-description mb-2", {
                  "truncate-3-lines": m.value,
                  "ql-editor p-0": t(o).isRichText
                }]),
                ref_key: "jdescription",
                ref: u,
                style: g(e.descriptionStyle),
                innerHTML: t(o).description
              }, null, 14, ll)) : b("", !0),
              t(o).tags ? (l(), n("h4", {
                key: 3,
                class: "j-tag mb-2",
                style: g(e.metricsStyle)
              }, w(t(o).tags) + ". ", 5)) : b("", !0),
              t(o).text ? (l(), n("h4", al, w(t(o).text), 1)) : b("", !0)
            ]),
            a("div", ol, [
              t(o).userEngagements ? (l(), F(t(Ot), {
                key: 0,
                subscribe: t(o).userEngagements.subscribe,
                like: t(o).userEngagements.like,
                dislike: t(o).userEngagements.dislike,
                watchLater: t(o).userEngagements.watchLater
              }, null, 8, ["subscribe", "like", "dislike", "watchLater"])) : b("", !0)
            ]),
            a("div", nl, [
              K(h.$slots, "buttons", {}, () => [
                (l(!0), n(X, null, re(e.buttons, (S) => (l(), F(t(dl), {
                  key: S.id,
                  data: S
                }, null, 8, ["data"]))), 128))
              ], !0)
            ])
          ], 6)
        ])) : (l(), n("div", sl, "..."))
      ], 4);
    };
  }
}, Mi = /* @__PURE__ */ ne(rl, [["__scopeId", "data-v-5b28ec64"]]), se = {
  __name: "JButton",
  props: {
    variant: {
      type: String,
      required: !1,
      default: "primary"
    },
    active: {
      type: Boolean,
      required: !1,
      default: !1
    },
    full: {
      type: Boolean,
      required: !1,
      default: !1
    },
    circle: {
      type: Boolean,
      required: !1,
      default: !1
    },
    transparent: {
      type: Boolean,
      required: !1,
      default: !1
    },
    rounded: {
      type: Boolean,
      required: !1,
      default: !1
    },
    outlined: {
      type: Boolean,
      required: !1,
      default: !1
    },
    hovered: {
      type: Boolean,
      required: !1,
      default: !1
    },
    selected: {
      type: Boolean,
      required: !1,
      default: !1
    },
    loading: {
      type: Boolean,
      required: !1,
      default: !1
    },
    callback: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    data: {
      type: String,
      required: !1,
      default: null
    },
    dg: {
      type: String,
      required: !1,
      default: null
    },
    border: {
      type: String,
      required: !1,
      default: null
    },
    background: {
      type: String,
      required: !1,
      default: null
    },
    textColor: {
      type: String,
      required: !1,
      default: null
    },
    hidden: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  setup(e) {
    const i = e, { variant: o, active: c, full: s, border: r, hidden: y, transparent: d, rounded: m, textColor: u, background: h, callback: f, data: p } = ae(i), v = R(() => ({
      background: h.value,
      border: r.value,
      color: u.value
    }));
    function S() {
      f && f.value && f.value(p.value);
    }
    return (j, $) => (l(), n("button", {
      class: J(["j-button py-2", [
        t(o),
        {
          "j-is-rounded": t(m),
          "j-is-loading": e.loading,
          "j-is-outlined": e.outlined,
          "j-is-fullwidth": t(s),
          "j-is-circle": e.circle,
          "j-is-transparent": t(d),
          "j-is-active": t(c),
          "j-is-hovered": e.hovered,
          "j-is-selected": e.selected,
          "j-is-hidden": t(y)
        }
      ]]),
      style: g(v.value),
      onClick: S
    }, [
      K(j.$slots, "default")
    ], 6));
  }
}, il = { key: 0 }, ul = {
  __name: "JCustomButton",
  props: {
    text: {
      type: String,
      default: ""
    },
    customWrapper: {
      type: [String, Object],
      default: "RouterLink"
    },
    style: {
      type: Object,
      default: {}
    },
    icon: {
      type: Object,
      default: {}
    },
    // icon, icon-text, text
    type: {
      type: String,
      default: "icon"
    },
    url: {
      type: String,
      default: ""
    },
    textBeforeIcon: {
      type: Boolean,
      default: !1
    },
    version: {
      type: String,
      default: "1"
    }
  },
  setup(e) {
    Ie((x) => ({
      "71214c07": S.value,
      ccb48366: k.value,
      "03db2e7c": h.value,
      "03d625c8": f.value,
      "711c4353": j.value,
      "3c364c80": p.value,
      "1d626d95": $.value,
      e313a7d6: M.value,
      "3c405de8": v.value,
      "1d5d64e1": N.value
    }));
    const i = e, { customWrapper: o, text: c, style: s, icon: r, type: y, url: d, version: m } = ae(i), u = R(() => {
      const x = m.value === "2" ? s.value : s.value.fontStyle;
      if (!x) return {};
      const {
        textAlign: T,
        fontSize: O,
        fontWeight: E,
        fontFamily: I,
        color: A,
        colorOnActive: le,
        colorOnHover: Z
      } = x;
      return {
        textAlign: T,
        fontSize: O,
        fontWeight: E,
        fontFamily: I,
        color: A,
        colorOnActive: le,
        colorOnHover: Z
      };
    }), h = R(
      () => {
        var x, T;
        return ((x = u.value) == null ? void 0 : x.colorOnHover) || ((T = u.value) == null ? void 0 : T.color);
      }
    ), f = R(
      () => {
        var x, T, O, E;
        return ((T = (x = r.value) == null ? void 0 : x.style) == null ? void 0 : T.colorOnHover) || ((E = (O = r.value) == null ? void 0 : O.style) == null ? void 0 : E.color);
      }
    ), p = R(
      () => {
        var x, T;
        return ((x = u.value) == null ? void 0 : x.colorOnActive) || ((T = u.value) == null ? void 0 : T.color);
      }
    ), v = R(
      () => {
        var x, T, O, E;
        return ((T = (x = r.value) == null ? void 0 : x.style) == null ? void 0 : T.colorOnActive) || ((E = (O = r.value) == null ? void 0 : O.style) == null ? void 0 : E.color);
      }
    ), S = R(
      () => {
        var x, T;
        return ((x = s.value) == null ? void 0 : x.backgroundColorOnHover) || ((T = s.value) == null ? void 0 : T.backgroundColor);
      }
    ), j = R(
      () => {
        var x, T, O, E;
        return ((T = (x = r.value) == null ? void 0 : x.style) == null ? void 0 : T.backgroundColorOnHover) || ((E = (O = r.value) == null ? void 0 : O.style) == null ? void 0 : E.backgroundColor);
      }
    ), $ = R(
      () => {
        var x, T;
        return ((x = s.value) == null ? void 0 : x.backgroundColorOnActive) || ((T = s.value) == null ? void 0 : T.backgroundColor);
      }
    ), N = R(
      () => {
        var x, T, O, E;
        return ((T = (x = r.value) == null ? void 0 : x.style) == null ? void 0 : T.backgroundColorOnActive) || ((E = (O = r.value) == null ? void 0 : O.style) == null ? void 0 : E.backgroundColor);
      }
    ), k = R(
      () => {
        var x, T;
        return ((x = s.value) == null ? void 0 : x.borderColorOnHover) || ((T = s.value) == null ? void 0 : T.borderColor);
      }
    ), M = R(
      () => {
        var x, T;
        return ((x = s.value) == null ? void 0 : x.borderColorOnActive) || ((T = s.value) == null ? void 0 : T.borderColor);
      }
    );
    return (x, T) => (l(), F(ge(t(o)), {
      style: g(t(s)),
      href: t(o) === "a" && t(d) ? t(d) : "/not-set",
      to: t(d) ? t(d) : "/not-set",
      target: t(o) === "a" && t(d) ? "_blank" : null,
      class: J(["flex flex-row flex-wrap items-center j-custom-button", e.textBeforeIcon === !0 ? "flex-row-reverse" : ""]),
      "aria-label": `Read more ${t(c)}`
    }, {
      default: q(() => [
        K(x.$slots, "default", {}, () => [
          (t(y) === "icon" || t(y) === "icon-text") && t(r).props ? (l(), n("span", il, [
            D(t(oe), {
              "ikone-name": t(r).props.name,
              "ikone-style": t(r).style
            }, null, 8, ["ikone-name", "ikone-style"])
          ])) : b("", !0),
          t(y) === "text" || t(y) === "icon-text" ? (l(), n("div", {
            key: 1,
            style: g(u.value),
            class: "button-text cursor-pointer"
          }, [
            K(x.$slots, "text", {}, () => [
              _(w(t(c)), 1)
            ], !0)
          ], 4)) : b("", !0)
        ], !0)
      ]),
      _: 3
    }, 8, ["style", "href", "to", "target", "class", "aria-label"]));
  }
}, He = /* @__PURE__ */ ne(ul, [["__scopeId", "data-v-d2886edf"]]), cl = ["width", "height"], dl = {
  __name: "JCustomButtonSceleton",
  props: {
    data: {
      type: Object,
      required: !0
    },
    customWrapper: {
      type: String,
      default: null
    }
  },
  setup(e) {
    return (i, o) => (l(), n("div", {
      style: g(e.data.style),
      class: "j-custom-button-sceleton flex flex-wrap items-center"
    }, [
      K(i.$slots, "default", {}, () => [
        e.data.props.type === "icon" || e.data.props.type === "icon-text" ? (l(), n("span", {
          key: 0,
          style: g(e.data.icon.style)
        }, [
          K(i.$slots, "icon", {}, () => [
            (l(), n("svg", {
              viewBox: "0,0,24,24",
              width: e.data.icon.props.size,
              height: e.data.icon.props.size,
              xmlns: "http://www.w3.org/2000/svg",
              class: "inline-block",
              style: g({ fill: e.data.icon.style.color || "currentcolor" })
            }, o[0] || (o[0] = [
              a("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M3.4 6A2.6 2.6 0 016 3.4h12A2.6 2.6 0 0120.6 6v12a2.6 2.6 0 01-2.6 2.6H6A2.6 2.6 0 013.4 18V6zM6 4.6A1.4 1.4 0 004.6 6v12A1.4 1.4 0 006 19.4h12a1.4 1.4 0 001.4-1.4V6A1.4 1.4 0 0018 4.6H6z"
              }, null, -1),
              a("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M6.477 8.077a1.6 1.6 0 011.6-1.6h1.077a1.6 1.6 0 011.6 1.6v1.077a1.6 1.6 0 01-1.6 1.6H8.077a1.6 1.6 0 01-1.6-1.6V8.077zm1.6-.4a.4.4 0 00-.4.4v1.077c0 .22.179.4.4.4h1.077a.4.4 0 00.4-.4V8.077a.4.4 0 00-.4-.4H8.077zM12.015 7.077a.6.6 0 01.6-.6h4.308a.6.6 0 010 1.2h-4.308a.6.6 0 01-.6-.6zM12.015 10.154a.6.6 0 01.6-.6h4.308a.6.6 0 010 1.2h-4.308a.6.6 0 01-.6-.6zM6.477 14.23a1.6 1.6 0 011.6-1.6h1.077a1.6 1.6 0 011.6 1.6v1.078a1.6 1.6 0 01-1.6 1.6H8.077a1.6 1.6 0 01-1.6-1.6V14.23zm1.6-.4a.4.4 0 00-.4.4v1.078c0 .22.179.4.4.4h1.077a.4.4 0 00.4-.4V14.23a.4.4 0 00-.4-.4H8.077zM12.015 13.23a.6.6 0 01.6-.6h4.308a.6.6 0 010 1.2h-4.308a.6.6 0 01-.6-.6zM12.015 16.308a.6.6 0 01.6-.6h4.308a.6.6 0 010 1.2h-4.308a.6.6 0 01-.6-.6z"
              }, null, -1)
            ]), 12, cl))
          ])
        ], 4)) : b("", !0),
        e.data.props.type === "text" || e.data.props.type === "icon-text" ? (l(), n("div", {
          key: 1,
          style: g(e.data.style.fontStyle),
          class: "button-text"
        }, [
          K(i.$slots, "text", {}, () => [
            _(w(e.data.props.text), 1)
          ])
        ], 4)) : b("", !0)
      ])
    ], 4));
  }
}, fl = { class: "flex flex-1 flex-col justify-between p-2 order-2" }, yl = { class: "flex gap-1" }, pl = { class: "flex gap-1" }, ml = {
  key: 0,
  class: "py-1 px-1.5 rounded text-white bg-[#3A41ED]"
}, vl = { class: "flex ml-auto gap-1" }, gl = {
  key: 0,
  class: "badge badge__wrapper-video-live"
}, hl = {
  key: 1,
  class: "py-1 px-1.5 rounded text-white bg-black/50"
}, bl = { class: "flex mt-auto" }, wl = { class: "flex ml-auto" }, xl = {
  inheritAttrs: !1,
  customOptions: {}
}, kl = /* @__PURE__ */ Object.assign(xl, {
  __name: "JCard",
  props: {
    showTitle: {
      type: Boolean,
      required: !1,
      default: !1
    },
    title: {
      type: String,
      required: !1,
      default: ""
    },
    showAuthor: {
      type: Boolean,
      required: !1,
      default: !1
    },
    author: {
      type: String,
      required: !1,
      default: ""
    },
    showViews: {
      type: Boolean,
      required: !1,
      default: !1
    },
    views: {
      type: String,
      required: !1,
      default: ""
    },
    showDate: {
      type: Boolean,
      required: !1,
      default: !1
    },
    date: {
      type: String,
      required: !1,
      default: ""
    },
    showTimeDuration: {
      type: Boolean,
      required: !1,
      default: !1
    },
    timeDuration: {
      type: [String, Number],
      required: !1,
      default: ""
    },
    showThumbnail: {
      type: Boolean,
      required: !1,
      default: !1
    },
    detailsStyle: {
      type: Object,
      required: !1
    },
    url: {
      type: String,
      required: !1,
      default: ""
    },
    isRedirect: {
      type: Boolean,
      required: !1,
      default: !1
    },
    customWrapper: {
      type: String,
      required: !1,
      default: "RouterLink"
    },
    cardStyle: {
      type: Object,
      required: !1,
      default: {}
    },
    titleStyle: {
      type: Object,
      required: !1,
      default: {}
    },
    infoboxFontStyle: {
      type: Object,
      required: !1,
      default: {}
    },
    infoboxClasses: {
      type: String,
      default: ""
    },
    infoboxStyle: {
      type: Object,
      required: !1,
      default: {}
    },
    infoboxWrapperStyle: {
      type: Object,
      required: !1,
      default: {}
    },
    thumbnailStyle: {
      type: Object,
      required: !1,
      default: {}
    },
    breakpoint: {
      type: String,
      required: !1,
      default: "desktop"
    },
    showParentGroup: {
      type: Boolean,
      default: !1
    },
    parentGroupName: {
      type: String,
      default: ""
    },
    parentGroupUrl: {
      type: String,
      default: ""
    },
    parentGroupStyle: {
      type: Object,
      default: {}
    },
    showProgressBar: {
      type: Boolean,
      default: !0
    },
    progressBarConfig: {
      type: Object,
      default: {
        position: "bottom",
        frontBarStyle: {},
        backBarStyle: {},
        isVertical: !1
      }
    },
    progressBarValue: {
      type: [Number, String],
      default: 50
    },
    isNew: {
      type: Boolean,
      default: !1
    },
    newItemText: {
      type: String,
      default: "New"
    }
  },
  setup(e) {
    const i = e, o = gt(), c = R(() => o.order ? `flex-${o.order}` : "flex-col"), { showAuthor: s, showViews: r, showDate: y, parentGroupStyle: d, progressBarValue: m } = ae(i), u = R(
      () => s.value || r.value || y.value
    ), h = R(() => {
      if (!i.progressBarConfig) return {};
      const { isVertical: v, frontBarStyle: S } = i.progressBarConfig;
      return v ? { ...S, height: m.value + "%" } : { ...S, width: m.value + "%" };
    }), f = (v) => {
      v.target.style.color = d.value.colorOnHover || d.value.color;
    }, p = (v) => {
      v.target.style.color = d.value.color;
    };
    return (v, S) => (l(), n("div", $e({ class: "j-card w-full" }, v.$attrs, {
      class: [e.cardStyle.layoutType, e.breakpoint]
    }), [
      a("div", {
        class: J([[c.value, e.cardStyle.layoutType], "w-full flex cardBorder"]),
        style: g(e.cardStyle)
      }, [
        e.showThumbnail ? (l(), F(ge(e.isRedirect ? "a" : e.customWrapper), {
          key: 0,
          to: e.url ? e.url : "",
          href: e.url ? e.url : "",
          class: "relative"
        }, {
          default: q(() => [
            a("div", {
              class: J([
                "absolute z-1 top-0 left-0 flex w-full h-full overflow-hidden",
                e.progressBarConfig && e.progressBarConfig.isVertical ? "flex-row" : "flex-col"
              ]),
              style: g(e.thumbnailStyle)
            }, [
              a("div", fl, [
                a("div", yl, [
                  a("div", pl, [
                    e.isNew ? (l(), n("span", ml, w(e.newItemText), 1)) : b("", !0),
                    K(v.$slots, "top_left", {}, void 0, !0)
                  ]),
                  a("div", vl, [
                    K(v.$slots, "top_right", {}, void 0, !0),
                    e.showTimeDuration && e.timeDuration ? (l(), n(X, { key: 0 }, [
                      e.timeDuration === -1 ? (l(), n("span", gl, "Live")) : (l(), n("span", hl, w(e.timeDuration), 1))
                    ], 64)) : b("", !0)
                  ])
                ]),
                S[0] || (S[0] = a("div", { class: "flex w-full mt-auto" }, null, -1)),
                a("div", bl, [
                  K(v.$slots, "bottom_left", { class: "flex" }, void 0, !0),
                  a("div", wl, [
                    K(v.$slots, "bottom_right", {}, void 0, !0)
                  ])
                ])
              ]),
              e.showProgressBar && e.progressBarConfig && t(m) ? (l(), n("div", {
                key: 0,
                class: J([
                  "flex",
                  e.progressBarConfig.position === "bottom" || e.progressBarConfig.position === "right" ? "order-3" : "order-1"
                ])
              }, [
                a("div", {
                  class: "flex-1 overflow-hidden",
                  style: g(e.progressBarConfig.backBarStyle)
                }, [
                  a("div", {
                    style: g(h.value)
                  }, null, 4)
                ], 4)
              ], 2)) : b("", !0)
            ], 6),
            K(v.$slots, "image", {}, void 0, !0),
            K(v.$slots, "filmstrip", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["to", "href"])) : b("", !0),
        u.value || e.showTitle ? (l(), n("div", {
          key: 1,
          style: g(e.infoboxWrapperStyle),
          class: "j-infobox p-1 box-border z-1 overflow-hidden"
        }, [
          e.showTitle ? (l(), F(ge(e.isRedirect ? "a" : e.customWrapper), {
            key: 0,
            to: e.url ? e.url : "",
            href: e.url ? e.url : "",
            class: "jcard-truncate",
            style: g(e.titleStyle)
          }, {
            default: q(() => [
              _(w(e.title), 1)
            ]),
            _: 1
          }, 8, ["to", "href", "style"])) : b("", !0),
          e.showParentGroup && e.parentGroupName ? (l(), F(ge(e.parentGroupUrl ? "RouterLink" : "div"), {
            key: 1,
            style: g(t(d)),
            to: e.parentGroupUrl,
            onMouseenter: f,
            onMouseleave: p
          }, {
            default: q(() => [
              _(w(e.parentGroupName), 1)
            ]),
            _: 1
          }, 40, ["style", "to"])) : b("", !0),
          u.value ? (l(), n("div", {
            key: 2,
            class: J([e.infoboxClasses, "flex flex-wrap"]),
            style: g(e.infoboxStyle)
          }, [
            t(s) ? (l(), n("span", {
              key: 0,
              style: g(e.infoboxFontStyle)
            }, w(e.author), 5)) : b("", !0),
            t(r) ? (l(), n("span", {
              key: 1,
              style: g(e.infoboxFontStyle)
            }, w(e.views), 5)) : b("", !0),
            t(y) ? (l(), n("span", {
              key: 2,
              style: g(e.infoboxFontStyle)
            }, w(e.date), 5)) : b("", !0)
          ], 6)) : b("", !0)
        ], 4)) : b("", !0)
      ], 6)
    ], 16));
  }
}), Xe = /* @__PURE__ */ ne(kl, [["__scopeId", "data-v-9c581b6b"]]), Sl = {
  key: 0,
  class: "relative"
}, Cl = { class: "absolute z-1 top-0 left-0 flex flex-col w-full h-full justify-between p-2" }, $l = { class: "flex" }, Tl = { class: "flex ml-auto absolute right-0" }, Ol = {
  key: 0,
  class: "j-card-badge-sceleton py-0.5 px-1 rounded text-white bg-black/50 mx-1"
}, ql = { class: "flex mt-auto" }, jl = { class: "flex ml-auto" }, Ml = {
  inheritAttrs: !1,
  customOptions: {}
}, Il = /* @__PURE__ */ Object.assign(Ml, {
  __name: "JCardSceleton",
  props: {
    showTitle: {
      type: Boolean,
      required: !1,
      default: !1
    },
    title: {
      type: String,
      required: !1,
      default: ""
    },
    showAuthor: {
      type: Boolean,
      required: !1,
      default: !1
    },
    author: {
      type: String,
      required: !1,
      default: ""
    },
    showViews: {
      type: Boolean,
      required: !1,
      default: !1
    },
    views: {
      type: String,
      required: !1,
      default: ""
    },
    showDate: {
      type: Boolean,
      required: !1,
      default: !1
    },
    date: {
      type: String,
      required: !1,
      default: ""
    },
    showTimeDuration: {
      type: Boolean,
      required: !1,
      default: !1
    },
    timeDuration: {
      type: String,
      required: !1,
      default: ""
    },
    showThumbnail: {
      type: Boolean,
      required: !1,
      default: !1
    },
    detailsStyle: {
      type: Object,
      required: !1
    },
    url: {
      type: String,
      required: !1,
      default: ""
    },
    isRedirect: {
      type: Boolean,
      required: !1,
      default: !1
    },
    customWrapper: {
      type: String,
      required: !1,
      default: "RouterLink"
    },
    cardStyle: {
      type: Object,
      required: !1,
      default: {}
    },
    titleStyle: {
      type: Object,
      required: !1,
      default: {}
    },
    infoboxFontStyle: {
      type: Object,
      required: !1,
      default: {}
    },
    infoboxClasses: {
      type: String,
      default: ""
    },
    infoboxStyle: {
      type: Object,
      required: !1,
      default: {}
    },
    infoboxWrapperStyle: {
      type: Object,
      required: !1,
      default: {}
    },
    breakpoint: {
      type: String,
      required: !1,
      default: "desktop"
    }
  },
  setup(e) {
    const i = e, o = gt(), c = R(() => o.order ? `flex-${o.order}` : "flex-col"), { showAuthor: s, showViews: r, showDate: y } = ae(i), d = R(
      () => s.value || r.value || y.value
    );
    return (m, u) => (l(), n("div", $e({ class: "j-card-sceleton w-full" }, m.$attrs, {
      class: [e.cardStyle.layoutType, e.breakpoint]
    }), [
      a("div", {
        class: J([c.value, "w-full flex"]),
        style: g(e.cardStyle)
      }, [
        e.showThumbnail ? (l(), n("div", Sl, [
          a("div", Cl, [
            a("div", $l, [
              K(m.$slots, "top_left", {}, void 0, !0),
              a("div", Tl, [
                K(m.$slots, "top_right", {}, void 0, !0),
                e.showTimeDuration && e.timeDuration ? (l(), n("span", Ol, w(e.timeDuration), 1)) : b("", !0)
              ])
            ]),
            u[0] || (u[0] = a("div", { class: "flex w-full mt-auto" }, null, -1)),
            a("div", ql, [
              K(m.$slots, "bottom_left", { class: "flex" }, void 0, !0),
              a("div", jl, [
                K(m.$slots, "bottom_right", {}, void 0, !0)
              ])
            ])
          ]),
          K(m.$slots, "image", {}, void 0, !0),
          K(m.$slots, "filmstrip", {}, void 0, !0)
        ])) : b("", !0),
        d.value || e.showTitle ? (l(), n("div", {
          key: 1,
          style: g(e.infoboxWrapperStyle),
          class: "j-infobox p-1 box-border z-1"
        }, [
          e.showTitle ? (l(), n("div", {
            key: 0,
            class: "j-card-title jcard-truncate",
            style: g(e.titleStyle)
          }, w(e.title), 5)) : b("", !0),
          d.value ? (l(), n("div", {
            key: 1,
            class: J([e.infoboxClasses, "j-card-sceleton-infobox flex flex-wrap"]),
            style: g(e.infoboxStyle)
          }, [
            t(s) ? (l(), n("span", {
              key: 0,
              class: "j-card-sceleton-subtitle",
              style: g(e.infoboxFontStyle)
            }, w(e.author), 5)) : b("", !0),
            t(r) ? (l(), n("span", {
              key: 1,
              class: "j-card-sceleton-subtitle",
              style: g(e.infoboxFontStyle)
            }, w(e.views), 5)) : b("", !0),
            t(y) ? (l(), n("span", {
              key: 2,
              class: "j-card-sceleton-subtitle",
              style: g(e.infoboxFontStyle)
            }, w(e.date), 5)) : b("", !0)
          ], 6)) : b("", !0)
        ], 4)) : b("", !0)
      ], 6)
    ], 16));
  }
}), wt = /* @__PURE__ */ ne(Il, [["__scopeId", "data-v-8fae4fae"]]);
async function xt(e) {
  return new Promise((i) => {
    const o = new Image();
    o.onload = function() {
      i(e);
    }, o.onerror = function() {
      console.log("onerror", e), i(!1);
    }, o.src = e;
  });
}
const Bl = ["alt", "src", "data-src"], Fl = {
  __name: "JPertaciImage",
  props: {
    imageSrc: {
      type: String,
      required: !1
    },
    width: {
      type: String,
      required: !1
    },
    height: {
      type: String,
      required: !1
    },
    aspectRatio: {
      type: String,
      required: !1
    },
    alt: {
      type: String,
      required: !0
    },
    placeholder: {
      type: String,
      required: !1,
      default: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII="
    },
    fallback: {
      type: String,
      required: !1,
      default: "https://cdn.vpapps.cloud/default-image.png"
    },
    noLazyImage: {
      type: Boolean,
      required: !1,
      default: !1
    },
    alt: {
      type: String,
      required: !1,
      default: "&nbsp;"
    }
  },
  setup(e) {
    const i = e, {
      imageSrc: o,
      placeholder: c,
      width: s,
      height: r,
      aspectRatio: y,
      alt: d,
      fallback: m,
      noLazyImage: u
    } = ae(i), h = C(o.value), f = C(null);
    return ke(() => {
      setTimeout(() => {
        xt(o.value).then((p) => {
          p || (f.value.classList.add("broke-image"), h.value = m.value);
        });
      }, 3e3);
    }), (p, v) => (l(), n("img", $e({
      style: {
        aspectRatio: t(y),
        width: t(s),
        height: t(r)
      },
      alt: t(d),
      class: "j-lazy-image w-full",
      ref_key: "jimage",
      ref: f,
      src: h.value,
      "data-src": t(o)
    }, p.$attrs), null, 16, Bl));
  }
}, xe = /* @__PURE__ */ ne(Fl, [["__scopeId", "data-v-c63ef3c3"]]);
let pt = null;
function kt(e, i) {
  clearTimeout(pt), pt = setTimeout(() => {
    e();
  }, i);
}
const Ll = { class: "chat-input flex flex-col relative" }, Dl = { class: "h-[24px] w-[24px] min-w-[24px] min-h-[24px]" }, Al = { class: "relative w-full" }, Hl = ["placeholder", "data-placeholder"], El = { class: "absolute w-3/4 bottom-full bg-white text-black" }, Nl = ["onClick", "onMouseover"], Wl = { class: "w-10 h-auto" }, Rl = { class: "absolute" }, zl = {
  key: 0,
  class: "flex bg-white max-h-48 scrollable-list items-center justify-center p-4 overflow-y-auto z-20 flex-col"
}, Vl = { class: "flex justify-end items-center" }, Jl = {
  __name: "JChatInput",
  props: {
    postMessageCallback: {
      type: Function,
      required: !0
    },
    footerStyle: {
      type: Object,
      required: !1,
      default: {}
    },
    profile: {
      type: Object,
      required: !1,
      default: {
        picture: null,
        name: "Unknown"
      }
    },
    buttonText: {
      type: String,
      required: !1,
      default: "Send"
    },
    inputText: {
      type: String,
      required: !1,
      default: "Write a message..."
    },
    mentionUsers: {
      type: Array,
      required: !0,
      default: []
    },
    mentionEnabled: {
      type: Boolean,
      default: !0
    },
    loadMentionUsers: {
      type: Function,
      required: !1,
      default: null
    },
    hideMentionUserLoader: {
      type: Boolean,
      required: !1,
      default: !1
    },
    sendButtonType: {
      type: String,
      required: !1,
      default: "icon-text"
    },
    loadMoreMentions: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    mentionsSearchCallback: {
      type: Function,
      required: !1,
      default: null
    }
  },
  setup(e) {
    Ie((B) => ({
      af43ee8c: p.value
    }));
    const i = e, { mentionEnabled: o, mentionUsers: c } = ae(i);
    C(null);
    const s = C(null), r = C(!1), y = C(""), d = C([]), m = C(""), u = C(-1), h = C(!1), f = C(null), p = C(i.footerStyle.input.placeholderColor), v = R(() => c.value.filter(
      (L) => !d.value.some((H) => H.userId === L.userId)
    ));
    function S() {
      i.loadMentionUsers && i.loadMentionUsers();
    }
    const j = () => kt(S, 600), $ = () => {
      if (s.value.innerText.trim().length === 0) return;
      const B = s.value.cloneNode(!0);
      B.querySelectorAll("span").forEach((V) => {
        if (V.classList.contains("mention")) {
          const te = `@{${V.getAttribute("data-user-id")}}`, ue = document.createTextNode(te);
          V.replaceWith(ue);
        } else {
          const U = document.createTextNode(V.innerText);
          V.replaceWith(U);
        }
      });
      const H = B.innerText.trim();
      i.postMessageCallback && i.postMessageCallback(H), s.value.innerText = "", N();
    }, N = () => {
      d.value = [], r.value = !1, y.value = "", h.value = !1;
    };
    S();
    const k = (B) => {
      if (B.key === "Enter" && (B.preventDefault(), $()), B.key === "@" && j(), B.key === "@" && o.value === !0 && c.value && c.value.length > 0) {
        const H = window.getSelection().getRangeAt(0);
        if (H.startContainer.textContent.charAt(H.startOffset - 1).trim().slice(-1) !== "") {
          r.value = !1;
          return;
        }
        r.value = !0, d.value.length === c.value.length && O(), E();
      } else if (B.key === "ArrowUp")
        B.preventDefault(), x();
      else if (B.key === "ArrowDown")
        B.preventDefault(), T();
      else if (B.key === "Escape")
        B.preventDefault(), r.value = !1;
      else if (B.key === "Backspace" || B.key === "Delete") {
        if (window.getSelection().toString().trim() === s.value.innerText.trim() && d.value.length > 0) {
          B.preventDefault(), d.value = [], s.value.innerHTML = "", r.value = !1;
          return;
        }
        let H = Array.from(
          s.value.querySelectorAll(".mention")
        );
        setTimeout(() => {
          H.forEach((V) => {
            if (!document.body.contains(V)) {
              B.preventDefault();
              let U = V.innerText;
              const te = d.value.find(
                (ue) => `${ue.firstName} ${ue.lastName}` === U
              );
              te && (d.value = d.value.filter(
                (ue) => ue.userId !== te.userId
              )), m.value = s.value.innerHTML;
            }
          }), y.value === "" && (r.value = !1);
        }, 0);
      } else if (B.key === " ") {
        const H = window.getSelection().getRangeAt(0);
        H.startOffset > 0 && H.startContainer.textContent.charAt(
          H.startOffset - 1
        ) === "@" && (r.value = !1);
      }
    }, M = C(null), x = () => {
      r.value && u.value > 0 && (u.value--, M.value.children[u.value].scrollIntoView({ block: "nearest", inline: "nearest" }));
    }, T = () => {
      r.value && u.value < v.value.length - 1 && (u.value++, M.value.children[u.value].scrollIntoView({ block: "nearest", inline: "nearest" }));
    }, O = () => {
      h.value = !0, setTimeout(() => {
        h.value = !1;
      }, 2e3);
    }, E = () => {
      const L = window.getSelection().getRangeAt(0), H = L.startContainer.textContent.substring(
        0,
        L.startOffset
      ), V = H.lastIndexOf("@");
      if (V !== -1) {
        const U = H.substring(V + 1).trim();
        y.value = U;
      } else
        y.value = "";
      r.value && i.mentionsSearchCallback && (y.value.split(" ").length > 2 && (r.value = !1, y.value = ""), y.value.length && i.mentionsSearchCallback(y.value));
    }, I = (B) => {
      s.value.innerText.length >= 200 && B.preventDefault();
    }, A = (B) => {
      B.preventDefault();
      let L = B.clipboardData.getData("text"), V = 200 - s.value.innerText.length;
      L.length > V && (L = L.substring(0, V)), s.value.innerText += L;
    }, le = (B) => {
      var ue, G;
      if (d.value.some((Y) => Y.userId === B.userId))
        return;
      d.value.push(B), d.value.length === c.value.length && !y.value && O();
      const L = window.getSelection(), H = L.getRangeAt(0), V = y.value.length;
      if (H.startContainer && H.startOffset > V)
        H.setStart(
          H.startContainer,
          H.startOffset - V - 1
        );
      else if (H.startContainer && H.startContainer.previousSibling) {
        const Y = H.startContainer.previousSibling;
        H.setStart(Y, Y.length - V - 1);
      }
      const U = `<span contenteditable="false" class="mention" style="color:${(G = (ue = i.footerStyle) == null ? void 0 : ue.input) == null ? void 0 : G.wrapper.mentionColor}" data-user-id="${B.userId}">${B.firstName} ${B.lastName}</span>`, te = H.createContextualFragment(U);
      H.deleteContents(), H.insertNode(te), H.collapse(!1), s.value.focus(), L.removeAllRanges(), L.addRange(H), m.value = s.value.innerHTML, y.value = "", r.value = !1, E(), j();
    }, Z = (B) => {
      let L = 0;
      for (let V = 0; V < B.length; V++)
        L = B.charCodeAt(V) + ((L << 5) - L);
      let H = (L & 16777215).toString(16).toUpperCase();
      for (; H.length < 6; )
        H = "0" + H;
      return "#" + H;
    };
    ke(() => {
      Be(f.value, W);
    });
    const W = () => {
      try {
        i.loadMoreMentions();
      } catch (B) {
        console.error("Error calling load more: ", B);
      }
    };
    return (B, L) => (l(), n("div", Ll, [
      a("div", {
        class: "flex justify-between py-1",
        style: g(e.footerStyle.input.wrapper)
      }, [
        a("picture", Dl, [
          e.profile.picture ? (l(), F(xe, {
            key: 0,
            "image-src": e.profile.picture,
            alt: "comment-img",
            class: "rounded-full mr-3 h-100 h-[24px] w-[24px]",
            fallback: "https://cdn.vpapps.cloud/unnamed.jpg"
          }, null, 8, ["image-src"])) : (l(), F(t(yt), {
            key: 1,
            profileStyle: e.profile.style,
            name: e.profile.name
          }, {
            default: q(() => [
              _(w(e.profile.name), 1)
            ]),
            _: 1
          }, 8, ["profileStyle", "name"]))
        ]),
        a("div", Al, [
          a("div", {
            ref_key: "editableDiv",
            ref: s,
            type: "text",
            class: "chat-input flex-1 editable-div whitespace-nowrap bg-transparent absolute left-0 top-0 w-full overflow-x-auto focus:outline-none px-3",
            placeholder: e.inputText,
            contenteditable: "",
            onKeydown: k,
            onKeypress: I,
            onPaste: A,
            onInput: E,
            onBlur: L[0] || (L[0] = (H) => r.value = !1),
            style: g(e.footerStyle.input.fontStyle),
            "data-placeholder": e.inputText
          }, null, 44, Hl),
          a("div", El, [
            fe(a("ul", {
              class: "flex bg-white max-h-48 scrollable-list overflow-y-auto z-20 flex-col",
              ref_key: "suggestionList",
              ref: M
            }, [
              (l(!0), n(X, null, re(v.value, (H, V) => {
                var U, te;
                return l(), n("li", {
                  class: "cursor-pointer flex gap-2 px-3 z-9999 items-center bg-white py-2 hover:bg-[#F6F8F9] border border-t border-[#ECF2F4] text-black pb-3 whitespace-nowrap",
                  key: H.userId,
                  onClick: (ue) => le(H),
                  onMousedown: L[1] || (L[1] = Ke(() => {
                  }, ["prevent"])),
                  onMouseover: (ue) => u.value = V,
                  style: g(
                    u.value === V ? { backgroundColor: "#F6F8F9" } : {}
                  )
                }, [
                  a("div", Wl, [
                    a("span", {
                      class: "w-10 min-w-[40px] h-10 rounded-full text-white flex items-center justify-center relative",
                      style: g({
                        backgroundColor: Z(
                          (U = H == null ? void 0 : H.firstName) == null ? void 0 : U.slice(0, 1)
                        )
                      })
                    }, [
                      H != null && H.picture ? (l(), F(xe, {
                        key: 0,
                        "image-src": H == null ? void 0 : H.picture,
                        alt: "comment-img",
                        class: "rounded-full h-full object-cover z-1"
                      }, null, 8, ["image-src"])) : b("", !0),
                      a("span", Rl, w((te = H == null ? void 0 : H.firstName) == null ? void 0 : te.slice(0, 1)), 1)
                    ], 4)
                  ]),
                  _(" " + w(H.firstName) + " " + w(H.lastName), 1)
                ], 44, Nl);
              }), 128)),
              a("li", null, [
                fe(a("div", {
                  ref_key: "mentionUserLoader",
                  ref: f,
                  class: "first-chat-message flex justify-center flex-col items-center"
                }, L[2] || (L[2] = [
                  a("div", { class: "overflow-hidden" }, [
                    a("div", { class: "border-gray-300 min-h-[24px] min-w-[24px] animate-spin rounded-full border-4 border-t-blue-600 my-1" })
                  ], -1)
                ]), 512), [
                  [be, e.hideMentionUserLoader]
                ])
              ])
            ], 512), [
              [be, v.value.length > 0 && r.value]
            ]),
            y.value.length && !v.value.length ? (l(), n("ul", zl, L[3] || (L[3] = [
              a("li", null, "No Users Found", -1)
            ]))) : b("", !0)
          ])
        ])
      ], 4),
      a("div", Vl, [
        D(t(He), {
          text: e.buttonText,
          "custom-wrapper": "div",
          type: e.sendButtonType,
          style: g(e.footerStyle.button),
          icon: e.footerStyle.icon,
          version: "2",
          onClick: $
        }, null, 8, ["text", "type", "style", "icon"])
      ])
    ]));
  }
}, Pl = /* @__PURE__ */ ne(Jl, [["__scopeId", "data-v-34ca76db"]]);
function Fe(e, i) {
  return ke(() => {
    document.addEventListener("click", i, { capture: !0 });
  }), lt(() => {
    document.removeEventListener("click", i);
  }), {
    isClickOutside: function(o) {
      return (e == null ? void 0 : e.value) && !e.value.contains(o.target);
    }
  };
}
const Ul = { class: "flex" }, Gl = { class: "flex" }, Zl = ["innerHTML"], Kl = {
  key: 0,
  class: "relative mr-5"
}, Xl = ["id"], Ql = { class: "flex flex-col bg-white z-90" }, Yl = { class: "flex items-center pl-2 hover:bg-[#F8FAFB]" }, _l = { class: "flex items-center pl-2 hover:bg-[#F8FAFB]" }, ea = { class: "flex items-center pl-2 hover:bg-[#F8FAFB]" }, ta = {
  __name: "JChatRow",
  props: {
    message: {
      type: String,
      required: !0
    },
    id: {
      type: String,
      required: !1,
      default: "1"
    },
    index: {
      type: Number,
      required: !0,
      default: -1
    },
    author: {
      type: Object,
      required: !0
    },
    rowStyle: {
      type: Object,
      required: !1
    },
    deleteChatMessageCallback: {
      type: Function,
      required: !1
    },
    showChatMessageOptions: {
      type: Boolean,
      required: !1,
      default: !1
    },
    blockChatUserCallback: {
      type: Function,
      required: !1
    },
    mentionUsers: {
      type: Array,
      required: !1,
      default: []
    },
    enableTimestamps: {
      type: Boolean,
      required: !1,
      default: !1
    },
    messageTime: {
      type: String,
      required: !1,
      default: ""
    }
  },
  setup(e) {
    const i = e, { mentionUsers: o } = ae(i), c = C(!1), s = C(null), r = C(!1), y = C(null), d = (S) => {
      m.isClickOutside(S, s) && (c.value = !1), u.isClickOutside(S, y) && (r.value = !1);
    }, m = Fe(s, d), u = Fe(y, d), h = () => {
      i.deleteChatMessageCallback && (i.deleteChatMessageCallback(i.id), c.value = !1);
    }, f = () => {
      const S = {
        type: 1,
        email: i.author.email
      };
      i.blockChatUserCallback && (i.blockChatUserCallback(S), c.value = !1);
    }, p = () => {
      const S = {
        type: 2,
        email: i.author.email
      };
      i.blockChatUserCallback && (i.blockChatUserCallback(S), c.value = !1);
    }, v = (S) => {
      const j = /@\{(\w+)\}/g;
      return S.replace(j, ($, N) => {
        var M, x;
        const k = o.value.find((T) => T.userId === N);
        return k ? `<span style="color:${((x = (M = i.rowStyle) == null ? void 0 : M.wrapper) == null ? void 0 : x.mentionColor) || "blue"};">${k.firstName} ${k.lastName}</span>` : '<span style="color:red;">User Not Found</span>';
      });
    };
    return (S, j) => {
      var $, N;
      return l(), n("div", {
        class: "w-full h-auto flex flex-row items-start",
        style: g(e.rowStyle.wrapper)
      }, [
        a("div", Ul, [
          e.author.image ? (l(), F(t(xe), {
            key: 0,
            style: g(e.rowStyle.image),
            "image-src": e.author.image,
            alt: "comment-img",
            class: "chat-imagerounded-full",
            fallback: "https://cdn.vpapps.cloud/unnamed.jpg"
          }, null, 8, ["style", "image-src"])) : (l(), F(t(yt), {
            key: 1,
            profileStyle: e.rowStyle.image,
            name: e.author.name
          }, {
            default: q(() => [
              _(w(S.profile.name), 1)
            ]),
            _: 1
          }, 8, ["profileStyle", "name"]))
        ]),
        a("div", {
          class: "flex flex-row justify-between w-full items-center",
          style: g({ gap: ((N = ($ = e.rowStyle) == null ? void 0 : $.wrapper) == null ? void 0 : N.gap) || null })
        }, [
          a("div", Gl, [
            a("div", {
              class: "chat-message break-all!",
              style: g(e.rowStyle.text)
            }, [
              a("span", {
                class: "chat-author whitespace-nowrap inline-block",
                style: g(e.rowStyle.author)
              }, w(e.enableTimestamps ? e.messageTime : "") + " " + w(e.author.name) + ": ", 5),
              a("span", {
                innerHTML: v(e.message)
              }, null, 8, Zl)
            ], 4)
          ]),
          e.showChatMessageOptions ? (l(), n("div", Kl, [
            (l(), n("svg", {
              width: "16",
              height: "16",
              viewBox: "0 0 16 16",
              fill: "none",
              class: "cursor-pointer",
              xmlns: "http://www.w3.org/2000/svg",
              onClick: j[0] || (j[0] = (k) => c.value = !c.value)
            }, j[1] || (j[1] = [
              a("path", {
                d: "M7.99984 4.66667C7.26346 4.66667 6.6665 4.06971 6.6665 3.33333C6.6665 2.59695 7.26346 2 7.99984 2C8.73622 2 9.33317 2.59695 9.33317 3.33333C9.33317 4.06971 8.73622 4.66667 7.99984 4.66667Z",
                fill: "#36435E"
              }, null, -1),
              a("path", {
                d: "M7.99984 9.33333C7.26346 9.33333 6.6665 8.73638 6.6665 8C6.6665 7.26362 7.26346 6.66667 7.99984 6.66667C8.73622 6.66667 9.33317 7.26362 9.33317 8C9.33317 8.73638 8.73622 9.33333 7.99984 9.33333Z",
                fill: "#36435E"
              }, null, -1),
              a("path", {
                d: "M6.6665 12.6667C6.6665 13.403 7.26346 14 7.99984 14C8.73622 14 9.33317 13.403 9.33317 12.6667C9.33317 11.9303 8.73622 11.3333 7.99984 11.3333C7.26346 11.3333 6.6665 11.9303 6.6665 12.6667Z",
                fill: "#36435E"
              }, null, -1)
            ]))),
            fe(a("div", {
              ref_key: "chatOptionsRef",
              ref: s,
              id: `chat-options-pop-up-${e.id}`,
              class: J(["w-auto absolute right-4 -transform-x-1/2 rounded-sm shadow flex flex-col", e.index > 2 ? "bottom-0" : "top-0"])
            }, [
              a("span", Ql, [
                a("span", Yl, [
                  D(t(se), {
                    callback: h,
                    data: "1",
                    rounded: "",
                    class: "flex gap-2 whitespace-nowrap text-[#ff0000] px-2 justify-start! w-full pl-0",
                    "aria-label": "Smazat"
                  }, {
                    default: q(() => j[2] || (j[2] = [
                      a("svg", {
                        width: "18",
                        height: "18",
                        viewBox: "0 0 14 16",
                        fill: "none",
                        class: "p-px",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        a("path", {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M4 2.90234V3.27734H0.8125C0.50184 3.27734 0.25 3.52918 0.25 3.83984C0.25 4.1505 0.50184 4.40234 0.8125 4.40234H1.84375L3.00363 13.6814C3.14438 14.8074 4.10153 15.6523 5.23626 15.6523H8.76374C9.89847 15.6523 10.8556 14.8074 10.9964 13.6814L12.1562 4.40234H13.1875C13.4982 4.40234 13.75 4.1505 13.75 3.83984C13.75 3.52918 13.4982 3.27734 13.1875 3.27734H10V2.90234C10 1.6597 8.99264 0.652344 7.75 0.652344H6.25C5.00736 0.652344 4 1.6597 4 2.90234ZM7.75 1.77734H6.25C5.62868 1.77734 5.125 2.28102 5.125 2.90234V3.27734H8.875V2.90234C8.875 2.28102 8.37132 1.77734 7.75 1.77734ZM4.11995 13.5419L3.02438 4.77734H10.9756L9.88005 13.5419C9.80968 14.1049 9.3311 14.5273 8.76374 14.5273H5.23626C4.6689 14.5273 4.19032 14.1049 4.11995 13.5419Z",
                          fill: "#ff0000"
                        })
                      ], -1),
                      _(" Delete ")
                    ])),
                    _: 1,
                    __: [2]
                  })
                ]),
                a("span", _l, [
                  D(t(se), {
                    callback: f,
                    data: "1",
                    rounded: "",
                    class: "flex gap-2 whitespace-nowrap text-[#36435E] px-2 justify-start! w-full pl-0",
                    "aria-label": "Smazat"
                  }, {
                    default: q(() => j[3] || (j[3] = [
                      a("svg", {
                        width: "18",
                        height: "18",
                        viewBox: "0 0 14 14",
                        fill: "none",
                        class: "p-px",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        a("path", {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M3.84742 7.15302C3.84742 6.87809 4.0703 6.65521 4.34523 6.65521H9.65514C9.93007 6.65521 10.1529 6.87809 10.1529 7.15302C10.1529 7.42795 9.93007 7.65082 9.65514 7.65082H4.34523C4.0703 7.65082 3.84742 7.42795 3.84742 7.15302Z",
                          fill: "#36435E"
                        }),
                        a("path", {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M7.00019 12.7948C10.1161 12.7948 12.642 10.2689 12.642 7.15302C12.642 4.03715 10.1161 1.51123 7.00019 1.51123C3.88431 1.51123 1.3584 4.03715 1.3584 7.15302C1.3584 10.2689 3.88431 12.7948 7.00019 12.7948ZM7.00019 13.7904C10.6659 13.7904 13.6376 10.8187 13.6376 7.15302C13.6376 3.48729 10.6659 0.515625 7.00019 0.515625C3.33445 0.515625 0.362793 3.48729 0.362793 7.15302C0.362793 10.8187 3.33445 13.7904 7.00019 13.7904Z",
                          fill: "#6E7B95"
                        })
                      ], -1),
                      _(" Block User for Chat ")
                    ])),
                    _: 1,
                    __: [3]
                  })
                ]),
                a("span", ea, [
                  D(t(se), {
                    callback: p,
                    data: "1",
                    rounded: "",
                    class: "flex gap-2 whitespace-nowrap text-[#36435E] px-2 justify-start! w-full pl-0",
                    "aria-label": "Smazat"
                  }, {
                    default: q(() => j[4] || (j[4] = [
                      a("svg", {
                        width: "18",
                        height: "18",
                        viewBox: "0 0 14 14",
                        fill: "none",
                        class: "p-px",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        a("path", {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M3.84742 7.15302C3.84742 6.87809 4.0703 6.65521 4.34523 6.65521H9.65514C9.93007 6.65521 10.1529 6.87809 10.1529 7.15302C10.1529 7.42795 9.93007 7.65082 9.65514 7.65082H4.34523C4.0703 7.65082 3.84742 7.42795 3.84742 7.15302Z",
                          fill: "#36435E"
                        }),
                        a("path", {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M7.00019 12.7948C10.1161 12.7948 12.642 10.2689 12.642 7.15302C12.642 4.03715 10.1161 1.51123 7.00019 1.51123C3.88431 1.51123 1.3584 4.03715 1.3584 7.15302C1.3584 10.2689 3.88431 12.7948 7.00019 12.7948ZM7.00019 13.7904C10.6659 13.7904 13.6376 10.8187 13.6376 7.15302C13.6376 3.48729 10.6659 0.515625 7.00019 0.515625C3.33445 0.515625 0.362793 3.48729 0.362793 7.15302C0.362793 10.8187 3.33445 13.7904 7.00019 13.7904Z",
                          fill: "#6E7B95"
                        })
                      ], -1),
                      _(" Block User for Project ")
                    ])),
                    _: 1,
                    __: [4]
                  })
                ])
              ])
            ], 10, Xl), [
              [be, c.value]
            ])
          ])) : b("", !0)
        ], 4)
      ], 4);
    };
  }
}, la = { class: "flex flex-col" }, aa = {
  key: 0,
  class: "absolute top-0 right-0 bottom-0 left-0 flex justify-center items-center text-black text-xs"
}, oa = {
  __name: "JChat",
  props: {
    config: {
      type: Object,
      required: !1,
      default: {
        active: !1,
        isEnded: !1,
        canChat: !0
      }
    },
    postMessageCallback: {
      type: Function,
      required: !0
    },
    loadMentionUsers: {
      type: Function,
      required: !1,
      default: null
    },
    loadMoreOldMesaggesCallback: {
      type: Function,
      required: !1,
      default: null
    },
    loadMoreOldParticipantsCallback: {
      type: Function,
      required: !1,
      default: null
    },
    deleteChatMessageCallback: {
      type: Function,
      required: !1,
      default: null
    },
    laodMoreMentionsCallback: {
      type: Function,
      required: !1,
      default: null
    },
    mentionsSearchCallback: {
      type: Function,
      required: !1,
      default: null
    },
    blockChatUserCallback: {
      type: Function,
      required: !1,
      default: null
    },
    chatMessages: {
      type: Array,
      required: !1,
      default: []
    },
    mentionUsers: {
      type: Array,
      required: !1,
      default: []
    },
    participantsList: {
      type: Array,
      required: !1,
      default: []
    },
    newMessage: {
      type: Object,
      required: !1,
      default: null
    },
    title: {
      type: String,
      required: !1,
      default: "LiveChat"
    },
    hideChatText: {
      type: String,
      required: !1,
      default: "Hide Chat"
    },
    hideMentionUserLoader: {
      type: Boolean,
      required: !1,
      default: !1
    },
    showChatText: {
      type: String,
      required: !1,
      default: "Show Chat"
    },
    buttonText: {
      type: String,
      required: !1,
      default: "Send"
    },
    showParticipantsLoader: {
      type: Boolean,
      required: !1,
      default: !1
    },
    sendButtonType: {
      type: String,
      required: !1,
      default: "icon-text"
    },
    showChatMessageOptions: {
      type: Boolean,
      required: !1,
      default: !1
    },
    participantsChatText: {
      type: String,
      required: !1,
      default: "Participants"
    },
    timestampsChatText: {
      type: String,
      required: !1,
      default: "Timestamps"
    },
    inputText: {
      type: String,
      required: !1,
      default: "Write a message..."
    },
    profile: {
      type: Object,
      required: !1,
      default: {
        picture: null,
        // "https://vwrjffrka3.gjirafa.net/storage/images/user/qzyykq-square.jpg",
        name: "John Doe",
        style: {
          backgroundColor: "red",
          color: "blue",
          borderRadius: "100%",
          fontSize: "14px",
          fontWeight: "500",
          fontFamily: "",
          textDecoration: "none",
          fontStyle: "normal",
          minWidth: "20px",
          minHeight: "20px"
        }
      }
    },
    customHeight: {
      type: [String, Number],
      required: !1,
      default: null
    },
    style: {
      type: Object,
      required: !1,
      default: {
        wrapper: {
          backgroundColor: "lightpink"
        },
        header: {
          wrapper: {
            color: "green",
            backgroundColor: "lightgreen"
          },
          title: {
            color: "green",
            backgroundColor: "lightgreen"
          },
          hideButton: {
            backgroundColor: "lightpink",
            color: "red",
            padding: "4px 8px",
            borderRadius: "4px"
          }
        },
        body: {
          backgroundColor: "lightpink",
          color: "pink"
        },
        row: {
          wrapper: {
            backgroundColor: "lightyellow",
            borderWidth: "1px"
          },
          image: {
            backgroundColor: "lightgreen",
            borderRadius: "100%",
            color: "green"
          },
          author: {
            color: "#6E7B95",
            fontSize: "12px",
            fontWeight: "500",
            fontFamily: ""
          },
          text: {
            color: "#36435E",
            fontSize: "12px",
            fontWeight: "500",
            fontFamily: "",
            padding: "0 0 0 8px"
          }
        },
        footer: {
          wrapper: {
            backgroundColor: "lightblue",
            color: "blue"
          },
          input: {
            borderWidth: "1px",
            borderColor: "#ECF2F4",
            padding: "8px 16px",
            borderRadius: "4px",
            color: "blue",
            placeholderColor: "#6E7B95"
          },
          button: {
            fontSize: "14px",
            color: "#36435E"
          },
          icon: {
            name: "vpapps-font-send-message-alt",
            style: {
              fontSize: "20px",
              color: "#36435E"
            }
          }
        },
        button: {
          wrapper: {
            backgroundColor: "lightpink"
          }
        }
      }
    },
    participantsEnabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    chatInReplayMode: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  setup(e, { expose: i }) {
    Ie((I) => ({
      "5a0d8b1a": S.value,
      "49f00e30": j.value
    }));
    const o = e, c = C(null), s = C(!0), r = C(o.chatMessages), y = C(null), d = C(!1), m = C(0), u = C(!1), h = C(""), f = C(!1), p = C(!1), v = R(() => o.config.active), S = R(
      () => {
        var I, A, le, Z, W, B;
        return ((le = (A = (I = o.style) == null ? void 0 : I.header) == null ? void 0 : A.hideButton) == null ? void 0 : le.colorOnHover) || ((B = (W = (Z = o.style) == null ? void 0 : Z.header) == null ? void 0 : W.hideButton) == null ? void 0 : B.color);
      }
    ), j = R(
      () => {
        var I, A, le, Z, W, B;
        return ((le = (A = (I = o.style) == null ? void 0 : I.header) == null ? void 0 : A.hideButton) == null ? void 0 : le.colorOnActive) || ((B = (W = (Z = o.style) == null ? void 0 : Z.header) == null ? void 0 : W.hideButton) == null ? void 0 : B.color);
      }
    ), $ = (I) => {
      I.target.scrollTop === 0 ? s.value = !0 : s.value = !1;
    }, N = () => {
      y.value.scrollTo(0, 0);
    }, k = () => {
      d.value || (m.value = y.value.scrollTop), d.value = !d.value, m.value != 0 && Le(() => {
        y.value.scrollTo({
          top: m.value,
          left: 0,
          behavior: "instant"
        });
      });
    }, M = () => {
      p.value = !p.value;
    }, x = () => {
      if (d.value) return;
      const [I] = r.value;
      let A = 0;
      I && (A = I.chatMessageId);
      try {
        o.loadMoreOldMesaggesCallback(A);
      } catch (le) {
        console.error("Error calling load more: ", le);
      }
    };
    i({
      showInfoMessage: (I) => {
        h.value = I, f.value = !0, setTimeout(() => {
          f.value = !1;
        }, 4e3);
      }
    }), ke(() => {
      c.value && Be(c.value, x);
    });
    function O(I) {
      u.value = I;
    }
    function E() {
      d.value = !1;
    }
    return (I, A) => {
      var le, Z;
      return l(), n("div", {
        class: J(["j-chat relative h-full flex flex-col overflow-hidden", d.value && "is-collapsed h-auto!"]),
        style: g({ ...e.style.wrapper, height: e.customHeight })
      }, [
        fe(D(t(da), {
          style: g(e.style),
          participants: e.participantsList,
          "load-more-old-participants": e.loadMoreOldParticipantsCallback,
          showParticipantsLoader: e.showParticipantsLoader,
          onHideParticipants: M
        }, null, 8, ["style", "participants", "load-more-old-participants", "showParticipantsLoader"]), [
          [be, p.value]
        ]),
        a("div", {
          class: "chat-content flex flex-col h-full",
          style: g({ gap: ((Z = (le = e.style) == null ? void 0 : le.wrapper) == null ? void 0 : Z.gap) || null })
        }, [
          a("div", {
            class: "chat-header flex justify-between items-center",
            style: g(e.style.header.wrapper)
          }, [
            a("p", {
              style: g(e.style.header.title)
            }, w(e.title), 5),
            D(t(ba), {
              "is-collapsed": d.value,
              "show-chat-text": e.showChatText,
              "hide-chat-text": e.hideChatText,
              "icon-color": e.style.header.title.color,
              "participants-enabled": e.participantsEnabled,
              "participants-chat-text": e.participantsChatText,
              "timestamps-chat-text": e.timestampsChatText,
              onToogleChat: k,
              onEnableTimestamps: O,
              onOpenChatSettings: E,
              onShowParticipants: M
            }, null, 8, ["is-collapsed", "show-chat-text", "hide-chat-text", "icon-color", "participants-enabled", "participants-chat-text", "timestamps-chat-text"])
          ], 4),
          fe(a("div", {
            ref_key: "chatBody",
            ref: y,
            key: "body",
            class: "chat-body overflow-y-auto overflow-x-hidden flex h-full flex-col-reverse",
            style: g(e.style.body),
            onScroll: $
          }, [
            A[0] || (A[0] = a("div", { class: "flex flex-1 grow" }, null, -1)),
            a("div", la, [
              (l(!0), n(X, null, re(r.value, (W, B) => (l(), F(t(ta), {
                key: W.chatMessageId,
                index: B,
                rowStyle: e.style.row,
                id: W.chatMessageId,
                message: W.message,
                "message-time": W.createdAt,
                author: W.author,
                "delete-chat-message-callback": e.deleteChatMessageCallback,
                "block-chat-user-callback": e.blockChatUserCallback,
                "show-chat-message-options": e.showChatMessageOptions,
                mentionUsers: W.userMentions,
                "enable-timestamps": u.value
              }, null, 8, ["index", "rowStyle", "id", "message", "message-time", "author", "delete-chat-message-callback", "block-chat-user-callback", "show-chat-message-options", "mentionUsers", "enable-timestamps"]))), 128))
            ]),
            fe(a("div", {
              ref_key: "firstChatMessage",
              ref: c,
              class: "first-chat-message flex justify-center flex-col items-center"
            }, [
              K(I.$slots, "loadMoreSpinner", {}, void 0, !0)
            ], 512), [
              [be, r.value.length >= 9]
            ]),
            a("div", {
              class: J([f.value ? "show" : null, "info-message absolute bottom-0 flex justify-center items-center text-sm text-black p-1 rounded-md bg-slate-300 m-4"])
            }, w(h.value), 3)
          ], 36), [
            [be, !d.value]
          ]),
          fe(a("div", {
            class: "chat-footer",
            key: "chat-footer",
            style: g(e.style.footer.wrapper)
          }, [
            fe(D(t(Pl), {
              class: J(v.value ? null : "blur-[1px]"),
              footerStyle: e.style.footer,
              profile: e.profile,
              postMessageCallback: e.postMessageCallback,
              "button-text": e.buttonText,
              "input-text": e.inputText,
              mentionUsers: e.mentionUsers,
              "load-mention-users": e.loadMentionUsers,
              "send-button-type": e.sendButtonType,
              "hide-mention-user-loader": e.hideMentionUserLoader,
              "load-more-mentions": e.laodMoreMentionsCallback,
              "mentions-search-callback": e.mentionsSearchCallback
            }, null, 8, ["class", "footerStyle", "profile", "postMessageCallback", "button-text", "input-text", "mentionUsers", "load-mention-users", "send-button-type", "hide-mention-user-loader", "load-more-mentions", "mentions-search-callback"]), [
              [be, !e.chatInReplayMode]
            ]),
            v.value ? b("", !0) : (l(), n("div", aa, [
              K(I.$slots, "chatFooterInfo", {}, void 0, !0)
            ]))
          ], 4), [
            [be, !d.value]
          ]),
          D(at, { name: "slide-up" }, {
            default: q(() => [
              !s.value && r.value.length >= 9 ? (l(), n("div", {
                key: 0,
                onClick: N,
                class: "chat-scroll-to-bottom absolute flex justify-center items-center bottom-16 w-10 h-10 rounded-full mx-auto cursor-pointer"
              }, [
                D(t(oe), {
                  class: "w-[32px] h-[32px] rounded-full border-2 flex justify-center items-center font-bold",
                  "ikone-name": "vpapps-font-chevron-line-down",
                  "ikone-style": e.style.button.wrapper
                }, null, 8, ["ikone-style"])
              ])) : b("", !0)
            ]),
            _: 1
          })
        ], 4)
      ], 6);
    };
  }
}, Ii = /* @__PURE__ */ ne(oa, [["__scopeId", "data-v-e22c54a5"]]), na = {
  width: "22",
  height: "12",
  viewBox: "0 0 16 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sa = ["fill"], ra = { class: "flex-col m-4 mt-0" }, ia = { class: "flex items-center m-2 gap-1 ml-0" }, ua = { class: "flex" }, ca = {
  key: 0,
  class: "overflow-hidden"
}, da = {
  __name: "JChatParticipants",
  props: {
    style: {
      type: Object,
      required: !1,
      default: {}
    },
    participants: {
      type: Array,
      required: !1,
      default: () => []
    },
    loadMoreOldParticipants: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    showParticipantsLoader: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: ["hideParticipants"],
  setup(e, { emit: i }) {
    const o = e, c = C(null), s = C(null);
    ke(() => {
      Be(c.value, r);
    });
    const r = () => {
      try {
        o.loadMoreOldParticipants();
      } catch (y) {
        console.error("Error calling load more: ", y);
      }
    };
    return (y, d) => {
      var m, u, h;
      return l(), n("div", {
        class: "absolute top-0 left-0 w-full h-full z-99999",
        style: g({
          backgroundColor: ((m = e.style.wrapper) == null ? void 0 : m.backgroundcolor) || "#FFFFFF"
        })
      }, [
        a("div", {
          class: "chat-content flex flex-col h-full",
          style: g({ gap: ((h = (u = e.style) == null ? void 0 : u.wrapper) == null ? void 0 : h.gap) || null })
        }, [
          a("div", {
            class: "chat-header flex items-center",
            style: g(e.style.header.wrapper)
          }, [
            a("div", {
              class: "m-4 cursor-pointer",
              onClick: d[0] || (d[0] = (f) => y.$emit("hideParticipants"))
            }, [
              (l(), n("svg", na, [
                a("path", {
                  d: "M6.77521 1.7935C7.01929 1.54943 7.01929 1.1537 6.77521 0.909621C6.53113 0.665543 6.13541 0.665543 5.89133 0.909621L1.18596 5.61499C0.77916 6.02179 0.77916 6.68134 1.18596 7.08813L5.89133 11.7935C6.13541 12.0376 6.53113 12.0376 6.77521 11.7935C7.01929 11.5494 7.01929 11.1537 6.77521 10.9096L2.84215 6.97656L14.6666 6.97656C15.0118 6.97656 15.2916 6.69674 15.2916 6.35156C15.2916 6.00639 15.0118 5.72656 14.6666 5.72656L2.84215 5.72656L6.77521 1.7935Z",
                  fill: e.style.header.title.color
                }, null, 8, sa)
              ]))
            ]),
            a("span", {
              class: "cursor-default",
              style: g({ color: e.style.header.title.color })
            }, "Participants", 4)
          ], 4),
          a("div", {
            ref_key: "chatBody",
            ref: s,
            key: "body",
            class: "chat-body overflow-y-auto overflow-x-hidden w-full flex-1 flex-col-reverse",
            onScroll: d[1] || (d[1] = (...f) => y.onScroll && y.onScroll(...f))
          }, [
            a("ul", ra, [
              (l(!0), n(X, null, re(e.participants, (f, p) => (l(), n("li", null, [
                a("div", ia, [
                  f.picture ? (l(), F(t(xe), {
                    key: 0,
                    style: g(e.style.row.image),
                    "image-src": f.picture,
                    alt: "comment-img",
                    class: "chat-imagerounded-full",
                    fallback: "https://cdn.vpapps.cloud/unnamed.jpg"
                  }, null, 8, ["style", "image-src"])) : (l(), F(t(yt), {
                    key: 1,
                    profileStyle: e.style.row.image,
                    name: f.firstName
                  }, {
                    default: q(() => [
                      _(w(f.firstName), 1)
                    ]),
                    _: 2
                  }, 1032, ["profileStyle", "name"])),
                  a("div", ua, [
                    a("div", {
                      class: "chat-message break-all!",
                      style: g(e.style.row.text)
                    }, [
                      a("span", {
                        class: "chat-author whitespace-nowrap inline-block",
                        style: g(e.style.row.author)
                      }, w(f.firstName) + " " + w(f.lastName), 5)
                    ], 4)
                  ])
                ])
              ]))), 256)),
              a("li", null, [
                fe(a("div", {
                  ref_key: "firstParticipant",
                  ref: c,
                  class: "first-chat-message flex justify-center flex-col items-center"
                }, [
                  e.showParticipantsLoader ? b("", !0) : (l(), n("div", ca, d[2] || (d[2] = [
                    a("div", { class: "border-gray-300 min-h-[24px] min-w-[24px] animate-spin rounded-full border-4 border-t-blue-600 my-1" }, null, -1)
                  ])))
                ], 512), [
                  [be, e.participants.length >= 9 && !e.showParticipantsLoader]
                ])
              ])
            ])
          ], 544)
        ], 4)
      ], 4);
    };
  }
}, fa = { class: "relative" }, ya = ["fill"], pa = { class: "text-sm py-1 mx-1 flex flex-col whitespace-nowrap" }, ma = { class: "text-[#36435E] font-medium p-3 py-1 flex gap-2 items-center cursor-pointer hover:bg-[#F8FAFB]" }, va = { class: "switch-container relative border border-gray-300" }, ga = ["checked"], ha = {
  __name: "JChatOptions",
  props: {
    isCollapsed: {
      type: Boolean,
      required: !0,
      default: !1
    },
    hideChatText: {
      type: String,
      required: !1,
      default: "Hide Chat"
    },
    showChatText: {
      type: String,
      required: !1,
      default: "Show Chat"
    },
    participantsChatText: {
      type: String,
      required: !1,
      default: "Participants"
    },
    timestampsChatText: {
      type: String,
      required: !1,
      default: "Timestamps"
    },
    iconColor: {
      type: String,
      required: !1,
      default: "#6E7B95"
    },
    participantsEnabled: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: [
    "enableTimestamps",
    "toogleChat",
    "openChatSettings",
    "showParticipants"
  ],
  setup(e, { emit: i }) {
    const o = i, c = e, s = C(!1), r = C(!1), y = C(null), d = C(null), { isCollapsed: m } = ae(c), u = () => {
      s.value = !s.value, o("toogleChat");
    }, h = () => {
      m.value && o("openChatSettings"), s.value = !s.value;
    }, f = () => {
      o("showParticipants");
    }, p = (S) => {
      o("enableTimestamps", S);
    }, v = (S) => {
      s.value && !y.value.contains(S.target) && !d.value.contains(S.target) && (s.value = !1);
    };
    return ke(() => {
      document.addEventListener("click", v);
    }), lt(() => {
      document.removeEventListener("click", v);
    }), (S, j) => (l(), n("div", fa, [
      a("div", {
        ref_key: "trigger",
        ref: d
      }, [
        (l(), n("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: e.iconColor,
          class: "cursor-pointer",
          xmlns: "http://www.w3.org/2000/svg",
          onClick: h
        }, j[1] || (j[1] = [
          a("path", { d: "M7.99984 4.66667C7.26346 4.66667 6.6665 4.06971 6.6665 3.33333C6.6665 2.59695 7.26346 2 7.99984 2C8.73622 2 9.33317 2.59695 9.33317 3.33333C9.33317 4.06971 8.73622 4.66667 7.99984 4.66667Z" }, null, -1),
          a("path", { d: "M7.99984 9.33333C7.26346 9.33333 6.6665 8.73638 6.6665 8C6.6665 7.26362 7.26346 6.66667 7.99984 6.66667C8.73622 6.66667 9.33317 7.26362 9.33317 8C9.33317 8.73638 8.73622 9.33333 7.99984 9.33333Z" }, null, -1),
          a("path", { d: "M6.6665 12.6667C6.6665 13.403 7.26346 14 7.99984 14C8.73622 14 9.33317 13.403 9.33317 12.6667C9.33317 11.9303 8.73622 11.3333 7.99984 11.3333C7.26346 11.3333 6.6665 11.9303 6.6665 12.6667Z" }, null, -1)
        ]), 8, ya))
      ], 512),
      fe(a("div", {
        ref_key: "dropdown",
        ref: y,
        class: "absolute w-auto bg-white border rounded-sm border-gray-200 right-full z-9999"
      }, [
        a("ul", pa, [
          e.participantsEnabled ? (l(), n("li", {
            key: 0,
            class: "text-[#36435E] font-medium p-3 py-1 flex gap-2 items-center cursor-pointer hover:bg-[#F8FAFB]",
            onClick: f
          }, [
            j[2] || (j[2] = a("svg", {
              width: "18",
              height: "18",
              viewBox: "0 0 16 12",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              a("path", {
                d: "M7.99985 8.25C9.24249 8.25 10.2498 7.24264 10.2498 6C10.2498 4.75736 9.24249 3.75 7.99985 3.75C6.75721 3.75 5.74985 4.75736 5.74985 6C5.74985 7.24264 6.75721 8.25 7.99985 8.25Z",
                fill: "#6E7B95"
              }),
              a("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M7.99981 0.9375C3.40088 0.9375 1.39372 3.88954 0.789072 5.59984C0.697262 5.85953 0.697263 6.14047 0.789072 6.40016C1.39372 8.11046 3.40088 11.0625 7.99981 11.0625C12.5987 11.0625 14.6059 8.11046 15.2106 6.40016C15.3024 6.14047 15.3024 5.85953 15.2106 5.59984C14.6059 3.88954 12.5987 0.9375 7.99981 0.9375ZM1.84974 5.97482C2.34315 4.57917 4.00644 2.0625 7.99981 2.0625C11.9932 2.0625 13.6565 4.57917 14.1499 5.97482C14.1559 5.99188 14.1559 6.00812 14.1499 6.02518C13.6565 7.42083 11.9932 9.9375 7.99981 9.9375C4.00645 9.9375 2.34315 7.42083 1.84974 6.02518C1.84371 6.00812 1.84371 5.99188 1.84974 5.97482Z",
                fill: "#6E7B95"
              })
            ], -1)),
            a("span", null, w(e.participantsChatText), 1)
          ])) : b("", !0),
          a("li", ma, [
            j[4] || (j[4] = qt('<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" data-v-b1640d92><path d="M4.84734 2.97058C5.11944 2.70279 5.11944 2.26862 4.84734 2.00083C4.57523 1.73304 4.13406 1.73304 3.86195 2.00083L2.00389 3.8294C1.73178 4.09719 1.73178 4.53136 2.00389 4.79915C2.27599 5.06694 2.71717 5.06694 2.98927 4.79915L4.84734 2.97058Z" fill="#6E7B95" data-v-b1640d92></path><path d="M13.1523 2.00083C12.8802 2.26862 12.8802 2.70279 13.1523 2.97058L15.0103 4.79915C15.2824 5.06694 15.7236 5.06694 15.9957 4.79915C16.2678 4.53136 16.2678 4.09719 15.9957 3.8294L14.1377 2.00083C13.8656 1.73304 13.4244 1.73304 13.1523 2.00083Z" fill="#6E7B95" data-v-b1640d92></path><path d="M9.69658 7.05713C9.69658 6.67842 9.38462 6.37142 8.9998 6.37142C8.61499 6.37142 8.30303 6.67842 8.30303 7.05713V10.084L10.3652 12.1134C10.6373 12.3812 11.0785 12.3812 11.3506 12.1134C11.6227 11.8456 11.6227 11.4115 11.3506 11.1437L9.69658 9.51596V7.05713Z" fill="#6E7B95" data-v-b1640d92></path><path fill-rule="evenodd" clip-rule="evenodd" d="M15.503 9.79999C15.503 13.3346 12.5914 16.2 8.9998 16.2C5.40817 16.2 2.49658 13.3346 2.49658 9.79999C2.49658 6.26537 5.40817 3.39999 8.9998 3.39999C12.5914 3.39999 15.503 6.26537 15.503 9.79999ZM14.1095 9.79999C14.1095 12.5772 11.8218 14.8286 8.9998 14.8286C6.17781 14.8286 3.89013 12.5772 3.89013 9.79999C3.89013 7.02278 6.17781 4.77142 8.9998 4.77142C11.8218 4.77142 14.1095 7.02278 14.1095 9.79999Z" fill="#6E7B95" data-v-b1640d92></path></svg>', 1)),
            a("span", null, w(e.timestampsChatText), 1),
            a("div", va, [
              a("input", {
                type: "checkbox",
                id: "`switch-${name}`",
                name: "name",
                checked: r.value,
                onChange: j[0] || (j[0] = ($) => p($.target.checked)),
                hidden: ""
              }, null, 40, ga),
              j[3] || (j[3] = a("label", {
                for: "`switch-${name}`",
                class: "switch absolute w-full h-full cursor-pointer"
              }, null, -1))
            ])
          ]),
          a("li", {
            class: "text-[#36435E] font-medium p-3 py-1 flex gap-2 items-center cursor-pointer hover:bg-[#F8FAFB]",
            onClick: u
          }, [
            j[5] || (j[5] = a("svg", {
              width: "18",
              height: "18",
              viewBox: "0 0 16 12",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              a("path", {
                d: "M7.99985 8.25C9.24249 8.25 10.2498 7.24264 10.2498 6C10.2498 4.75736 9.24249 3.75 7.99985 3.75C6.75721 3.75 5.74985 4.75736 5.74985 6C5.74985 7.24264 6.75721 8.25 7.99985 8.25Z",
                fill: "#6E7B95"
              }),
              a("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M7.99981 0.9375C3.40088 0.9375 1.39372 3.88954 0.789072 5.59984C0.697262 5.85953 0.697263 6.14047 0.789072 6.40016C1.39372 8.11046 3.40088 11.0625 7.99981 11.0625C12.5987 11.0625 14.6059 8.11046 15.2106 6.40016C15.3024 6.14047 15.3024 5.85953 15.2106 5.59984C14.6059 3.88954 12.5987 0.9375 7.99981 0.9375ZM1.84974 5.97482C2.34315 4.57917 4.00644 2.0625 7.99981 2.0625C11.9932 2.0625 13.6565 4.57917 14.1499 5.97482C14.1559 5.99188 14.1559 6.00812 14.1499 6.02518C13.6565 7.42083 11.9932 9.9375 7.99981 9.9375C4.00645 9.9375 2.34315 7.42083 1.84974 6.02518C1.84371 6.00812 1.84371 5.99188 1.84974 5.97482Z",
                fill: "#6E7B95"
              })
            ], -1)),
            a("span", null, w(t(m) ? e.showChatText : e.hideChatText), 1)
          ])
        ])
      ], 512), [
        [be, s.value]
      ])
    ]));
  }
}, ba = /* @__PURE__ */ ne(ha, [["__scopeId", "data-v-b1640d92"]]), Bi = {
  __name: "JCol",
  props: {
    columns: {
      type: [String, Number],
      default: null
    },
    orientation: {
      type: String,
      default: "vertical"
    }
  },
  setup(e) {
    const i = {
      1: "basis-1/12",
      2: "basis-2/12",
      3: "basis-3/12",
      4: "basis-4/12",
      5: "basis-5/12",
      6: "basis-6/12",
      7: "basis-7/12",
      8: "basis-8/12",
      9: "basis-9/12",
      10: "basis-10/12",
      11: "basis-11/12",
      12: "basis-full"
    };
    return (o, c) => (l(), n("div", {
      class: J(["j-column flex max-w-full", [i[e.columns], e.orientation === "vertical" ? "flex-col" : "flex-row"]])
    }, [
      K(o.$slots, "default")
    ], 2));
  }
}, wa = { class: "j-comment-input grid grid-cols-2" }, xa = {
  key: 1,
  class: "j-comment-action-holder flex gap-4 col-span-2"
}, ka = { class: "w-10 min-w-[40px] h-10 rounded-full text-white flex bg-[#F8FAFB] items-center justify-center relative" }, Sa = {
  class: "absolute flex items-center justify-center",
  style: {
    backgroundColor: "#F1F1F3",
    borderRadius: "100%",
    fontSize: "14px",
    fontFamily: "Inter !important",
    lineHeight: "16px",
    color: "#868693",
    fontWeight: "600"
  }
}, Ca = { class: "relative w-full" }, $a = ["onKeydown"], Ta = ["onClick", "onMouseover"], Oa = { class: "w-10 h-auto" }, qa = {
  class: "w-10 min-w-[40px] h-10 rounded-full text-white flex items-center justify-center relative",
  style: {
    backgroundColor: "#F1F1F3",
    borderRadius: "100%",
    fontSize: "13px",
    fontFamily: "Inter !important",
    lineHeight: "16px",
    color: "#868693",
    fontWeight: "600"
  }
}, ja = { class: "absolute flex items-center justify-center" }, Ma = {
  key: 1,
  class: "bg-white"
}, Ia = {
  key: 2,
  class: "j-comment-actions col-span-2 gap-2 flex justify-end mt-3"
}, Ba = {
  __name: "JCommentInput",
  props: {
    callback: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    parentId: {
      type: String,
      required: !1,
      default: null
    },
    cancelCommentCallback: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    user: {
      type: Object,
      required: !0
    },
    mentionUsers: {
      type: Array,
      required: !0
    },
    mentionEnabled: {
      type: Boolean,
      default: !0
    },
    cancelText: {
      type: String,
      default: "Cancel"
    },
    confirmText: {
      type: String,
      default: "Confirm"
    },
    primaryButtonStyle: {
      type: Object,
      default: {}
    },
    secondaryButtonStyle: {
      type: Object,
      default: {}
    },
    canComment: {
      type: Boolean,
      default: !0
    },
    inputTextStyle: {
      type: Object,
      default: {}
    }
  },
  setup(e) {
    const i = e, {
      callback: o,
      cancelCommentCallback: c,
      parentId: s,
      user: r,
      mentionEnabled: y,
      mentionUsers: d
    } = ae(i), m = C(null), u = C(null), h = C(!1), f = C(""), p = C([]), v = C(""), S = C(-1), j = C(!1), $ = R(() => {
      const W = d.value.filter(
        (L) => !p.value.some((H) => H.userId === L.userId)
      );
      if (f.value === "")
        return W;
      const B = f.value.replace(/@.*/, "").trim();
      return W.filter(
        (L) => `${L.firstName} ${L.lastName}`.toLowerCase().includes(B.toLowerCase())
      );
    }), N = () => {
      m.value = null, p.value = [], c && c.value && c.value(), u.value.innerHTML = "";
    }, k = (W) => {
      if (W.key === "@" && y.value === !0 && d.value && d.value.length > 0) {
        const L = window.getSelection().getRangeAt(0);
        if (L.startContainer.textContent.charAt(L.startOffset - 1).trim().slice(-1) !== "") {
          h.value = !1;
          return;
        }
        h.value = !0, p.value.length === d.value.length && E(), I();
      } else if (W.key === "ArrowUp")
        W.preventDefault(), x();
      else if (W.key === "ArrowDown")
        W.preventDefault(), T();
      else if (W.key === "Escape")
        W.preventDefault(), h.value = !1;
      else if (W.key === "Backspace" || W.key === "Delete") {
        if (window.getSelection().toString().trim() === u.value.innerText.trim() && p.value.length > 0) {
          W.preventDefault(), p.value = [], u.value.innerHTML = "", h.value = !1;
          return;
        }
        let L = Array.from(
          u.value.querySelectorAll(".mention")
        );
        setTimeout(() => {
          L.forEach((H) => {
            if (!document.body.contains(H)) {
              W.preventDefault();
              let V = H.innerText;
              const U = p.value.find(
                (te) => `${te.firstName} ${te.lastName}` === V
              );
              U && (p.value = p.value.filter(
                (te) => te.userId !== U.userId
              )), v.value = u.value.innerHTML;
            }
          }), f.value === "" && (h.value = !1);
        }, 0);
      } else if (W.key === "Enter")
        W.preventDefault(), O();
      else if (W.key === " ") {
        const L = window.getSelection().getRangeAt(0);
        L.startOffset > 0 && L.startContainer.textContent.charAt(
          L.startOffset - 1
        ) === "@" && (h.value = !1);
      }
    }, M = C(null), x = () => {
      h.value && S.value > 0 && (S.value--, M.value.children[S.value].scrollIntoView({ block: "nearest", inline: "nearest" }));
    }, T = () => {
      h.value && S.value < $.value.length - 1 && (S.value++, M.value.children[S.value].scrollIntoView({ block: "nearest", inline: "nearest" }));
    }, O = () => {
      h.value && S.value >= 0 && S.value < $.value.length && (le($.value[S.value]), S.value = -1);
    }, E = () => {
      j.value = !0, setTimeout(() => {
        j.value = !1;
      }, 2e3);
      const W = d.value[d.value.length - 1];
      `${W.firstName}${W.lastName}`;
    }, I = () => {
      const B = window.getSelection().getRangeAt(0), L = B.startContainer.textContent.substring(
        0,
        B.startOffset
      ), H = L.lastIndexOf("@");
      if (H !== -1) {
        const V = L.substring(H + 1).trim();
        f.value = V;
      } else
        f.value = "";
    }, A = R(() => {
      let W = v.value;
      return p.value.forEach((B) => {
        `${B.userId}`;
        const L = new RegExp(`@${B.userId}`, "g");
        W = W.replace(L, `${B.firstName} ${B.lastName}`);
      }), W;
    }), le = (W) => {
      if (p.value.some((te) => te.userId === W.userId))
        return;
      p.value.push(W), p.value.length === d.value.length && E();
      const B = window.getSelection(), L = B.getRangeAt(0), H = f.value.length;
      if (L.startContainer && L.startOffset > H)
        L.setStart(
          L.startContainer,
          L.startOffset - H - 1
        );
      else if (L.startContainer && L.startContainer.previousSibling) {
        const te = L.startContainer.previousSibling;
        L.setStart(te, te.length - H - 1);
      }
      const V = `<span contenteditable="false" class="mention" data-user-id="${W.userId}">${W.firstName} ${W.lastName}</span>`, U = L.createContextualFragment(V);
      L.deleteContents(), L.insertNode(U), L.collapse(!1), u.value.focus(), B.removeAllRanges(), B.addRange(L), v.value = u.value.innerHTML, h.value = !1, I();
    }, Z = () => {
      v.value = u.value.innerHTML.replace(/&nbsp;/g, " ");
      const W = u.value.cloneNode(!0);
      W.querySelectorAll("span").forEach((H) => {
        if (H.classList.contains("mention")) {
          const U = `@{${H.getAttribute("data-user-id")}}`, te = document.createTextNode(U);
          H.replaceWith(te);
        } else {
          const V = document.createTextNode(H.innerText);
          H.replaceWith(V);
        }
      });
      const L = W.innerText.trim();
      o && o.value && (o.value(L, s.value, p.value), m.value = null, p.value = []), u.value.innerHTML = "";
    };
    return (W, B) => {
      var L, H, V, U, te, ue;
      return l(), n("div", wa, [
        e.canComment ? (l(), n("div", xa, [
          a("span", ka, [
            (L = t(r)) != null && L.picture ? (l(), F(xe, {
              key: 0,
              "image-src": (H = t(r)) == null ? void 0 : H.picture,
              alt: "comment-img",
              class: "rounded-full h-full object-cover z-1"
            }, null, 8, ["image-src"])) : b("", !0),
            a("span", Sa, w((U = (V = t(r)) == null ? void 0 : V.firstName) == null ? void 0 : U.slice(0, 1).toUpperCase()) + w((ue = (te = t(r)) == null ? void 0 : te.lastName) == null ? void 0 : ue.slice(0, 1).toUpperCase()), 1)
          ]),
          a("div", Ca, [
            a("div", {
              ref_key: "editableDiv",
              ref: u,
              contenteditable: "",
              onKeydown: k,
              onInput: I,
              onBlur: B[0] || (B[0] = (G) => h.value = !1),
              class: "w-full h-full border pt-1 bg-transparent border-[#DEDEDE] text-black px-3 rounded-md focus:outline-0 relative",
              style: g(e.inputTextStyle)
            }, null, 36),
            h.value ? (l(), n("div", {
              key: 0,
              class: "absolute min-w-[50%] w-2/3 md:w-[40%] top-full bg-white text-black",
              onKeydown: _e(Ke(O, ["prevent"]), ["enter"])
            }, [
              $.value.length > 0 ? (l(), n("ul", {
                key: 0,
                class: "flex bg-white max-h-48 scrollable-list overflow-y-auto z-20 flex-col",
                ref_key: "suggestionList",
                ref: M
              }, [
                (l(!0), n(X, null, re($.value, (G, Y) => {
                  var P, z;
                  return l(), n("li", {
                    class: "cursor-pointer flex gap-2 px-3 z-100 items-center bg-white py-2 hover:bg-[#F6F8F9] border border-t border-[#ECF2F4] text-black pb-3 whitespace-nowrap",
                    key: G.userId,
                    onClick: (ye) => le(G),
                    onMousedown: B[1] || (B[1] = Ke(() => {
                    }, ["prevent"])),
                    onMouseover: (ye) => S.value = Y,
                    style: g(
                      S.value === Y ? { backgroundColor: "#F6F8F9" } : {}
                    )
                  }, [
                    a("div", Oa, [
                      a("span", qa, [
                        G != null && G.picture ? (l(), F(xe, {
                          key: 0,
                          "image-src": G == null ? void 0 : G.picture,
                          alt: "comment-img",
                          class: "rounded-full h-full object-cover z-1"
                        }, null, 8, ["image-src"])) : b("", !0),
                        a("span", ja, w((P = G == null ? void 0 : G.firstName) == null ? void 0 : P.slice(0, 1).toUpperCase()) + w((z = G == null ? void 0 : G.lastName) == null ? void 0 : z.slice(0, 1).toUpperCase()), 1)
                      ])
                    ]),
                    _(" " + w(G.firstName) + " " + w(G.lastName), 1)
                  ], 44, Ta);
                }), 128))
              ], 512)) : b("", !0),
              j.value ? (l(), n("ul", Ma, B[3] || (B[3] = [
                a("li", { class: "cursor-pointer px-3 py-2 hover:bg-[#F6F8F9] z-90 text-black pb-3 whitespace-nowrap" }, " No mentionUsers left to suggest. ", -1)
              ]))) : b("", !0)
            ], 40, $a)) : b("", !0)
          ])
        ])) : (l(), n("div", {
          key: 0,
          class: "col-span-2 mb-2 font-medium flex gap-4",
          style: g({
            backgroundColor: e.primaryButtonStyle.backgroundColor || "#F6F8F9"
          })
        }, B[2] || (B[2] = [
          a("span", { class: "p-4 text-black" }, " Your account has been blocked from commenting.", -1)
        ]), 4)),
        e.canComment ? (l(), n("div", Ia, [
          D(t(se), {
            onClick: N,
            "aria-label": e.cancelText,
            style: g(e.secondaryButtonStyle)
          }, {
            default: q(() => [
              _(w(e.cancelText), 1)
            ]),
            _: 1
          }, 8, ["aria-label", "style"]),
          D(t(se), {
            callback: Z,
            data: A.value,
            "aria-label": e.confirmText,
            style: g(e.primaryButtonStyle)
          }, {
            default: q(() => [
              _(w(e.confirmText), 1)
            ]),
            _: 1
          }, 8, ["data", "aria-label", "style"])
        ])) : b("", !0)
      ]);
    };
  }
}, Fa = { class: "j-comment-row grid grid-cols-2 mt-4" }, La = { class: "col-span-2 flex gap-1" }, Da = {
  class: "w-10 min-w-[40px] h-10 rounded-full text-white flex items-center justify-center relative",
  style: {
    backgroundColor: "#F1F1F3",
    borderRadius: "100%",
    fontSize: "14px",
    fontFamily: "Inter !important",
    lineHeight: "16px",
    color: "#868693",
    fontWeight: "600"
  }
}, Aa = { class: "absolute flex items-center justify-center" }, Ha = { class: "grid grid-rows gap-1 w-full ml-3" }, Ea = { class: "j-comment-content-row w-full flex justify-between" }, Na = { class: "flex" }, Wa = { class: "text-[#7483A1] text-xs" }, Ra = { class: "relative" }, za = ["id"], Va = { class: "flex flex-col" }, Ja = { class: "flex bg-white items-center" }, Pa = { class: "j-comment-content-row flex" }, Ua = ["innerHTML"], Ga = { class: "j-comment-content flex flex-col" }, Za = { key: 2 }, Ka = { key: 2 }, Xa = { key: 2 }, Qa = {
  key: 1,
  class: "j-comment-content-row flex"
}, Ya = { class: "text-[#3A3CFF]" }, _a = {
  key: 0,
  id: "delete-pop-up",
  class: "fixed top-0 left-0 right-0 transform-x-1/2 bg-[#04030633] flex flex-col h-full w-full items-center justify-center z-50"
}, eo = { key: 0 }, to = { key: 1 }, lo = { key: 2 }, ao = { key: 3 }, oo = { class: "flex justify-end gap-3" }, no = {
  __name: "JCommentRow",
  props: {
    data: {
      type: Object,
      required: !0
    },
    callback: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    postCommentCallback: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    deleteCommentCallback: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    cancelCommentCallback: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    showCommentInput: {
      type: Boolean,
      required: !1,
      default: !1
    },
    onCommentEngagementCallback: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    loadRepliesCallback: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    user: {
      type: Object,
      required: !1,
      default: {}
    },
    mentionUsers: {
      type: Array,
      required: !0
    },
    mentionEnabled: {
      type: Boolean,
      default: !0
    },
    cancelText: {
      type: String,
      default: "Cancel"
    },
    confirmText: {
      type: String,
      default: "Confirm"
    },
    replyText: {
      type: String,
      default: "Reply"
    },
    repliesText: {
      type: String,
      default: "REPLIES"
    },
    accountNameStyle: {
      type: Object,
      default: {}
    },
    commentStyle: {
      type: Object,
      default: {}
    },
    primaryButtonStyle: {
      type: Object,
      default: {}
    },
    secondaryButtonStyle: {
      type: Object,
      default: {}
    },
    engagementsStyle: {
      type: Object,
      default: {}
    },
    showLike: {
      type: Boolean,
      default: !0
    },
    showDislike: {
      type: Boolean,
      default: !0
    },
    showReply: {
      type: Boolean,
      default: !0
    },
    showLikeCount: {
      type: Boolean,
      default: !0
    },
    showLikeIcon: {
      type: Boolean,
      default: !0
    },
    showLikeText: {
      type: Boolean,
      default: !1
    },
    showDislikeCount: {
      type: Boolean,
      default: !0
    },
    showDislikeIcon: {
      type: Boolean,
      default: !0
    },
    showDislikeText: {
      type: Boolean,
      default: !1
    },
    showReplyCount: {
      type: Boolean,
      default: !0
    },
    showReplyIcon: {
      type: Boolean,
      default: !0
    },
    showReplyText: {
      type: Boolean,
      default: !0
    },
    likeIcon: {
      type: Object,
      default: {
        props: {
          name: "vpapps-font-thumbs-up-like"
        },
        style: {}
      }
    },
    dislikeIcon: {
      type: Object,
      default: {
        props: {
          name: "vpapps-font-thumbs-down-dislike"
        },
        style: {}
      }
    },
    replyIcon: {
      type: Object,
      default: {
        props: {
          name: "vpapps-font-reply"
        },
        style: {}
      }
    },
    dateFormat: {
      type: String,
      default: "en"
    },
    deleteText: {
      type: String,
      default: "Delete"
    }
  },
  setup(e) {
    Ie((P) => ({
      "1e225e81": L.value,
      "4edda60f": H.value,
      d1390702: V.value,
      e3f042e6: U.value,
      "0a218b84": te.value,
      "2e6cb98c": ue.value
    }));
    const i = e, {
      data: o,
      callback: c,
      postCommentCallback: s,
      deleteCommentCallback: r,
      onCommentEngagementCallback: y,
      mentionUsers: d,
      likeIcon: m,
      dislikeIcon: u,
      replyIcon: h,
      loadRepliesCallback: f,
      dateFormat: p,
      deleteText: v
    } = ae(i), S = C(!1), j = C(!1), $ = C(null), N = C(null), k = C(!1), M = C(o.value.showCommentInput), x = (P) => {
      T.isClickOutside(
        P,
        $
      ) && (S.value = !1), O.isClickOutside(P, N) && (j.value = !1);
    }, T = Fe(
      $,
      x
    ), O = Fe(N, x), E = (P) => {
      const z = /@\{(\w+)\}/g;
      return P.replace(z, (ye, ce) => {
        var ve, we;
        const de = d.value.find((Ce) => Ce.userId === ce);
        return de ? `<span style="color: ${(ve = i.commentStyle.colors) == null ? void 0 : ve.mentionedUser};">${de.firstName} ${de.lastName}</span>` : `<span style="color: ${(we = i.commentStyle.colors) == null ? void 0 : we.mentionedUser};">User Not Found</span>`;
      });
    }, I = (P) => {
      const z = new Date(P), ce = Math.floor((/* @__PURE__ */ new Date() - z) / (1e3 * 60 * 60 * 24)), de = Math.floor(ce / 30), ve = Math.floor(ce / 365);
      return ce < 30 ? new Intl.RelativeTimeFormat(`${p.value}`, {
        numeric: "auto"
      }).format(-ce, "day") : de < 12 ? new Intl.RelativeTimeFormat(`${p.value}`, {
        numeric: "auto"
      }).format(-de, "month") : new Intl.RelativeTimeFormat(`${p.value}`, {
        numeric: "auto"
      }).format(-ve, "year");
    }, A = (P, z) => {
      y && y.value && y.value(P, z);
    }, le = (P, z, ye) => {
      ye ? M.value = !0 : (k.value = !k.value, f && f.value && f.value(P, z));
    }, Z = () => {
      M.value = !1;
    }, W = () => {
      S.value = !1, j.value = !0;
    }, B = ({ id: P, parentId: z }) => {
      r && r.value && (j.value = !1, r.value(P, z));
    }, L = R(() => {
      var P, z;
      return (z = (P = m.value) == null ? void 0 : P.style) == null ? void 0 : z.colorOnHover;
    }), H = R(
      () => {
        var P, z;
        return (z = (P = m.value) == null ? void 0 : P.style) == null ? void 0 : z.backgroundColorOnHover;
      }
    ), V = R(
      () => {
        var P, z;
        return (z = (P = u.value) == null ? void 0 : P.style) == null ? void 0 : z.colorOnHover;
      }
    ), U = R(
      () => {
        var P, z;
        return (z = (P = u.value) == null ? void 0 : P.style) == null ? void 0 : z.backgroundColorOnHover;
      }
    ), te = R(() => {
      var P, z;
      return (z = (P = h.value) == null ? void 0 : P.style) == null ? void 0 : z.colorOnHover;
    }), ue = R(
      () => {
        var P, z;
        return (z = (P = h.value) == null ? void 0 : P.style) == null ? void 0 : z.backgroundColorOnHover;
      }
    ), G = R(() => {
      var z, ye, ce, de, ve, we, Ce, Te, Oe, ee, Q, ie;
      let P = {
        color: (ye = (z = m.value) == null ? void 0 : z.style) == null ? void 0 : ye.color,
        backgroundColor: (de = (ce = m.value) == null ? void 0 : ce.style) == null ? void 0 : de.backgroundColor
      };
      return o.value.isLiked && ((we = (ve = m.value) == null ? void 0 : ve.style) != null && we.colorOnActive && (P.color = (Te = (Ce = m.value) == null ? void 0 : Ce.style) == null ? void 0 : Te.colorOnActive), (ee = (Oe = m.value) == null ? void 0 : Oe.style) != null && ee.backgroundColorOnActive && (P.backgroundColor = (ie = (Q = m.value) == null ? void 0 : Q.style) == null ? void 0 : ie.backgroundColorOnActive)), P;
    }), Y = R(() => {
      var z, ye, ce, de, ve, we, Ce, Te, Oe, ee, Q, ie;
      let P = {
        color: (ye = (z = u.value) == null ? void 0 : z.style) == null ? void 0 : ye.color,
        backgroundColor: (de = (ce = u.value) == null ? void 0 : ce.style) == null ? void 0 : de.backgroundColor
      };
      return o.value.isDisliked && ((we = (ve = u.value) == null ? void 0 : ve.style) != null && we.colorOnActive && (P.color = (Te = (Ce = u.value) == null ? void 0 : Ce.style) == null ? void 0 : Te.colorOnActive), (ee = (Oe = u.value) == null ? void 0 : Oe.style) != null && ee.backgroundColorOnActive && (P.backgroundColor = (ie = (Q = u.value) == null ? void 0 : Q.style) == null ? void 0 : ie.backgroundColorOnActive)), P;
    });
    return (P, z) => {
      var ye, ce, de, ve, we, Ce, Te, Oe, ee, Q, ie;
      return l(), n(X, null, [
        a("div", Fa, [
          a("div", La, [
            a("span", Da, [
              (ye = t(o).author) != null && ye.picture ? (l(), F(xe, {
                key: 0,
                "image-src": (ce = t(o).author) == null ? void 0 : ce.picture,
                alt: "comment-img",
                class: "rounded-full h-full object-cover z-1"
              }, null, 8, ["image-src"])) : b("", !0),
              a("span", Aa, w((we = (ve = (de = t(o)) == null ? void 0 : de.author) == null ? void 0 : ve.firstName) == null ? void 0 : we.slice(0, 1).toUpperCase()) + w((Oe = (Te = (Ce = t(o)) == null ? void 0 : Ce.author) == null ? void 0 : Te.lastName) == null ? void 0 : Oe.slice(0, 1).toUpperCase()), 1)
            ]),
            a("div", Ha, [
              a("div", Ea, [
                a("div", Na, [
                  a("p", {
                    class: "mr-3",
                    style: g(e.accountNameStyle)
                  }, w((ee = t(o).author) == null ? void 0 : ee.firstName) + " " + w((Q = t(o).author) == null ? void 0 : Q.lastName), 5),
                  a("h5", Wa, w(I(t(o).createdAt)), 1)
                ]),
                a("div", Ra, [
                  (ie = t(o)) != null && ie.canDelete ? (l(), F(t(oe), {
                    key: 0,
                    onClick: z[0] || (z[0] = (pe) => S.value = !S.value),
                    ikoneName: "vpapps-font-three-dots-vertical"
                  })) : b("", !0),
                  fe(a("div", {
                    ref_key: "commentOptionsRef",
                    ref: $,
                    id: `comment-options-pop-up-${t(o).id}`,
                    class: "absolute top-4 left-auto right-1 -transform-x-1/2 shadow w-32 flex flex-col"
                  }, [
                    a("span", Va, [
                      a("span", Ja, [
                        D(se, {
                          callback: W,
                          data: t(o).id,
                          rounded: "",
                          class: "flex gap-2 whitespace-nowrap text-[#ff0000] px-2 justify-start! w-full pl-0",
                          "aria-label": t(v)
                        }, {
                          default: q(() => [
                            D(t(oe), { "ikone-name": "vpapps-font-delete-trash" }),
                            _(" " + w(t(v)), 1)
                          ]),
                          _: 1
                        }, 8, ["data", "aria-label"])
                      ])
                    ])
                  ], 8, za), [
                    [be, S.value]
                  ])
                ])
              ]),
              a("div", Pa, [
                a("p", {
                  class: "j-comment-text whitespace-break-spaces",
                  style: g(e.commentStyle),
                  innerHTML: E(t(o).text)
                }, null, 12, Ua)
              ]),
              a("div", Ga, [
                a("div", {
                  class: "j-comment-content-row flex",
                  style: g(e.engagementsStyle)
                }, [
                  e.showLike ? (l(), F(se, {
                    key: 0,
                    class: "flex gap-1",
                    "aria-label": "Like",
                    "text-color": e.engagementsStyle.color,
                    style: g({
                      fontSize: e.engagementsStyle.fontSize,
                      fontStyle: e.engagementsStyle.fontStyle,
                      fontWeight: e.engagementsStyle.fontWeight,
                      fontFamily: e.engagementsStyle.fontFamily
                    }),
                    onClick: z[1] || (z[1] = (pe) => A(1, t(o).id))
                  }, {
                    default: q(() => {
                      var pe, qe, je;
                      return [
                        e.showLikeIcon ? (l(), F(t(oe), {
                          key: 0,
                          "ikone-name": (qe = (pe = t(m)) == null ? void 0 : pe.props) == null ? void 0 : qe.name,
                          "ikone-style": {
                            ...(je = t(m)) == null ? void 0 : je.style,
                            color: G.value.color,
                            backgroundColor: G.value.backgroundColor
                          },
                          class: "like-icon-hover"
                        }, null, 8, ["ikone-name", "ikone-style"])) : b("", !0),
                        e.showLikeText ? (l(), n(X, { key: 1 }, [
                          _("Like")
                        ], 64)) : b("", !0),
                        e.showLikeCount && t(o).likeCount ? (l(), n("p", Za, " (" + w(t(o).likeCount) + ") ", 1)) : b("", !0)
                      ];
                    }),
                    _: 1
                  }, 8, ["text-color", "style"])) : b("", !0),
                  e.showDislike ? (l(), F(se, {
                    key: 1,
                    class: "flex gap-1",
                    "aria-label": "Dislike",
                    "text-color": e.engagementsStyle.color,
                    style: g({
                      fontSize: e.engagementsStyle.fontSize,
                      fontStyle: e.engagementsStyle.fontStyle,
                      fontWeight: e.engagementsStyle.fontWeight,
                      fontFamily: e.engagementsStyle.fontFamily
                    }),
                    onClick: z[2] || (z[2] = (pe) => A(2, t(o).id))
                  }, {
                    default: q(() => {
                      var pe, qe, je;
                      return [
                        e.showDislikeIcon ? (l(), F(t(oe), {
                          key: 0,
                          "ikone-name": (qe = (pe = t(u)) == null ? void 0 : pe.props) == null ? void 0 : qe.name,
                          "ikone-style": {
                            ...(je = t(u)) == null ? void 0 : je.style,
                            color: Y.value.color,
                            backgroundColor: Y.value.backgroundColor
                          },
                          class: "dislike-icon-hover"
                        }, null, 8, ["ikone-name", "ikone-style"])) : b("", !0),
                        e.showDislikeText ? (l(), n(X, { key: 1 }, [
                          _("Like")
                        ], 64)) : b("", !0),
                        e.showDislikeCount && t(o).dislikeCount ? (l(), n("p", Ka, " (" + w(t(o).dislikeCount) + ") ", 1)) : b("", !0)
                      ];
                    }),
                    _: 1
                  }, 8, ["text-color", "style"])) : b("", !0),
                  !t(o).parentId && e.showReply ? (l(), F(se, {
                    key: 2,
                    class: "flex gap-1",
                    "aria-label": "Reply",
                    "text-color": e.engagementsStyle.color,
                    style: g({
                      fontSize: e.engagementsStyle.fontSize,
                      fontStyle: e.engagementsStyle.fontStyle,
                      fontWeight: e.engagementsStyle.fontWeight,
                      fontFamily: e.engagementsStyle.fontFamily
                    }),
                    onClick: z[3] || (z[3] = (pe) => le(t(o).id, t(o).mediaId, !0))
                  }, {
                    default: q(() => {
                      var pe, qe, je;
                      return [
                        e.showReplyIcon ? (l(), F(t(oe), {
                          key: 0,
                          "ikone-name": (qe = (pe = t(h)) == null ? void 0 : pe.props) == null ? void 0 : qe.name,
                          "ikone-style": (je = t(h)) == null ? void 0 : je.style,
                          class: "reply-icon-hover"
                        }, null, 8, ["ikone-name", "ikone-style"])) : b("", !0),
                        e.showReplyText ? (l(), n(X, { key: 1 }, [
                          _(w(e.replyText), 1)
                        ], 64)) : b("", !0),
                        e.showReplyCount && t(o).replyCount ? (l(), n("p", Xa, " (" + w(t(o).replyCount) + ") ", 1)) : b("", !0)
                      ];
                    }),
                    _: 1
                  }, 8, ["text-color", "style"])) : b("", !0)
                ], 4),
                M.value ? (l(), F(Ba, {
                  key: 0,
                  parentId: t(o).id,
                  callback: t(s),
                  user: e.user,
                  cancelCommentCallback: Z,
                  "mention-users": t(d),
                  "mention-enabled": e.mentionEnabled,
                  "cancel-text": e.cancelText,
                  "confirm-text": e.confirmText,
                  "primary-button-style": e.primaryButtonStyle,
                  "secondary-button-style": e.secondaryButtonStyle
                }, null, 8, ["parentId", "callback", "user", "mention-users", "mention-enabled", "cancel-text", "confirm-text", "primary-button-style", "secondary-button-style"])) : b("", !0),
                a("div", null, [
                  k.value === !0 ? K(P.$slots, "replies", { key: 0 }, void 0, !0) : b("", !0),
                  K(P.$slots, "repliesLoader", {}, void 0, !0)
                ]),
                t(o).repliesCount !== 0 ? (l(), n("div", Qa, [
                  D(se, {
                    onClick: z[4] || (z[4] = (pe) => le(t(o).id, t(o).mediaId, !1)),
                    class: "md:text-[13px] text-xs flex gap-2",
                    textColor: "#000000",
                    "aria-label": "Replies"
                  }, {
                    default: q(() => [
                      (l(), n("svg", {
                        width: "8",
                        height: "5",
                        viewBox: "0 0 8 5",
                        fill: "none",
                        class: J(k.value ? "rotate-180" : ""),
                        xmlns: "http://www.w3.org/2000/svg"
                      }, z[6] || (z[6] = [
                        a("path", {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M0.602252 0.203937C0.821922 -0.0157329 1.17808 -0.0157329 1.39775 0.203937L4 2.80619L6.60225 0.203937C6.82192 -0.0157329 7.17808 -0.0157329 7.39775 0.203937C7.61742 0.423607 7.61742 0.779762 7.39775 0.999432L4.66291 3.73427C4.2968 4.10038 3.7032 4.10038 3.33709 3.73427L0.602252 0.999432C0.382583 0.779762 0.382583 0.423607 0.602252 0.203937Z",
                          fill: "#3A3CFF"
                        }, null, -1)
                      ]), 2)),
                      a("p", Ya, w(e.repliesText), 1)
                    ]),
                    _: 1
                  })
                ])) : b("", !0)
              ])
            ])
          ])
        ]),
        (l(), F(ot, { to: "body" }, [
          j.value ? (l(), n("div", _a, [
            a("div", {
              ref_key: "deleteModalRef",
              ref: N,
              class: "flex flex-col text-center w-11/12 sm:w-3/4 md:w-2/3 lg:w-1/3 bg-[#FFFFFF] p-6 gap-8 text-[#36435E] rounded-md"
            }, [
              t(p) !== "en" ? (l(), n("p", eo, "Smazat komentář")) : (l(), n("p", to, "Delete Comment")),
              t(p) !== "en" ? (l(), n("span", lo, z[7] || (z[7] = [
                a("p", null, "Jste si jisti, že chcete smazat tento komentář?", -1),
                a("p", { class: "text-[#6E7B95]" }, "Tuto akci nebude možné vrátit zpět.", -1)
              ]))) : (l(), n("span", ao, z[8] || (z[8] = [
                a("p", null, "Are you sure you want to delete this comment?", -1),
                a("p", { class: "text-[#6E7B95]" }, "This action cannot be undone", -1)
              ]))),
              a("div", oo, [
                D(se, {
                  onClick: z[5] || (z[5] = (pe) => j.value = !1),
                  rounded: "",
                  full: "",
                  class: "flex gap-2 whitespace-nowrap font-normal",
                  border: "1px solid #E2E2E2",
                  textColor: "#646464",
                  "aria-label": e.cancelText
                }, {
                  default: q(() => [
                    _(w(e.cancelText), 1)
                  ]),
                  _: 1
                }, 8, ["aria-label"]),
                D(se, {
                  callback: B,
                  data: t(o),
                  rounded: "",
                  full: "",
                  class: "flex gap-2 whitespace-nowrap text-[#ff0000] font-normal",
                  background: "#E34850",
                  "text-color": "#fff",
                  "aria-label": t(v)
                }, {
                  default: q(() => [
                    _(w(t(v)), 1)
                  ]),
                  _: 1
                }, 8, ["data", "aria-label"])
              ])
            ], 512)
          ])) : b("", !0)
        ]))
      ], 64);
    };
  }
}, mt = /* @__PURE__ */ ne(no, [["__scopeId", "data-v-c643d0b4"]]), so = { class: "relative h-full w-full flex flex-col" }, ro = { class: "col-span-1 flex justify-start" }, io = { class: "col-span-1 flex justify-end" }, uo = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 18 18",
  fill: "#9f9f9f",
  xmlns: "http://www.w3.org/2000/svg",
  class: "cursor-pointer col-span-1"
}, co = { class: "border-l border-[#6E7B95] border-solid pl-5" }, fo = { id: "load-more-comments" }, Fi = {
  __name: "JComments",
  props: {
    data: {
      type: [Object, Array],
      required: !0
    },
    loadMoreCommentsCallback: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    postCommentCallback: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    loadRepliesCallback: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    deleteCommentCallback: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    onCommentEngagementCallback: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    user: {
      type: Object,
      required: !1,
      default: {}
    },
    breakpoint: {
      type: String,
      default: "desktop"
    },
    screenOrientation: {
      type: String,
      default: "natural"
    },
    cancelCommentCallback: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    mentionEnabled: {
      type: Boolean,
      default: !0
    },
    mentionUsers: {
      type: Array,
      required: !0
    },
    commentsText: {
      type: String,
      default: "Comments"
    },
    cancelText: {
      type: String,
      default: "Cancel"
    },
    confirmText: {
      type: String,
      default: "Confirm"
    },
    replyText: {
      type: String,
      default: "Reply"
    },
    repliesText: {
      type: String,
      default: "REPLIES"
    },
    style: {
      type: Object,
      default: {}
    },
    titleStyle: {
      type: Object,
      default: {}
    },
    titleWrapperStyle: {
      type: Object,
      default: {}
    },
    accountNameStyle: {
      type: Object,
      default: {}
    },
    commentStyle: {
      type: Object,
      default: {}
    },
    engagementsStyle: {
      type: Object,
      default: {}
    },
    primaryButtonStyle: {
      type: Object,
      default: {}
    },
    secondaryButtonStyle: {
      type: Object,
      default: {}
    },
    showLike: {
      type: Boolean,
      default: !0
    },
    showDislike: {
      type: Boolean,
      default: !0
    },
    showReply: {
      type: Boolean,
      default: !0
    },
    showLikeCount: {
      type: Boolean,
      default: !0
    },
    showLikeIcon: {
      type: Boolean,
      default: !0
    },
    showLikeText: {
      type: Boolean,
      default: !1
    },
    showDislikeCount: {
      type: Boolean,
      default: !0
    },
    showDislikeIcon: {
      type: Boolean,
      default: !0
    },
    showDislikeText: {
      type: Boolean,
      default: !1
    },
    showReplyCount: {
      type: Boolean,
      default: !0
    },
    showReplyIcon: {
      type: Boolean,
      default: !0
    },
    showReplyText: {
      type: Boolean,
      default: !0
    },
    likeIcon: {
      type: [Object, null],
      default: null
    },
    dislikeIcon: {
      type: [Object, null],
      default: null
    },
    replyIcon: {
      type: [Object, null],
      default: null
    },
    escapeHeight: {
      type: Number,
      default: 60
    },
    dateFormat: {
      type: String,
      default: "en"
    },
    deleteText: {
      type: String,
      default: "Delete"
    }
  },
  setup(e) {
    Ie((j) => ({
      dae72660: S.value
    }));
    const i = e, {
      data: o,
      loadMoreCommentsCallback: c,
      postCommentCallback: s,
      deleteCommentCallback: r,
      onCommentEngagementCallback: y,
      user: d,
      breakpoint: m,
      screenOrientation: u,
      loadRepliesCallback: h
    } = ae(i), f = C(!1), p = R(() => m.value === "mobile" || m.value === "tablet");
    jt(u, (j) => {
      j.includes("landscape") && p.value && f.value && v(!1);
    });
    function v(j) {
      f.value = j;
      const $ = document.querySelector(".j-header"), N = document.querySelector(".j-comments"), k = document.querySelector("body");
      if (j) {
        if ($) {
          const M = $ == null ? void 0 : $.offsetHeight;
          N.style.top = `calc(56.25vw + ${M}px)`;
        }
        window.scrollTo(0, 0), k.style.overflow = "hidden";
      } else
        k.style.overflow = "";
    }
    const S = R(() => `${i.escapeHeight}px`);
    return ke(() => {
      Le(() => {
        const j = document.querySelector("#load-more-comments");
        Be(j, c.value);
      });
    }), (j, $) => (l(), n("div", {
      class: J(["j-comments", {
        "fixed-comments bg-white overflow-y-hidden fixed left-0 right-0 bottom-0 z-20  shadow-[0_-6px_16px_rgba(163,176,194,0.32)] rounded-t m-0!": p.value && f.value,
        "": p.value && !f.value,
        hidden: p.value && t(u).includes("landscape")
      }]),
      style: g(e.style)
    }, [
      a("div", so, [
        a("div", {
          class: J(["grid grid-cols-2 w-full z-10 comments-header", {
            "mb-0": p.value && !f.value,
            "px-2 border-b border-b-[#E0E5EB]": p.value
          }]),
          style: g(e.titleWrapperStyle),
          onClick: $[1] || ($[1] = (N) => p.value && v(!0))
        }, [
          a("div", ro, [
            a("p", {
              class: "my-auto",
              style: g(e.titleStyle)
            }, w(e.commentsText), 5)
          ]),
          a("div", io, [
            p.value && !f.value ? (l(), n("svg", uo, $[2] || ($[2] = [
              a("path", {
                d: "M6.60225 4.37523C6.82192 4.5949 7.17808 4.5949 7.39775 4.37523C7.61742 4.15556 7.61742 3.79941 7.39775 3.57974L4.66291 0.8449C4.2968 0.478783 3.7032 0.478784 3.33709 0.8449L0.602252 3.57974C0.382583 3.79941 0.382583 4.15556 0.602252 4.37523C0.821922 4.5949 1.17808 4.5949 1.39775 4.37523L4 1.77298L6.60225 4.37523Z",
                fill: "#7483A1"
              }, null, -1),
              a("path", {
                d: "M6.60225 8.07974C6.82192 7.86007 7.17808 7.86007 7.39775 8.07974C7.61742 8.29941 7.61742 8.65556 7.39775 8.87523L4.66291 11.6101C4.29679 11.9762 3.7032 11.9762 3.33709 11.6101L0.602252 8.87523C0.382583 8.65556 0.382583 8.29941 0.602252 8.07974C0.821922 7.86006 1.17808 7.86006 1.39775 8.07974L4 10.682L6.60225 8.07974Z",
                fill: "#7483A1"
              }, null, -1)
            ]))) : b("", !0),
            p.value && f.value ? (l(), F(t(oe), {
              key: 1,
              onClick: $[0] || ($[0] = Ke((N) => v(!1), ["stop"])),
              "ikone-name": "vpapps-font-close-cancel"
            })) : b("", !0)
          ])
        ], 6),
        fe(a("div", {
          class: J(["flex flex-col", {
            "overflow-y-auto h-11/12 p-3 pt-5! mt-px": p.value && f.value,
            "": p.value && !f.value
          }])
        }, [
          K(j.$slots, "commentInput"),
          t(o).data && (!p.value || p.value && f.value) ? (l(!0), n(X, { key: 0 }, re(t(o).data, (N) => (l(), F(mt, {
            key: N.id,
            data: N,
            postCommentCallback: t(s),
            deleteCommentCallback: t(r),
            cancelCommentCallback: e.cancelCommentCallback,
            onCommentEngagementCallback: t(y),
            user: t(d),
            "mention-users": e.mentionUsers,
            "mention-enabled": e.mentionEnabled,
            cancelText: e.cancelText,
            confirmText: e.confirmText,
            replyText: e.replyText,
            repliesText: e.repliesText,
            "account-name-style": e.accountNameStyle,
            "comment-style": e.commentStyle,
            "engagements-style": e.engagementsStyle,
            "primary-button-style": e.primaryButtonStyle,
            "secondary-button-style": e.secondaryButtonStyle,
            "show-like": e.showLike,
            "show-dislike": e.showDislike,
            "show-reply": e.showReply,
            "show-like-count": e.showLikeCount,
            "show-like-icon": e.showLikeIcon,
            "show-like-text": e.showLikeText,
            "show-dislike-count": e.showDislikeCount,
            "show-dislike-icon": e.showDislikeIcon,
            "show-dislike-text": e.showDislikeText,
            "show-reply-count": e.showReplyCount,
            "show-reply-icon": e.showReplyIcon,
            "show-reply-text": e.showReplyText,
            "like-icon": e.likeIcon,
            "dislike-icon": e.dislikeIcon,
            "reply-icon": e.replyIcon,
            loadRepliesCallback: t(h),
            "date-format": e.dateFormat,
            "delete-text": e.deleteText
          }, {
            replies: q(() => [
              a("div", co, [
                (l(!0), n(X, null, re(N.replies, (k) => (l(), F(mt, {
                  key: k.id,
                  data: k,
                  user: t(d),
                  postCommentCallback: t(s),
                  deleteCommentCallback: t(r),
                  cancelCommentCallback: e.cancelCommentCallback,
                  onCommentEngagementCallback: t(y),
                  "mention-users": e.mentionUsers,
                  "mention-enabled": e.mentionEnabled,
                  cancelText: e.cancelText,
                  confirmText: e.confirmText,
                  replyText: e.replyText,
                  repliesText: e.repliesText,
                  "account-name-style": e.accountNameStyle,
                  "comment-style": e.commentStyle,
                  "engagements-style": e.engagementsStyle,
                  "primary-button-style": e.primaryButtonStyle,
                  "secondary-button-style": e.secondaryButtonStyle,
                  "show-like": e.showLike,
                  "show-dislike": e.showDislike,
                  "show-reply": e.showReply,
                  "show-like-count": e.showLikeCount,
                  "show-like-icon": e.showLikeIcon,
                  "show-like-text": e.showLikeText,
                  "show-dislike-count": e.showDislikeCount,
                  "show-dislike-icon": e.showDislikeIcon,
                  "show-dislike-text": e.showDislikeText,
                  "show-reply-count": e.showReplyCount,
                  "show-reply-icon": e.showReplyIcon,
                  "show-reply-text": e.showReplyText,
                  "like-icon": e.likeIcon,
                  "dislike-icon": e.dislikeIcon,
                  "reply-icon": e.replyIcon,
                  loadRepliesCallback: t(h),
                  "date-format": e.dateFormat,
                  "delete-text": e.deleteText
                }, null, 8, ["data", "user", "postCommentCallback", "deleteCommentCallback", "cancelCommentCallback", "onCommentEngagementCallback", "mention-users", "mention-enabled", "cancelText", "confirmText", "replyText", "repliesText", "account-name-style", "comment-style", "engagements-style", "primary-button-style", "secondary-button-style", "show-like", "show-dislike", "show-reply", "show-like-count", "show-like-icon", "show-like-text", "show-dislike-count", "show-dislike-icon", "show-dislike-text", "show-reply-count", "show-reply-icon", "show-reply-text", "like-icon", "dislike-icon", "reply-icon", "loadRepliesCallback", "date-format", "delete-text"]))), 128))
              ])
            ]),
            _: 2
          }, 1032, ["data", "postCommentCallback", "deleteCommentCallback", "cancelCommentCallback", "onCommentEngagementCallback", "user", "mention-users", "mention-enabled", "cancelText", "confirmText", "replyText", "repliesText", "account-name-style", "comment-style", "engagements-style", "primary-button-style", "secondary-button-style", "show-like", "show-dislike", "show-reply", "show-like-count", "show-like-icon", "show-like-text", "show-dislike-count", "show-dislike-icon", "show-dislike-text", "show-reply-count", "show-reply-icon", "show-reply-text", "like-icon", "dislike-icon", "reply-icon", "loadRepliesCallback", "date-format", "delete-text"]))), 128)) : b("", !0),
          fe(a("div", fo, null, 512), [
            [be, p.value ? p.value && f.value : !0]
          ])
        ], 2), [
          [be, p.value ? p.value && f.value : !0]
        ])
      ])
    ], 6));
  }
}, yo = "…";
function po(e, i, o) {
  e.style.cssText += "overflow:hidden;overflow-wrap:break-word;word-wrap:break-word";
  const c = i * parseInt(window.getComputedStyle(e).lineHeight, 10);
  return e.scrollHeight <= c ? !1 : St(
    e,
    e,
    c,
    yo
  );
}
function St(e, i, o, c) {
  const s = e.childNodes;
  let r = s.length - 1;
  for (; r > -1; ) {
    const y = s[r--];
    if (y.nodeType === 1 && St(
      y,
      i,
      o,
      c
    ) || y.nodeType === 3 && mo(
      y,
      i,
      o,
      c
    ))
      return !0;
    e.removeChild(y);
  }
  return !1;
}
function mo(e, i, o, c) {
  let s, r = e.textContent;
  for (; r.length > 1 && (s = r.lastIndexOf(" "), s !== -1); ) {
    if (e.textContent = r.substring(0, s), i.scrollHeight <= o) {
      e.textContent = r;
      break;
    }
    r = e.textContent;
  }
  return go(
    e,
    i,
    o,
    c
  );
}
const vo = /[ .,;!?'‘’“”\-–—]+$/;
function go(e, i, o, c) {
  let s = e.textContent, r = s.length;
  for (; r > 1; )
    if (s = s.substring(0, r - 1).replace(vo, ""), r = s.length, e.textContent = s + c, i.scrollHeight <= o)
      return !0;
  return !1;
}
const ho = { class: "j-details-title mb-2 w-full border-b border-gray-200 pb-3" }, bo = {
  key: 1,
  class: "flex flex-col"
}, wo = ["innerHTML"], xo = {
  __name: "JContentDetailsDescription",
  props: {
    title: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      required: !1,
      default: null
    },
    titleStyle: {
      type: Object,
      default: {}
    },
    descriptionStyle: {
      type: Object,
      default: {}
    },
    showTitle: {
      type: Boolean,
      default: !0
    },
    showDescription: {
      type: Boolean,
      default: !0
    },
    showMoreText: {
      type: String,
      required: !1,
      default: "Zobrazit více"
    },
    showLessText: {
      type: String,
      required: !1,
      default: "Zobrazit méně"
    }
  },
  setup(e) {
    const i = e, o = C(!1), c = C(!1), { description: s } = ae(i);
    function r(y) {
      const d = document.querySelector("#j-details-description");
      if (y) d.innerHTML = s.value;
      else return po(d, 3);
    }
    return ke(() => {
      setTimeout(() => {
        o.value = r(c.value);
      }, 800);
    }), (y, d) => (l(), n("div", ho, [
      e.showTitle ? (l(), n("h1", {
        key: 0,
        style: g(e.titleStyle)
      }, w(e.title), 5)) : b("", !0),
      e.showDescription ? (l(), n("div", bo, [
        a("div", {
          id: "j-details-description",
          class: "whitespace-pre-wrap ql-editor p-0!",
          innerHTML: t(s),
          style: g(e.descriptionStyle)
        }, null, 12, wo),
        o.value ? (l(), F(t(se), {
          key: 0,
          textColor: e.descriptionStyle.color,
          class: "shrink px-0 show-more-description text-left",
          style: g({ fontSize: e.descriptionStyle.fontSize }),
          "aria-label": c.value ? e.showLessText : e.showMoreText,
          onClick: d[0] || (d[0] = () => {
            c.value = !c.value, r(c.value);
          })
        }, {
          default: q(() => [
            _(w(c.value ? e.showLessText : e.showMoreText), 1)
          ]),
          _: 1
        }, 8, ["textColor", "style", "aria-label"])) : b("", !0)
      ])) : b("", !0)
    ]));
  }
}, ko = /* @__PURE__ */ ne(xo, [["__scopeId", "data-v-152b13cb"]]), So = {
  key: 0,
  id: "share-pop-up",
  class: "fixed top-0 left-0 right-0 transform-x-1/2 bg-[#04030633] flex flex-col h-full w-full items-center justify-center z-50"
}, Co = { class: "flex justify-between mb-2" }, $o = { class: "text-xl flex text-[#000000] font-extrabold" }, To = { class: "flex flex-col border-b border-b-[#EAEAEA] pb-4 mb-4" }, Oo = { class: "flex gap-2 py-2 mb-6" }, qo = { class: "mb-6" }, jo = { class: "bg-[#F5F5F5] p-3 rounded flex gap-4" }, Mo = {
  key: 0,
  class: "flex flex-col"
}, Io = { class: "flex bg-white items-center justify-between p-3 mt-5 mb-2 border border-secondary rounded-md transition-all duration-50 ease-in" }, Bo = { class: "text-[#646464] max-w-md grow flex-1 truncate" }, Fo = { class: "flex gap-3" }, Lo = { class: "flex gap-3" }, Do = { class: "flex gap-3" }, Ao = {
  key: 1,
  class: "flex flex-col"
}, Ho = { class: "flex bg-white items-center justify-between p-3 mt-5 border border-secondary rounded-md transition-all duration-50 ease-in" }, Eo = { class: "text-[#646464] max-w-md grow flex-1 truncate" }, No = { class: "text-base flex text-[#000000] font-bold mb-1" }, Wo = { class: "flex bg-white items-center justify-between p-3 border border-secondary rounded-md transition-all duration-50 ease-in" }, Ro = { class: "text-[#646464] max-w-md grow flex-1 truncate" }, zo = {
  key: 0,
  class: "flex gap-3"
}, Vo = { class: "text-black" }, Jo = { class: "text-[#8E8E8E] px-2" }, Po = {
  __name: "JContentDetailsShareModal",
  props: {
    callback: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    origin: {
      type: String,
      required: !1,
      default: ""
    },
    pathname: {
      type: String,
      required: !1,
      default: ""
    },
    shareText: {
      type: String,
      default: "Share"
    },
    videoUrl: {
      type: String,
      required: !1,
      default: ""
    },
    videoUrlEmbed: {
      type: String,
      required: !1,
      default: ""
    },
    title: {
      type: String,
      required: !0
    },
    date: {
      type: [String],
      required: !1,
      default: "25/02/2022"
    },
    duration: {
      type: [String, Number],
      required: !1,
      default: 0
    },
    img: {
      type: [String],
      required: !1,
      default: "https://cdn.vpapps.cloud/default-video-card.png"
    },
    includeSeo: {
      type: Boolean,
      required: !1,
      default: !1
    },
    autoplay: {
      type: Boolean,
      required: !1,
      default: !0
    },
    autoplayMobile: {
      type: Boolean,
      required: !1,
      default: !1
    },
    muted: {
      type: Boolean,
      required: !1,
      default: !0
    },
    shareIcon: {
      type: Object,
      default: {
        props: {
          name: "vpapps-font-share"
        },
        style: {}
      }
    },
    embedScript: {
      type: String,
      required: !1,
      default: "javascript"
    },
    copyText: {
      type: String,
      default: "Copy"
    },
    linkText: {
      type: String,
      default: "Copy"
    },
    videoStartTimeText: {
      type: String,
      default: "Video start time"
    },
    showMoreText: {
      type: String,
      required: !1,
      default: "Zobrazit více"
    },
    showLessText: {
      type: String,
      required: !1,
      default: "Zobrazit méně"
    },
    share: {
      type: Boolean,
      default: !1
    },
    isVerticalPlayer: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["closeShareModal"],
  setup(e, { emit: i }) {
    const o = e, {
      shareText: c,
      videoUrl: s,
      videoUrlEmbed: r,
      title: y,
      date: d,
      duration: m,
      img: u,
      shareIcon: h,
      copyText: f,
      linkText: p,
      videoStartTimeText: v,
      showMoreText: S,
      showLessText: j,
      share: $
    } = ae(o), N = C(null), k = C(!1), M = i, x = C(0), T = C("javascript"), O = C(!1), E = C(!0), I = C(!1), A = C(!0), le = [
      {
        id: "0",
        name: "Facebook",
        icon: "https://cdn.vpapps.cloud/social-medias/embed.svg",
        url: (G) => !0
      },
      {
        id: "1",
        name: "Facebook",
        icon: "https://cdn.vpapps.cloud/social-medias/facebook.svg",
        url: (G) => `https://www.facebook.com/dialog/share?href=${G}&client_id=461693840960966 `
      },
      {
        id: "2",
        name: "Messenger",
        icon: "https://cdn.vpapps.cloud/social-medias/messenger.svg",
        url: (G) => `http://www.facebook.com/dialog/send?link=${G}&redirect_uri=${G}&app_id=461693840960966 `
      },
      {
        id: "4",
        name: "Twitter",
        icon: "https://cdn.vpapps.cloud/social-medias/twitter.svg",
        url: (G) => `https://twitter.com/intent/tweet?url=${G}`
      }
    ], W = Fe(N, (G) => {
      W.isClickOutside(G, N) && M("closeShareModal");
    }), B = (G) => G.includes("?") ? "&" : "?", L = R(() => {
      const G = B(r.value);
      return `<div style="padding-top:56.25%; position:relative; width:100%;">
    ${O.value ? V.value : ""}
    <iframe
      class="no-margin"
      style="position:absolute; left:0; top:0; width: 100%; height:100%;"
      src="${r.value}${G}autoplay=${!E.value}&am=${I.value}&muted=${A.value}"
      frameborder="0"
      allow="autoplay"
      Allowfullscreen
    >
    </iframe>
  </div>`;
    }), H = R(() => {
      const G = B(r.value);
      return `<script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "VideoObject",
      "name": "${y.value}",
      "duration": "PT${m.value}S",
      "thumbnailUrl": "${u.value}",
      "uploadDate": "${d.value}",
      "contentUrl": "${r.value}${G}autoplay=${E.value}&am=${I.value}&muted=${A.value}"
    }
    <\/script>
  <div
    class="vp-embed-wrapper"
    data-upload="${d.value}"
    data-name="${y.value}"
    data-duration="PT${m.value}S"
    data-thumbnail="${u.value}"
    data-url="${r.value}${G}autoplay=${E.value}&am=${I.value}&muted=${A.value}">
    <div class="vp-embed" style="position: relative; overflow: hidden; padding-bottom: 56.25%"></div>
    <script
      id="JEmbed"
      type="text/javascript"
      src="https://cdn.vpapps.cloud/embed.js"><\/script>
  </div>`;
    }), V = R(() => `<meta itemprop='${d.value}' content='${d.value}' />
    <meta itemprop='${y.value}' />
    <meta itemprop='PT${m.value}S' content='PT${m.value}S' />
    <meta itemprop='${u.value}' content='${u.value}' />
    <meta itemprop='${r.value}${B(
      r.value
    )}autoplay=${E.value}&am=${I.value}&muted=${A.value}' content='${r.value}${B(
      r.value
    )}autoplay=${E.value}&am=${I.value}&muted=${A.value}' />`);
    async function U(G, Y) {
      const P = G.target.parentElement;
      try {
        await navigator.clipboard.writeText(Y), P.classList.add(
          "ring-1",
          "ring-offset-0",
          "ring-blue-500",
          "bg-blue-300/25"
        ), setTimeout(() => {
          P.classList.remove(
            "ring-1",
            "ring-offset-0",
            "ring-blue-500",
            "bg-blue-300/25"
          );
        }, 1e3);
      } catch (z) {
        console.error("Failed to copy: ", z);
      }
    }
    function te(G) {
      var Y;
      x.value = G.target.checked && typeof vpPlayer == "function" ? Math.floor((Y = vpPlayer()) == null ? void 0 : Y.getPosition()) : 0;
    }
    const ue = R(() => {
      const { value: G } = x;
      return G < 60 ? `00:${G < 10 ? "0" + G : G}` : G < 60 * 60 ? `${parseInt(G / 60) < 10 ? "0" + parseInt(G / 60) : parseInt(G / 60)}:${parseInt(G % 60, 10) < 10 ? "0" + parseInt(G % 60, 10) : parseInt(G % 60, 10)}` : `${parseInt(G / 60 / 60, 10)}:${parseInt(
        G / 60 % 60,
        10
      )}:${parseInt(G % 60, 10)}`;
    });
    return (G, Y) => (l(), F(ot, { to: "body" }, [
      t($) ? (l(), n("div", So, [
        a("div", {
          ref_key: "shareModalRef",
          ref: N,
          class: "flex flex-col w-11/12 sm:w-3/4 md:w-2/3 lg:w-1/3 bg-[#FFFFFF] rounded-md p-6"
        }, [
          a("span", Co, [
            a("p", $o, w(t(c)), 1),
            (l(), n("svg", {
              onClick: Y[0] || (Y[0] = (P) => M("closeShareModal")),
              width: "24",
              height: "24",
              viewBox: "0 0 18 18",
              fill: "#9f9f9f",
              xmlns: "http://www.w3.org/2000/svg",
              class: "cursor-pointer"
            }, Y[10] || (Y[10] = [
              a("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M6.793 17.207a.6.6 0 00.849 0l9.565-9.565a.6.6 0 00-.849-.849l-9.565 9.565a.6.6 0 000 .849z"
              }, null, -1),
              a("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M17.207 17.207a.6.6 0 01-.849 0L6.793 7.642a.6.6 0 01.849-.849l9.565 9.565a.6.6 0 010 .849z"
              }, null, -1)
            ])))
          ]),
          a("span", To, [
            a("div", Oo, [
              (l(), n(X, null, re(le, ({ icon: P, name: z, id: ye, url: ce }) => (l(), n(X, { key: ye }, [
                ye > 0 ? (l(), F(t(et), {
                  key: 0,
                  imageSrc: P,
                  "external-link-to": ce(t(s), t(y)),
                  alt: z,
                  "custom-wrapper": "a",
                  "image-style": {
                    height: "40px",
                    width: "40px",
                    borderRadius: "4px"
                  }
                }, null, 8, ["imageSrc", "external-link-to", "alt"])) : (l(), F(t(et), {
                  key: 1,
                  imageSrc: P,
                  onClick: Y[1] || (Y[1] = (de) => k.value = !0),
                  alt: z,
                  "custom-wrapper": "a",
                  class: "cursor-pointer",
                  "image-style": {
                    height: "40px",
                    width: "40px",
                    borderRadius: "4px"
                  }
                }, null, 8, ["imageSrc", "alt"]))
              ], 64))), 64))
            ]),
            fe(a("span", qo, [
              a("span", jo, [
                D(t(se), {
                  onClick: Y[2] || (Y[2] = (P) => T.value = "javascript"),
                  rounded: "",
                  class: "flex md:text-md gap-2 whitespace-nowrap text-[#646464] shrink px-3 w-full",
                  style: g({
                    background: T.value == "javascript" ? "#FFFFFF" : "#FFFFFF00",
                    fontWeight: 400
                  }),
                  "aria-label": "Javascript embed"
                }, {
                  default: q(() => Y[11] || (Y[11] = [
                    _(" JavaScript ")
                  ])),
                  _: 1,
                  __: [11]
                }, 8, ["style"]),
                D(t(se), {
                  onClick: Y[3] || (Y[3] = (P) => T.value = "iframe"),
                  rounded: "",
                  class: "flex md:text-md gap-2 whitespace-nowrap text-[#646464] shrink px-3 w-full",
                  style: g({
                    background: T.value == "iframe" ? "#FFFFFF" : "#FFFFFF00",
                    fontWeight: 400
                  }),
                  "aria-label": "iFrame embed"
                }, {
                  default: q(() => Y[12] || (Y[12] = [
                    _(" iFrame ")
                  ])),
                  _: 1,
                  __: [12]
                }, 8, ["style"])
              ]),
              _(" " + w(T.value) + " ", 1),
              T.value == "iframe" ? (l(), n("span", Mo, [
                a("span", Io, [
                  a("p", Bo, w(L.value), 1),
                  D(t(se), {
                    onClick: Y[4] || (Y[4] = (P) => U(P, L.value)),
                    rounded: "",
                    class: "flex md:text-md gap-2 whitespace-nowrap text-[#ffffff] shrink px-3",
                    style: {
                      background: "#3A3CFF",
                      fontWeight: 400
                    },
                    "aria-label": "Copy iframe embed"
                  }, {
                    default: q(() => [
                      _(w(t(f)), 1)
                    ]),
                    _: 1
                  })
                ]),
                a("span", Fo, [
                  fe(a("input", {
                    "onUpdate:modelValue": Y[5] || (Y[5] = (P) => O.value = P),
                    type: "checkbox",
                    name: "includeSeo",
                    id: "includeSeo"
                  }, null, 512), [
                    [Ne, O.value]
                  ]),
                  Y[13] || (Y[13] = a("p", { class: "text-black" }, "Zahrnout SEO", -1))
                ]),
                a("span", Lo, [
                  fe(a("input", {
                    "onUpdate:modelValue": Y[6] || (Y[6] = (P) => E.value = P),
                    type: "checkbox",
                    name: "autoplay",
                    id: "autoplay"
                  }, null, 512), [
                    [Ne, E.value]
                  ]),
                  Y[14] || (Y[14] = a("p", { class: "text-black" }, "Vypnout autoplay", -1))
                ]),
                a("span", Do, [
                  fe(a("input", {
                    "onUpdate:modelValue": Y[7] || (Y[7] = (P) => I.value = P),
                    type: "checkbox",
                    name: "autoplayMobile",
                    id: "autoplayMobile"
                  }, null, 512), [
                    [Ne, I.value]
                  ]),
                  Y[15] || (Y[15] = a("p", { class: "text-black" }, "Zapnout autoplay na mobilním webu", -1))
                ])
              ])) : b("", !0),
              T.value == "javascript" ? (l(), n("span", Ao, [
                a("span", Ho, [
                  a("p", Eo, w(H.value), 1),
                  D(t(se), {
                    onClick: Y[8] || (Y[8] = (P) => U(P, H.value)),
                    rounded: "",
                    class: "flex md:text-md gap-2 whitespace-nowrap text-[#ffffff] shrink px-3",
                    style: {
                      background: "#3A3CFF",
                      fontWeight: 400
                    },
                    "aria-label": "Copy javascript embed"
                  }, {
                    default: q(() => [
                      _(w(t(f)), 1)
                    ]),
                    _: 1
                  })
                ])
              ])) : b("", !0)
            ], 512), [
              [be, k.value]
            ]),
            a("p", No, w(t(p)), 1),
            a("span", Wo, [
              a("p", Ro, w(t(s)), 1),
              D(t(se), {
                onClick: Y[9] || (Y[9] = (P) => U(P, t(s))),
                rounded: "",
                class: "flex md:text-md gap-2 whitespace-nowrap text-[#ffffff] shrink px-3",
                style: {
                  background: "#3A3CFF",
                  fontWeight: 400
                },
                "aria-label": "Copy video url"
              }, {
                default: q(() => [
                  _(w(t(f)), 1)
                ]),
                _: 1
              })
            ])
          ]),
          e.isVerticalPlayer ? b("", !0) : (l(), n("span", zo, [
            a("input", {
              type: "checkbox",
              name: "embedCurrentTime",
              id: "embedCurrentTime",
              onInput: te
            }, null, 32),
            a("p", Vo, w(t(v)), 1),
            a("p", Jo, w(ue.value), 1)
          ]))
        ], 512)
      ])) : b("", !0)
    ]));
  }
}, Uo = /* @__PURE__ */ ne(Po, [["__scopeId", "data-v-bf2aa07c"]]), Go = { class: "j-details-info flex items-center gap-2" }, Zo = { key: 1 }, Ko = { key: 2 }, Xo = { key: 1 }, Qo = ["width", "height"], Yo = ["fill-rule"], _o = { key: 2 }, en = {
  __name: "JContentDetails",
  props: {
    title: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      required: !1,
      default: null
    },
    callback: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    origin: {
      type: String,
      required: !1,
      default: ""
    },
    pathname: {
      type: String,
      required: !1,
      default: ""
    },
    viewsCount: {
      type: [Number, String],
      required: !1,
      default: "2,332"
    },
    img: {
      type: [String],
      required: !1,
      default: "https://cdn.vpapps.cloud/default-video-card.png"
    },
    date: {
      type: [String],
      required: !1,
      default: "25/02/2022"
    },
    duration: {
      type: [String, Number],
      required: !1,
      default: 0
    },
    likesCount: {
      type: [Number, null],
      required: !1,
      default: null
    },
    dislikesCount: {
      type: [Number, null],
      required: !1,
      default: null
    },
    sharesCount: {
      type: [Number, null],
      required: !1,
      default: null
    },
    watchLaterCount: {
      type: Number,
      required: !1,
      default: null
    },
    hasLiked: {
      type: Boolean,
      required: !1,
      default: null
    },
    hasDisliked: {
      type: Boolean,
      required: !1,
      default: !1
    },
    hasWatchLater: {
      type: Boolean,
      required: !1,
      default: !1
    },
    showMoreText: {
      type: String,
      required: !1,
      default: "Zobrazit více"
    },
    showLessText: {
      type: String,
      required: !1,
      default: "Zobrazit méně"
    },
    engagementsShowDemo: {
      type: Boolean,
      required: !1,
      default: !0
    },
    showTitle: {
      type: Boolean,
      default: !0
    },
    showDescription: {
      type: Boolean,
      default: !0
    },
    showLike: {
      type: Boolean,
      default: !0
    },
    showDislike: {
      type: Boolean,
      default: !0
    },
    showShare: {
      type: Boolean,
      default: !0
    },
    showViews: {
      type: Boolean,
      default: !0
    },
    showPublishDate: {
      type: Boolean,
      default: !0
    },
    breakpoint: {
      type: String,
      default: "desktop"
    },
    shareText: {
      type: String,
      default: "Share"
    },
    viewsCountText: {
      type: String,
      default: "views"
    },
    videoStartTimeText: {
      type: String,
      default: "Video start time"
    },
    copyText: {
      type: String,
      default: "Copy"
    },
    linkText: {
      type: String,
      default: "Copy"
    },
    engagementsStyle: {
      type: Object,
      default: {}
    },
    titleStyle: {
      type: Object,
      default: {}
    },
    descriptionStyle: {
      type: Object,
      default: {}
    },
    showLikeIcon: {
      type: Boolean,
      default: !0
    },
    showLikeText: {
      type: Boolean,
      default: !1
    },
    showDislikeIcon: {
      type: Boolean,
      default: !0
    },
    showDislikeText: {
      type: Boolean,
      default: !1
    },
    showShareIcon: {
      type: Boolean,
      default: !0
    },
    showShareText: {
      type: Boolean,
      default: !0
    },
    likeIcon: {
      type: Object,
      default: {
        props: {
          name: "vpapps-font-thumbs-up-like"
        },
        style: {}
      }
    },
    dislikeIcon: {
      type: Object,
      default: {
        props: {
          name: "vpapps-font-thumbs-down-dislike"
        },
        style: {}
      }
    },
    shareIcon: {
      type: Object,
      default: {
        props: {
          name: "vpapps-font-share"
        },
        style: {}
      }
    },
    style: {
      type: Object,
      default: {}
    },
    isVerticalPlayer: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    Ie((Se) => ({
      "6c9388f1": Se.likedColorOnHover,
      a51ef702: Se.likedBackgroundColorOnHover,
      "0ac607e2": Se.dislikedColorOnHover,
      "33532a1d": Se.dislikedBackgroundColorOnHover,
      b84a4bba: Se.shareColorOnHover,
      "29317f31": Se.shareBackgroundColorOnHover
    }));
    const i = e, {
      title: o,
      description: c,
      callback: s,
      viewsCount: r,
      img: y,
      date: d,
      duration: m,
      likeIcon: u,
      dislikeIcon: h,
      shareIcon: f,
      likesCount: p,
      dislikesCount: v,
      watchLaterCount: S,
      hasLiked: j,
      hasDisliked: $,
      hasWatchLater: N,
      breakpoint: k,
      origin: M,
      pathname: x,
      shareText: T,
      viewsCountText: O,
      videoStartTimeText: E,
      copyText: I,
      linkText: A,
      showTitle: le,
      showDescription: Z,
      showMoreText: W,
      showLessText: B,
      showLikeIcon: L,
      showLikeText: H,
      showDislikeIcon: V,
      showDislikeText: U,
      showShareIcon: te,
      showShareText: ue,
      engagementsShowDemo: G,
      showViews: Y,
      showPublishDate: P,
      engagementsStyle: z,
      titleStyle: ye,
      descriptionStyle: ce,
      style: de,
      showLike: ve,
      showDislike: we,
      showShare: Ce
    } = ae(i), Te = R(() => k.value === "mobile"), Oe = C(!1), ee = C(!1), Q = C(0), ie = R(() => {
      var me, De, Me, Ae, Re, ze, Ve, Je, Pe, Ue, Ge, Ze;
      let Se = {
        color: (De = (me = u.value) == null ? void 0 : me.style) == null ? void 0 : De.color,
        backgroundColor: (Ae = (Me = u.value) == null ? void 0 : Me.style) == null ? void 0 : Ae.backgroundColor
      };
      return j.value && ((ze = (Re = u.value) == null ? void 0 : Re.style) != null && ze.colorOnActive && (Se.color = (Je = (Ve = u.value) == null ? void 0 : Ve.style) == null ? void 0 : Je.colorOnActive), (Ue = (Pe = u.value) == null ? void 0 : Pe.style) != null && Ue.backgroundColorOnActive && (Se.backgroundColor = (Ze = (Ge = u.value) == null ? void 0 : Ge.style) == null ? void 0 : Ze.backgroundColorOnActive)), Se;
    }), pe = R(() => {
      var me, De, Me, Ae, Re, ze, Ve, Je, Pe, Ue, Ge, Ze;
      let Se = {
        color: (De = (me = h.value) == null ? void 0 : me.style) == null ? void 0 : De.color,
        backgroundColor: (Ae = (Me = h.value) == null ? void 0 : Me.style) == null ? void 0 : Ae.backgroundColor
      };
      return $.value && ((ze = (Re = h.value) == null ? void 0 : Re.style) != null && ze.colorOnActive && (Se.color = (Je = (Ve = h.value) == null ? void 0 : Ve.style) == null ? void 0 : Je.colorOnActive), (Ue = (Pe = h.value) == null ? void 0 : Pe.style) != null && Ue.backgroundColorOnActive && (Se.backgroundColor = (Ze = (Ge = h.value) == null ? void 0 : Ge.style) == null ? void 0 : Ze.backgroundColorOnActive)), Se;
    }), qe = R(() => M.value + x.value + `${Q.value ? "?t=" + Q.value : ""}`), je = R(() => M.value + "/embed" + x.value + `${Q.value ? "?t=" + Q.value : ""}`), Ye = (Se) => {
      s && s.value && s.value(Se);
    };
    return (Se, me) => {
      var De;
      return l(), n("div", {
        class: "j-details flex flex-col",
        style: g(t(de))
      }, [
        a("div", {
          class: "j-details-info-holder relative flex justify-between items-center flex-wrap w-full",
          style: g(t(z))
        }, [
          a("div", Go, [
            t(G) && t(Y) ? (l(), n("p", {
              key: 0,
              class: "j-details-vews whitespace-nowrap",
              style: g({ ...t(z).fontStyle })
            }, w(t(r)) + " " + w(t(O)), 5)) : b("", !0),
            t(G) && t(Y) && t(P) ? (l(), n("p", Zo, "•")) : b("", !0),
            t(P) ? (l(), n("p", {
              key: 2,
              class: "j-details-date whitespace-nowrap",
              style: g({ ...t(z).fontStyle })
            }, w(t(d)), 5)) : b("", !0)
          ]),
          t(G) ? (l(), n("div", {
            key: 0,
            class: "j-details-actions relative flex overflow-x-auto items-center justify-start md:justify-end",
            style: g({ gap: (De = t(z)) == null ? void 0 : De.gap })
          }, [
            t(ve) ? (l(), F(t(se), {
              key: 0,
              class: "flex whitespace-nowrap",
              "aria-label": "Like",
              style: g({ ...t(z).fontStyle }),
              onClick: me[0] || (me[0] = (Me) => Ye(1))
            }, {
              default: q(() => {
                var Me, Ae;
                return [
                  t(L) ? (l(), F(t(oe), {
                    key: 0,
                    "ikone-name": (Ae = (Me = t(u)) == null ? void 0 : Me.props) == null ? void 0 : Ae.name,
                    "ikone-style": {
                      ...t(u).style,
                      color: ie.value.color,
                      backgroundColor: ie.value.backgroundColor
                    },
                    class: "like-icon-hover"
                  }, null, 8, ["ikone-name", "ikone-style"])) : b("", !0),
                  t(H) ? (l(), n(X, { key: 1 }, [
                    _("Like")
                  ], 64)) : b("", !0),
                  t(p) ? (l(), n("p", Ko, "(" + w(t(p)) + ")", 1)) : b("", !0)
                ];
              }),
              _: 1
            }, 8, ["style"])) : b("", !0),
            t(we) ? (l(), F(t(se), {
              key: 1,
              class: "flex whitespace-nowrap",
              "aria-label": "Dislike",
              style: g({ ...t(z).fontStyle }),
              onClick: me[1] || (me[1] = (Me) => Ye(2))
            }, {
              default: q(() => [
                t(V) ? (l(), F(t(oe), {
                  key: 0,
                  "ikone-name": t(h).props.name,
                  "ikone-style": {
                    ...t(h).style,
                    color: pe.value.color,
                    backgroundColor: pe.value.backgroundColor
                  },
                  class: "dislike-icon-hover"
                }, null, 8, ["ikone-name", "ikone-style"])) : b("", !0),
                t(v) ? (l(), n("p", Xo, "(" + w(t(v)) + ")", 1)) : b("", !0)
              ]),
              _: 1
            }, 8, ["style"])) : b("", !0),
            Oe.value ? (l(), F(t(se), {
              key: 2,
              onClick: me[2] || (me[2] = (Me) => Ye(5)),
              rounded: "",
              class: "flex whitespace-nowrap",
              "aria-label": "Watch later",
              style: g({ ...t(z).fontStyle })
            }, {
              default: q(() => [
                (l(), n("svg", {
                  width: Te.value ? 16 : 18,
                  height: Te.value ? 16 : 18,
                  class: "md:my-auto mx-auto",
                  viewBox: "0 0 20 21",
                  style: { fill: "currentColor" },
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  me[5] || (me[5] = a("path", {
                    d: "M4.53033 0.821232C4.82322 1.11413 4.82322 1.589 4.53033 1.88189L1.53033 4.88189C1.23744 5.17479 0.762563 5.17479 0.46967 4.88189C0.176777 4.589 0.176777 4.11413 0.46967 3.82123L3.46967 0.821232C3.76256 0.528339 4.23744 0.528339 4.53033 0.821232Z",
                    fill: "#6E7B95"
                  }, null, -1)),
                  me[6] || (me[6] = a("path", {
                    d: "M6.25 11.3516C6.25 10.9373 6.58579 10.6016 7 10.6016H9.25V8.35156C9.25 7.93735 9.58579 7.60156 10 7.60156C10.4142 7.60156 10.75 7.93735 10.75 8.35156V10.6016H13C13.4142 10.6016 13.75 10.9373 13.75 11.3516C13.75 11.7658 13.4142 12.1016 13 12.1016H10.75V14.3516C10.75 14.7658 10.4142 15.1016 10 15.1016C9.58579 15.1016 9.25 14.7658 9.25 14.3516V12.1016H7C6.58579 12.1016 6.25 11.7658 6.25 11.3516Z",
                    fill: "#6E7B95"
                  }, null, -1)),
                  a("path", {
                    "fill-rule": t(N) ? "nonzero" : "evenodd",
                    "clip-rule": "evenodd",
                    d: "M10 20.3516C14.9706 20.3516 19 16.3221 19 11.3516C19 6.381 14.9706 2.35156 10 2.35156C5.02944 2.35156 1 6.381 1 11.3516C1 16.3221 5.02944 20.3516 10 20.3516ZM10 18.8516C14.1421 18.8516 17.5 15.4937 17.5 11.3516C17.5 7.20943 14.1421 3.85156 10 3.85156C5.85786 3.85156 2.5 7.20943 2.5 11.3516C2.5 15.4937 5.85786 18.8516 10 18.8516Z",
                    stroke: "#6E7B95",
                    fill: "#6E7B9500"
                  }, null, 8, Yo),
                  me[7] || (me[7] = a("path", {
                    d: "M15.4697 1.88189C15.1768 1.589 15.1768 1.11413 15.4697 0.821232C15.7626 0.528339 16.2374 0.528339 16.5303 0.821232L19.5303 3.82123C19.8232 4.11413 19.8232 4.589 19.5303 4.88189C19.2374 5.17479 18.7626 5.17479 18.4697 4.88189L15.4697 1.88189Z",
                    fill: "#6E7B95"
                  }, null, -1))
                ], 8, Qo)),
                a("p", null, w(t(S)) + " Shlédnout Později", 1)
              ]),
              _: 1
            }, 8, ["style"])) : b("", !0),
            t(G) && t(Ce) ? (l(), F(t(se), {
              key: 3,
              rounded: "",
              class: "flex whitespace-nowrap",
              "aria-label": "Share",
              style: g({ ...t(z).fontStyle }),
              onClick: me[3] || (me[3] = (Me) => ee.value = !ee.value)
            }, {
              default: q(() => [
                t(te) ? (l(), F(t(oe), {
                  key: 0,
                  "ikone-name": t(f).props.name,
                  "ikone-style": { ...t(f).style },
                  class: "share-icon-hover"
                }, null, 8, ["ikone-name", "ikone-style"])) : b("", !0),
                t(ue) ? (l(), n(X, { key: 1 }, [
                  _(w(t(T)), 1)
                ], 64)) : b("", !0),
                e.sharesCount ? (l(), n("p", _o, "(" + w(e.sharesCount) + ")", 1)) : b("", !0)
              ]),
              _: 1
            }, 8, ["style"])) : b("", !0)
          ], 4)) : b("", !0)
        ], 4),
        D(ko, {
          title: t(o),
          description: t(c),
          titleStyle: t(ye),
          descriptionStyle: t(ce),
          showTitle: t(le),
          showDescription: t(Z),
          showMoreText: t(W),
          showLessText: t(B)
        }, null, 8, ["title", "description", "titleStyle", "descriptionStyle", "showTitle", "showDescription", "showMoreText", "showLessText"]),
        ee.value ? (l(), F(Uo, {
          key: 0,
          callback: t(s),
          origin: t(M),
          pathname: t(x),
          shareText: t(T),
          videoUrl: qe.value,
          videoUrlEmbed: je.value,
          title: t(o),
          date: t(d),
          duration: t(m),
          img: t(y),
          shareIcon: t(f),
          copyText: t(I),
          linkText: t(A),
          videoStartTimeText: t(E),
          showMoreText: t(W),
          showLessText: t(B),
          share: ee.value,
          isVerticalPlayer: e.isVerticalPlayer,
          onCloseShareModal: me[4] || (me[4] = (Me) => ee.value = !1)
        }, null, 8, ["callback", "origin", "pathname", "shareText", "videoUrl", "videoUrlEmbed", "title", "date", "duration", "img", "shareIcon", "copyText", "linkText", "videoStartTimeText", "showMoreText", "showLessText", "share", "isVerticalPlayer"])) : b("", !0)
      ], 4);
    };
  }
}, Li = /* @__PURE__ */ ne(en, [["__scopeId", "data-v-8b867571"]]), tn = "…";
function ln(e, i, o) {
  e.style.cssText += "overflow:hidden;overflow-wrap:break-word;word-wrap:break-word";
  const c = i * parseInt(window.getComputedStyle(e).lineHeight, 10);
  return e.scrollHeight <= c ? !1 : Ct(
    e,
    e,
    c,
    tn
  );
}
function Ct(e, i, o, c) {
  const s = e.childNodes;
  let r = s.length - 1;
  for (; r > -1; ) {
    const y = s[r--];
    if (y.nodeType === 1 && Ct(
      y,
      i,
      o,
      c
    ) || y.nodeType === 3 && an(
      y,
      i,
      o,
      c
    ))
      return !0;
    e.removeChild(y);
  }
  return !1;
}
function an(e, i, o, c) {
  let s, r = e.textContent;
  for (; r.length > 1 && (s = r.lastIndexOf(" "), s !== -1); ) {
    if (e.textContent = r.substring(0, s), i.scrollHeight <= o) {
      e.textContent = r;
      break;
    }
    r = e.textContent;
  }
  return nn(
    e,
    i,
    o,
    c
  );
}
const on = /[ .,;!?'‘’“”\-–—]+$/;
function nn(e, i, o, c) {
  let s = e.textContent, r = s.length;
  for (; r > 1; )
    if (s = s.substring(0, r - 1).replace(on, ""), r = s.length, e.textContent = s + c, i.scrollHeight <= o)
      return !0;
  return !1;
}
const sn = { class: "j-details p-3 mt-5 md:p-2 flex flex-col" }, rn = { class: "j-details-info-holder relative flex justify-between flex-wrap w-full gap-4 md:gap-1 mb-3" }, un = { class: "j-details-info flex col-span-4 gap-2 justify-start md:col-span-3 items-center" }, cn = {
  key: 0,
  class: "j-details-vews text-[#6E7B95] text-[14px] md:text-[16px] whitespace-nowrap"
}, dn = { key: 1 }, fn = { class: "j-details-date text-[#6E7B95] whitespace-nowrap text-[14px] md:text-[16px] flex align-center justify-between" }, yn = {
  key: 0,
  class: "j-details-actions relative text-[#6E7B95] gap-2 sm:gap-3 md:gap-4 col-span-4 flex overflow-x-auto md:col-span-7 items-center justify-start md:justify-end"
}, pn = { class: "flex rounded-md bg-[#F6F8F9] sm:bg-transparent gap-0 sm:gap-4" }, mn = { class: "border-r text-[14px] md:text-[16px] border-gray-500 pr-3 sm:pr-0 sm:border-none text-[#36435E]" }, vn = { class: "flex text-[#36435E]" }, gn = { class: "flex text-[#36435E]" }, hn = { class: "j-details-title mb-2 w-full border-b border-gray-200 pb-3" }, bn = {
  key: 0,
  class: "text-[18px] md:text-xl text-black font-semibold mb-3"
}, wn = {
  key: 1,
  class: "flex flex-col"
}, xn = ["innerHTML"], kn = {
  key: 0,
  id: "share-pop-up",
  class: "fixed top-0 left-0 right-0 transform-x-1/2 bg-[#04030633] flex flex-col h-full w-full items-center justify-center z-50"
}, Sn = { class: "flex justify-between mb-2" }, Cn = { class: "text-xl flex text-[#000000] font-extrabold" }, $n = { class: "flex flex-col border-b border-b-[#EAEAEA] pb-4 mb-4" }, Tn = { class: "flex gap-2 py-2 mb-6" }, On = { class: "mb-6" }, qn = { class: "bg-[#F5F5F5] p-3 rounded flex gap-4" }, jn = {
  key: 0,
  class: "flex flex-col"
}, Mn = { class: "flex bg-white items-center justify-between p-3 mt-5 mb-2 border border-secondary rounded-md transition-all duration-50 ease-in" }, In = { class: "text-[#646464] max-w-md grow flex-1 truncate" }, Bn = { class: "flex gap-3" }, Fn = { class: "flex gap-3" }, Ln = { class: "flex gap-3" }, Dn = {
  key: 1,
  class: "flex flex-col"
}, An = { class: "flex bg-white items-center justify-between p-3 mt-5 border border-secondary rounded-md transition-all duration-50 ease-in" }, Hn = { class: "text-[#646464] max-w-md grow flex-1 truncate" }, En = { class: "text-base flex text-[#000000] font-bold mb-1" }, Nn = { class: "flex bg-white items-center justify-between p-3 border border-secondary rounded-md transition-all duration-50 ease-in" }, Wn = { class: "text-[#646464] max-w-md grow flex-1 truncate" }, Rn = { class: "flex gap-3" }, zn = { class: "text-black" }, Vn = { class: "text-[#8E8E8E] px-2" }, Jn = {
  __name: "JDetails",
  props: {
    data: {
      type: Array,
      required: !0
    },
    title: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      required: !1,
      default: null
    },
    callback: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    viewsCount: {
      type: [Number, String],
      required: !1,
      default: "2,332"
    },
    img: {
      type: [String],
      required: !1,
      default: "https://cdn.vpapps.cloud/default-video-card.png"
    },
    date: {
      type: [String],
      required: !1,
      default: "25/02/2022"
    },
    duration: {
      type: [String, Number],
      required: !1,
      default: 0
    },
    likesCount: {
      type: Number,
      required: !1,
      default: null
    },
    dislikesCount: {
      type: Number,
      required: !1,
      default: null
    },
    favoritesCount: {
      type: Number,
      required: !1,
      default: null
    },
    subscribesCount: {
      type: Number,
      required: !1,
      default: null
    },
    watchLaterCount: {
      type: Number,
      required: !1,
      default: null
    },
    hasLiked: {
      type: Boolean,
      required: !1,
      default: null
    },
    hasDisliked: {
      type: Boolean,
      required: !1,
      default: !1
    },
    hasFavorite: {
      type: Boolean,
      required: !1,
      default: !1
    },
    hasSubsribed: {
      type: Boolean,
      required: !1,
      default: !1
    },
    hasWatchLater: {
      type: Boolean,
      required: !1,
      default: !1
    },
    customWrapper: {
      type: String,
      required: !1,
      default: "RouterLink"
    },
    showMoreText: {
      type: String,
      required: !1,
      default: "Zobrazit více"
    },
    showLessText: {
      type: String,
      required: !1,
      default: "Zobrazit méně"
    },
    engagementsShowDemo: {
      type: Boolean,
      required: !1,
      default: !0
    },
    showTitle: {
      type: Boolean,
      default: !0
    },
    showDescription: {
      type: Boolean,
      default: !0
    },
    showLike: {
      type: Boolean,
      default: !0
    },
    showDislike: {
      type: Boolean,
      default: !0
    },
    showShare: {
      type: Boolean,
      default: !0
    },
    showFavorite: {
      type: Boolean,
      default: !0
    },
    showViews: {
      type: Boolean,
      default: !0
    },
    breakpoint: {
      type: String,
      default: "desktop"
    },
    shareText: {
      type: String,
      default: "Share"
    },
    viewsCountText: {
      type: String,
      default: "views"
    },
    videoStartTimeText: {
      type: String,
      default: "Video start time"
    },
    copyText: {
      type: String,
      default: "Copy"
    },
    linkText: {
      type: String,
      default: "Copy"
    }
  },
  setup(e) {
    const i = e, { origin: o, pathname: c } = window.location, {
      data: s,
      title: r,
      description: y,
      callback: d,
      viewsCount: m,
      img: u,
      date: h,
      duration: f,
      likesCount: p,
      dislikesCount: v,
      favoritesCount: S,
      subscribesCount: j,
      watchLaterCount: $,
      hasLiked: N,
      hasDisliked: k,
      hasFavorite: M,
      hasSubsribed: x,
      hasWatchLater: T,
      breakpoint: O
    } = ae(i), E = C(null);
    R(() => O.value === "mobile");
    const I = C(!1), A = C(!1);
    C(!1), C(!1), C(!1);
    const le = C(!1), Z = C(!1);
    C(!1), C(!1);
    const W = C(!1), B = C("javascript"), L = (ee) => {
      d && d.value && d.value(ee);
    }, V = Fe(E, (ee) => {
      V.isClickOutside(ee, E) && (Z.value = !1);
    });
    async function U(ee, Q) {
      const ie = ee.target.parentElement;
      try {
        await navigator.clipboard.writeText(Q), ie.classList.add(
          "ring-1",
          "ring-offset-0",
          "ring-blue-500",
          "bg-blue-300/25"
        ), setTimeout(() => {
          ie.classList.remove(
            "ring-1",
            "ring-offset-0",
            "ring-blue-500",
            "bg-blue-300/25"
          );
        }, 1e3);
      } catch (pe) {
        console.error("Failed to copy: ", pe);
      }
    }
    const te = [
      {
        id: "0",
        name: "Facebook",
        icon: "https://cdn.vpapps.cloud/social-medias/embed.svg",
        createdAt: "0001-01-01T00:00:00",
        url: (ee) => W.value = !W.value
      },
      {
        id: "1",
        name: "Facebook",
        icon: "https://cdn.vpapps.cloud/social-medias/facebook.svg",
        createdAt: "0001-01-01T00:00:00",
        url: (ee) => `https://www.facebook.com/dialog/share?href=${ee}&client_id=461693840960966 `
      },
      {
        id: "2",
        name: "Messenger",
        icon: "https://cdn.vpapps.cloud/social-medias/messenger.svg",
        createdAt: "0001-01-01T00:00:00",
        url: (ee) => `http://www.facebook.com/dialog/send?link=${ee}&redirect_uri=${ee}&app_id=461693840960966 `
      },
      // {
      //   "id": "3",
      //   "name": "Instagram",
      //   "icon": "https://cdn.vpapps.cloud/social-medias/instagram.svg",
      //   "createdAt": "0001-01-01T00:00:00",
      //   url: (u) => `https://www.facebook.com/v11.0/dialog/share?href=${u}&client_id=461693840960966 `
      // },
      {
        id: "4",
        name: "Twitter",
        icon: "https://cdn.vpapps.cloud/social-medias/twitter.svg",
        createdAt: "0001-01-01T00:00:00",
        url: (ee) => `https://twitter.com/intent/tweet?url=${ee}`
      }
      // {
      //   id: "5",
      //   name: "E-Mail",
      //   icon: "https://cdn.vpapps.cloud/social-medias/email.svg",
      //   createdAt: "0001-01-01T00:00:00",
      //   url: (u, title) => `mailto:?subject=${title}&body=${u}`,
      // },
    ], ue = C(0), G = R(() => {
      const { value: ee } = ue;
      return ee < 60 ? `00:${ee < 10 ? "0" + ee : ee}` : ee < 60 * 60 ? `${parseInt(ee / 60) < 10 ? "0" + parseInt(ee / 60) : parseInt(ee / 60)}:${parseInt(ee % 60, 10) < 10 ? "0" + parseInt(ee % 60, 10) : parseInt(ee % 60, 10)}` : `${parseInt(ee / 60 / 60, 10)}:${parseInt(
        ee / 60 % 60,
        10
      )}:${parseInt(ee % 60, 10)}`;
    });
    function Y(ee) {
      var Q;
      ue.value = ee.target.checked && typeof vpPlayer == "function" ? Math.floor((Q = vpPlayer()) == null ? void 0 : Q.getPosition()) : 0;
    }
    const P = R(() => o + c + `${ue.value ? "?t=" + ue.value : ""}`), z = R(() => o + "/embed" + c + `${ue.value ? "?t=" + ue.value : ""}`), ye = C(!1), ce = C(!0), de = C(!1), ve = C(!0), we = R(() => `<div style="padding-top:56.25%; position:relative; width:100%;">
    ${ye.value ? Te.value : ""}
    <iframe
      class="no-margin"
      style="position:absolute; left:0; top:0; width: 100%; height:100%;"
      src="${z.value}?autoplay=${ce.value}&am=${de.value}&muted=${ve.value}"
      frameborder="0"
      allow="autoplay" 
      Allowfullscreen
    >
    </iframe>
  </div>`), Ce = R(() => `<script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "VideoObject",
      "name": "${r.value}",
      "duration": "PT${f.value}S",
      "thumbnailUrl": "${u.value}",
      "uploadDate": "${h.value}",
      "contentUrl": "${z.value}?autoplay=${ce.value}&am=${de.value}&muted=${ve.value}"
    }
    <\/script>
  <div
    class="vp-embed-wrapper"
    data-upload="${h.value}"
    data-name="${r.value}"
    data-duration="PT${f.value}S"
    data-thumbnail="${u.value}"
    data-url="${z.value}?autoplay=${ce.value}&am=${de.value}&muted=${ve.value}">
    <div class="vp-embed" style="position: relative; overflow: hidden; padding-bottom: 56.25%"></div>
    <script
      id="JEmbed"
      type="text/javascript"
      src="https://cdn.vpapps.cloud/embed.js"><\/script>
  </div>`), Te = R(() => `<meta itemprop='${h.value}' content='${h.value}' />
    <meta itemprop='${r.value}' />
    <meta itemprop='PT${f.value}S' content='PT${f.value}S' />
    <meta itemprop='${u.value}' content='${u.value}' />
    <meta itemprop='${z.value}?autoplay=${ce.value}&am=${de.value}&muted=${ve.value}' content='${z.value}?autoplay=${ce.value}&am=${de.value}&muted=${ve.value}' />`);
    function Oe(ee) {
      const Q = document.querySelector("#j-details-description");
      if (ee) Q.innerHTML = y.value;
      else return ln(Q, 3);
    }
    return ke(() => {
      setTimeout(() => {
        I.value = Oe(A.value);
      }, 800);
    }), (ee, Q) => (l(), n(X, null, [
      a("div", sn, [
        a("div", rn, [
          a("div", un, [
            e.engagementsShowDemo && e.showViews ? (l(), n("p", cn, w(t(m)) + " " + w(e.viewsCountText), 1)) : b("", !0),
            e.engagementsShowDemo && e.showViews ? (l(), n("p", dn, "•")) : b("", !0),
            a("p", fn, w(t(h)), 1)
          ]),
          e.engagementsShowDemo ? (l(), n("div", yn, [
            a("div", pn, [
              e.showLike ? (l(), F(t(se), {
                key: 0,
                onClick: Q[0] || (Q[0] = (ie) => L(1)),
                class: "flex text-[14px] md:text-[16px] gap-2 px-3 rounded-l-md bg-[#F6F8F9] sm:bg-transparent whitespace-nowrap",
                "aria-label": "Like"
              }, {
                default: q(() => [
                  D(t(oe), { "ikone-name": "vpapps-font-thumbs-up-like" }),
                  a("p", mn, w(t(p)), 1)
                ]),
                _: 1
              })) : b("", !0),
              e.showDislike ? (l(), F(t(se), {
                key: 1,
                onClick: Q[1] || (Q[1] = (ie) => L(2)),
                class: "flex text-[14px] md:text-[16px] gap-2 px-3 whitespace-nowrap rounded-r-md bg-[#F6F8F9] sm:bg-transparent",
                "aria-label": "Dislike"
              }, {
                default: q(() => [
                  D(t(oe), { "ikone-name": "vpapps-font-thumbs-down-dislike" })
                ]),
                _: 1
              })) : b("", !0)
            ]),
            le.value ? (l(), F(t(se), {
              key: 0,
              onClick: Q[2] || (Q[2] = (ie) => L(5)),
              rounded: "",
              class: "flex text-[14px] md:text-[16px] gap-2 whitespace-nowrap bg-[#F6F8F9] sm:bg-transparent",
              "aria-label": "Watch later"
            }, {
              default: q(() => [
                D(t(oe), { "ikone-name": "vpapps-font-clock-time-alarm-add" }),
                a("p", vn, w(t($)) + " Shlédnout Později ", 1)
              ]),
              _: 1
            })) : b("", !0),
            e.engagementsShowDemo && e.showShare ? (l(), F(t(se), {
              key: 1,
              onClick: Q[3] || (Q[3] = (ie) => Z.value = !Z.value),
              rounded: "",
              class: "flex text-[14px] md:text-[16px] gap-2 px-3 whitespace-nowrap bg-[#F6F8F9] sm:bg-transparent relative",
              "aria-label": "Share"
            }, {
              default: q(() => [
                D(t(oe), { "ikone-name": "vpapps-font-share" }),
                a("p", gn, w(e.shareText), 1)
              ]),
              _: 1
            })) : b("", !0)
          ])) : b("", !0)
        ]),
        a("div", hn, [
          e.showTitle ? (l(), n("p", bn, w(t(r)), 1)) : b("", !0),
          e.showDescription ? (l(), n("div", wn, [
            a("div", {
              id: "j-details-description",
              class: "text-[#646464] text-[14px] md:text-[16px] font-medium whitespace-pre-wrap ql-editor p-0!",
              innerHTML: t(y)
            }, null, 8, xn),
            I.value ? (l(), F(t(se), {
              key: 0,
              textColor: "#4B4B4B",
              class: "flex w-fit text-[14px] md:text-[16px] shrink px-0 show-more-description",
              "aria-label": A.value ? e.showLessText : e.showMoreText,
              onClick: Q[4] || (Q[4] = () => {
                A.value = !A.value, Oe(A.value);
              })
            }, {
              default: q(() => [
                _(w(A.value ? e.showLessText : e.showMoreText), 1)
              ]),
              _: 1
            }, 8, ["aria-label"])) : b("", !0)
          ])) : b("", !0)
        ])
      ]),
      (l(), F(ot, { to: "body" }, [
        Z.value ? (l(), n("div", kn, [
          a("div", {
            ref_key: "shareModalRef",
            ref: E,
            class: "flex flex-col w-11/12 sm:w-3/4 md:w-2/3 lg:w-1/3 bg-[#FFFFFF] rounded-md p-6"
          }, [
            a("span", Sn, [
              a("p", Cn, w(e.shareText), 1),
              D(t(oe), {
                "ikone-name": "vpapps-font-close-cancel",
                onClick: Q[5] || (Q[5] = (ie) => Z.value = !1)
              })
            ]),
            a("span", $n, [
              a("div", Tn, [
                (l(), n(X, null, re(te, ({ icon: ie, name: pe, id: qe, url: je }) => (l(), n(X, { key: qe }, [
                  qe > 0 ? (l(), F(t(et), {
                    key: 0,
                    imageSrc: ie,
                    "external-link-to": je(P.value, t(r)),
                    alt: pe,
                    "custom-wrapper": "a",
                    "image-style": {
                      height: "40px",
                      width: "40px",
                      borderRadius: "4px"
                    }
                  }, null, 8, ["imageSrc", "external-link-to", "alt"])) : (l(), F(t(et), {
                    key: 1,
                    imageSrc: ie,
                    onClick: (Ye) => je(),
                    alt: pe,
                    "custom-wrapper": "a",
                    class: "cursor-pointer",
                    "image-style": {
                      height: "40px",
                      width: "40px",
                      borderRadius: "4px"
                    }
                  }, null, 8, ["imageSrc", "onClick", "alt"]))
                ], 64))), 64))
              ]),
              fe(a("span", On, [
                a("span", qn, [
                  D(t(se), {
                    onClick: Q[6] || (Q[6] = (ie) => B.value = "javascript"),
                    rounded: "",
                    class: "flex md:text-md gap-2 whitespace-nowrap text-[#646464] shrink px-3 w-full",
                    style: g({
                      background: B.value == "javascript" ? "#FFFFFF" : "#FFFFFF00",
                      fontWeight: 400
                    }),
                    "aria-label": "Javascript embed"
                  }, {
                    default: q(() => Q[14] || (Q[14] = [
                      _(" JavaScript ")
                    ])),
                    _: 1,
                    __: [14]
                  }, 8, ["style"]),
                  D(t(se), {
                    onClick: Q[7] || (Q[7] = (ie) => B.value = "iframe"),
                    rounded: "",
                    class: "flex md:text-md gap-2 whitespace-nowrap text-[#646464] shrink px-3 w-full",
                    style: g({
                      background: B.value == "iframe" ? "#FFFFFF" : "#FFFFFF00",
                      fontWeight: 400
                    }),
                    "aria-label": "iFrame embed"
                  }, {
                    default: q(() => Q[15] || (Q[15] = [
                      _(" iFrame ")
                    ])),
                    _: 1,
                    __: [15]
                  }, 8, ["style"])
                ]),
                B.value == "iframe" ? (l(), n("span", jn, [
                  a("span", Mn, [
                    a("p", In, w(we.value), 1),
                    D(t(se), {
                      onClick: Q[8] || (Q[8] = (ie) => U(ie, we.value)),
                      rounded: "",
                      class: "flex md:text-md gap-2 whitespace-nowrap text-[#ffffff] shrink px-3",
                      style: {
                        background: "#3A3CFF",
                        fontWeight: 400
                      },
                      "aria-label": "Copy iframe embed"
                    }, {
                      default: q(() => [
                        _(w(e.copyText), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  a("span", Bn, [
                    fe(a("input", {
                      "onUpdate:modelValue": Q[9] || (Q[9] = (ie) => ye.value = ie),
                      type: "checkbox",
                      name: "includeSeo",
                      id: "includeSeo"
                    }, null, 512), [
                      [Ne, ye.value]
                    ]),
                    Q[16] || (Q[16] = a("p", { class: "text-black" }, "Zahrnout SEO", -1))
                  ]),
                  a("span", Fn, [
                    fe(a("input", {
                      "onUpdate:modelValue": Q[10] || (Q[10] = (ie) => ce.value = ie),
                      type: "checkbox",
                      name: "autoplay",
                      id: "autoplay"
                    }, null, 512), [
                      [Ne, ce.value]
                    ]),
                    Q[17] || (Q[17] = a("p", { class: "text-black" }, "Vypnout autoplay", -1))
                  ]),
                  a("span", Ln, [
                    fe(a("input", {
                      "onUpdate:modelValue": Q[11] || (Q[11] = (ie) => de.value = ie),
                      type: "checkbox",
                      name: "autoplayMobile",
                      id: "autoplayMobile"
                    }, null, 512), [
                      [Ne, de.value]
                    ]),
                    Q[18] || (Q[18] = a("p", { class: "text-black" }, "Zapnout autoplay na mobilním webu", -1))
                  ])
                ])) : b("", !0),
                B.value == "javascript" ? (l(), n("span", Dn, [
                  a("span", An, [
                    a("p", Hn, w(Ce.value), 1),
                    D(t(se), {
                      onClick: Q[12] || (Q[12] = (ie) => U(ie, Ce.value)),
                      rounded: "",
                      class: "flex md:text-md gap-2 whitespace-nowrap text-[#ffffff] shrink px-3",
                      style: {
                        background: "#3A3CFF",
                        fontWeight: 400
                      },
                      "aria-label": "Copy javascript embed"
                    }, {
                      default: q(() => [
                        _(w(e.copyText), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])) : b("", !0)
              ], 512), [
                [be, W.value]
              ]),
              a("p", En, w(e.linkText), 1),
              a("span", Nn, [
                a("p", Wn, w(P.value), 1),
                D(t(se), {
                  onClick: Q[13] || (Q[13] = (ie) => U(ie, P.value)),
                  rounded: "",
                  class: "flex md:text-md gap-2 whitespace-nowrap text-[#ffffff] shrink px-3",
                  style: {
                    background: "#3A3CFF",
                    fontWeight: 400
                  },
                  "aria-label": "Copy video url"
                }, {
                  default: q(() => [
                    _(w(e.copyText), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            a("span", Rn, [
              a("input", {
                type: "checkbox",
                name: "embedCurrentTime",
                id: "embedCurrentTime",
                onInput: Y
              }, null, 32),
              a("p", zn, w(e.videoStartTimeText), 1),
              a("p", Vn, w(G.value), 1)
            ])
          ], 512)
        ])) : b("", !0)
      ]))
    ], 64));
  }
}, Di = /* @__PURE__ */ ne(Jn, [["__scopeId", "data-v-80d467da"]]), Pn = { class: "ml-auto" }, Un = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Gn = ["fill"], Zn = { key: 0 }, Kn = ["onClick"], Xn = {
  key: 1,
  class: "p-3 text-center"
}, Qn = {
  __name: "JDropdown",
  props: {
    modelValue: {
      default: null
    },
    options: {
      type: Array
    },
    placeholder: {
      type: String,
      default: "Select"
    },
    optionLabel: {
      type: String,
      default: "name"
    },
    optionValue: {
      type: String,
      default: "publicId"
    },
    optionId: {
      type: String,
      default: null
    },
    border: {
      type: Boolean,
      default: !0
    },
    buttonTextPadding: {
      type: String,
      default: "p-1"
    },
    optionsWrapperClass: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      required: !1
    },
    selectObject: {
      type: Boolean,
      default: !0
    },
    dropDownStyle: {
      type: Object,
      default: {
        color: "#334155",
        backgroundColor: "white"
      }
    }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: i }) {
    const o = e, c = i, s = C(!1), r = R(() => {
      var h;
      return ((h = o.options) == null ? void 0 : h.find(
        (f) => f[o.optionValue] === o.modelValue || o.optionId && f[o.optionId] === o.modelValue[o.optionId] || f === o.modelValue
      )) || null;
    }), y = R(() => r.value !== null && r.value !== void 0 ? r.value[o.optionLabel] : r.value);
    function d() {
      o.disabled || (s.value = !s.value);
    }
    function m(h) {
      let f;
      h[o.optionValue] !== null && h[o.optionValue] !== void 0 ? f = h[o.optionValue] : f = o.selectObject ? h : null, c("update:modelValue", f), c("change", f), s.value = !1;
    }
    const u = R(() => o.dropDownStyle.color === "#FFFFFF" || o.dropDownStyle.color === "#00000000" || o.dropDownStyle.color === "");
    return (h, f) => (l(), n("div", null, [
      fe(a("div", {
        onClick: f[0] || (f[0] = (p) => s.value = !1),
        class: "fixed inset-0 z-10 w-full h-full"
      }, null, 512), [
        [be, s.value]
      ]),
      a("div", {
        class: J(["relative text-sm sm:text-main border border-[#cdd8e7] rounded-lg", {
          "opacity-70": e.disabled
        }]),
        style: g({
          backgroundColor: e.dropDownStyle.backgroundColor
        })
      }, [
        a("a", {
          onClick: d,
          class: J(["relative flex w-full select-none items-center gap-1 px-3 min-w-[130px] md:min-w-[180px]", [e.buttonTextPadding, !e.disabled && "cursor-pointer"]])
        }, [
          K(h.$slots, "button-text", {}, () => [
            a("span", {
              class: "mr-1 truncate font-medium",
              style: g({
                color: u.value === !0 ? "#334155" : e.dropDownStyle.color
              })
            }, w(y.value || e.placeholder), 5),
            a("span", Pn, [
              (l(), n("svg", Un, [
                a("path", {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M6.46967 8.54262C6.76256 8.26367 7.23744 8.26367 7.53033 8.54262L10 10.8947L12.4697 8.54262C12.7626 8.26367 13.2374 8.26367 13.5303 8.54262C13.8232 8.82156 13.8232 9.27382 13.5303 9.55277L10.8839 12.0732C10.3957 12.5381 9.60427 12.5381 9.11612 12.0732L6.46967 9.55277C6.17678 9.27382 6.17678 8.82156 6.46967 8.54262Z",
                  fill: e.dropDownStyle.color
                }, null, 8, Gn)
              ]))
            ])
          ], !0)
        ], 2),
        a("div", {
          class: J(["shadow-md absolute w-full left-0 top-full border overflow-y-auto h-auto scroll max-h-[140px] z-20 mt-[5px] rounded-md", [e.optionsWrapperClass, !s.value && "hidden"]]),
          style: g({
            backgroundColor: e.dropDownStyle.backgroundColor
          })
        }, [
          K(h.$slots, "default", {}, () => [
            e.options.length ? (l(), n("ul", Zn, [
              (l(!0), n(X, null, re(e.options, (p, v) => (l(), n("li", {
                class: J(["px-2 py-1 cursor-pointer border-[#cdd8e7]] border-b", {
                  "bg-gray-300 font-medium ": p[e.optionValue] === e.modelValue || e.optionId && p[e.optionId] === e.modelValue[e.optionId] || p === e.modelValue
                }]),
                key: `${v}`,
                style: g({
                  color: p[e.optionValue] === e.modelValue || e.optionId && p[e.optionId] === e.modelValue[e.optionId] || p === e.modelValue ? u.value === !0 ? "#334155" : e.dropDownStyle.color : "#64748b"
                }),
                onClick: (S) => m(p)
              }, [
                K(h.$slots, "option", $e({ ref_for: !0 }, p), () => [
                  _(w(p[e.optionLabel] || p), 1)
                ], !0)
              ], 14, Kn))), 128))
            ])) : (l(), n("div", Xn, "No available options"))
          ], !0)
        ], 6)
      ], 6)
    ]));
  }
}, Qe = /* @__PURE__ */ ne(Qn, [["__scopeId", "data-v-8f7797a1"]]), Yn = {
  __name: "JFilmStrip",
  props: {
    src: {
      type: String,
      required: !1,
      default: null
    },
    switchTime: {
      type: Number,
      required: !1,
      default: 0.5
    }
  },
  setup(e) {
    const i = e, o = C("0 0 / 1000% 1000%"), c = C(null), s = C(null), r = C(null), y = C("hover:opacity-0!"), d = C(!1), m = C(null), u = C(!0), h = ($) => {
      $ && (d.value = !!$, m.value = `url(${$})`, y.value = null);
    }, f = () => {
      clearInterval(c.value);
    }, p = ($, N) => {
      o.value = `${$}% ${N}% / 500% 500%`;
    }, v = () => {
      let $ = 0, N = 0;
      c.value = setInterval(() => {
        p($, N), $ += 25, $ > 100 && ($ = 0, N += 25), N > 100 && (f(), y.value = "hover:opacity-0!");
      }, i.switchTime * 1e3);
    }, S = () => {
      if (u.value) {
        if (!i.src) {
          u.value = !1;
          return;
        }
        r.value = setTimeout(async () => {
          if (!d.value) {
            const $ = await xt(i.src);
            if (!$) {
              clearTimeout(r.value), u.value = !1;
              return;
            }
            h($);
          }
          y.value = null, p(0, 0), s.value = setTimeout(() => {
            v();
          }, 100);
        }, 600);
      }
    }, j = () => {
      u.value && (clearTimeout(s.value), clearTimeout(r.value), f(), y.value = "hover:opacity-0!");
    };
    return ($, N) => (l(), n("div", {
      class: J(["j-filmstrip cursor-pointer z-1 absolute top-0 right-0 left-0 bottom-0 opacity-0 hover:opacity-100 transition-opacity hover:delay-700", y.value]),
      onMouseenter: S,
      onMouseleave: j,
      style: g({ background: `${m.value} ${o.value}` })
    }, null, 38));
  }
}, Ai = {
  __name: "JFollowingMedia",
  props: {
    media: {
      type: Array,
      required: !0
    },
    callback: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    customWrapper: {
      type: String,
      required: !1,
      default: "RouterLink"
    },
    title: {
      type: String,
      required: !1,
      default: "Related videos"
    },
    breakpoint: {
      type: String,
      default: "desktop"
    },
    style: {
      type: Object,
      default: {}
    },
    titleStyle: {
      type: Object,
      default: {}
    },
    newItemText: {
      type: String,
      default: "New"
    }
  },
  setup(e) {
    const i = e, { media: o, callback: c, breakpoint: s } = ae(i);
    return R(() => s.value === "mobile").value, ke(() => {
      Le(() => {
        const y = document.querySelector("#load-more-related");
        Be(y, c.value);
      });
    }), (y, d) => (l(), n("div", {
      class: "j-content-grid flex flex-col",
      style: g(e.style)
    }, [
      e.title ? (l(), n("h3", {
        key: 0,
        style: g(e.titleStyle)
      }, w(e.title), 5)) : b("", !0),
      (l(!0), n(X, null, re(t(o), (m, u) => (l(), n("div", {
        class: "content-wrapper basis-full",
        key: u
      }, [
        K(y.$slots, "card", { card: m }, () => {
          var h, f;
          return [
            D(t(Xe), {
              class: J("pt-0 pb-2 px-2"),
              "card-style": m.style.style,
              order: m.style.order,
              "infobox-font-style": m.style.infoboxFontStyle,
              "infobox-style": m.style.infoboxStyle,
              "infobox-wrapper-style": m.style.infoboxWrapperStyle,
              "infobox-classes": m.style.infoboxClasses,
              "thumbnail-style": m.style.thumbnailStyle,
              "title-style": {
                lineHeight: "20px",
                overflow: " hidden",
                textOverflow: "ellipsis",
                whiteSpace: "normal",
                padding: 0,
                ...m.style.titleStyle
              },
              "show-title": m.style.showTitle,
              title: m.props.title,
              "show-author": m.style.showAuthor,
              author: m.props.author,
              "show-views": !1,
              views: "00K Views",
              "show-date": m.style.showDate,
              date: m.props.startDate,
              "show-thumbnail": m.style.showThumbnail,
              "show-time-duration": m.style.showTimeDuration,
              "time-duration": m.props.timeDuration,
              mediaid: m.props.mediaid,
              url: m.props.url,
              "custom-wrapper": m.props.isRedirect ? "a" : e.customWrapper,
              breakpoint: t(s),
              "show-parent-group": m.style.showParentGroup,
              "parent-group-style": m.style.parentGroupStyle,
              "parent-group-name": (h = m.props.parentGroup) == null ? void 0 : h.name,
              "parent-group-url": (f = m.props.parentGroup) == null ? void 0 : f.url,
              "show-progress-bar": m.style.showProgressBar,
              "progress-bar-config": m.style.progressBarStyle,
              "progress-bar-value": m.props.progressBarValue,
              "is-new": m.props.isNew,
              "new-item-text": e.newItemText
            }, {
              image: q(() => [
                K(y.$slots, "card-image", $e({ ref_for: !0 }, {
                  image: m.props.img,
                  style: m.style.imageStyle,
                  filmstrip: m.props.filmstrip,
                  isFilmstrip: m.style.isFilmstrip,
                  alt: m.props.title
                }), () => [
                  D(t(xe), {
                    imageSrc: m.props.img,
                    alt: m.props.title,
                    class: J(["w-full", [t(s)]]),
                    style: g(m.style.imageStyle)
                  }, null, 8, ["imageSrc", "alt", "class", "style"])
                ])
              ]),
              badge: q(() => [
                (l(!0), n(X, null, re(y.formatedBadges, (p, v) => (l(), n(X, null, [
                  p.classes ? (l(), F(t(Ee), {
                    key: v,
                    style: g(p.style),
                    class: J(p.classes)
                  }, {
                    default: q(() => [
                      _(w(p.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["style", "class"])) : b("", !0)
                ], 64))), 256))
              ]),
              _: 2
            }, 1032, ["card-style", "order", "infobox-font-style", "infobox-style", "infobox-wrapper-style", "infobox-classes", "thumbnail-style", "title-style", "show-title", "title", "show-author", "author", "show-date", "date", "show-thumbnail", "show-time-duration", "time-duration", "mediaid", "url", "custom-wrapper", "breakpoint", "show-parent-group", "parent-group-style", "parent-group-name", "parent-group-url", "show-progress-bar", "progress-bar-config", "progress-bar-value", "is-new", "new-item-text"])
          ];
        })
      ]))), 128)),
      d[0] || (d[0] = a("div", { id: "load-more-related" }, null, -1))
    ], 4));
  }
}, _n = {
  name: "jvp-footer",
  inheritAttrs: !1,
  customOptions: {}
};
function es(e, i, o, c, s, r) {
  return l(), n("div", $e(e.$attrs, {
    id: "j-footer",
    class: "j-footer w-full flex flex-wrap gap-4"
  }), [
    K(e.$slots, "default")
  ], 16);
}
const Hi = /* @__PURE__ */ ne(_n, [["render", es]]), Ei = {
  __name: "JFooterLabel",
  props: {
    data: {
      type: Object,
      default: {
        text: {
          type: String,
          default: ""
        }
      }
    },
    labelStyle: {
      type: Object,
      required: !1,
      default: {}
    }
  },
  setup(e) {
    const i = e, { text: o } = i.data;
    return (c, s) => (l(), n("div", $e(c.$attrs, {
      style: e.labelStyle,
      class: "p-4 md:pl-0 text-center md:text-left"
    }), w(t(o)), 17));
  }
}, ts = ["target", "aria-label", "href"], ls = {
  __name: "JFooterMenuItem",
  props: {
    menu: {
      type: Array,
      required: !1,
      default: []
    },
    style: {
      type: Object,
      default: {}
    }
  },
  setup(e) {
    const i = e;
    function o(r) {
      var y = /^javascript/;
      return y.test(r);
    }
    const { menu: c, orientation: s } = i;
    return (r, y) => {
      const d = We("RouterLink"), m = We("JFooterMenuItem", !0);
      return l(), n("ol", {
        class: J(["flex flex-wrap gap-4 text-sm", e.style.orientation === "horizontal" ? "flex-row" : "flex-col"]),
        style: g(e.style)
      }, [
        (l(!0), n(X, null, re(t(c), (u) => (l(), n("li", {
          class: "menu-item list-none",
          key: u.url
        }, [
          u ? (l(), n(X, { key: 0 }, [
            u.itemTypeId === 1 || u.itemLinkTypeId === 2 ? (l(), F(d, {
              to: u.url,
              key: u.url,
              "aria-label": u.navigationLabel,
              class: "cursor-pointer item"
            }, {
              default: q(() => [
                _(w(u.navigationLabel), 1)
              ]),
              _: 2
            }, 1032, ["to", "aria-label"])) : u.itemTypeId === 2 ? (l(), n("a", {
              target: o(u.url) ? null : "_blank",
              key: "external" + u.url,
              "aria-label": u.navigationLabel,
              href: u.url,
              class: "cursor-pointer item"
            }, w(u.navigationLabel), 9, ts)) : (l(), n("div", {
              key: "label" + u.url
            }, w(u.navigationLabel), 1)),
            u.childItems ? (l(), F(m, {
              key: 3,
              menu: u.childItems,
              orientation: t(s),
              style: g(e.style)
            }, null, 8, ["menu", "orientation", "style"])) : b("", !0)
          ], 64)) : b("", !0)
        ]))), 128))
      ], 6);
    };
  }
}, as = {
  key: 0,
  class: "mb-6"
}, os = {
  __name: "JFooterMenu",
  props: {
    data: {
      type: Object,
      default: {
        title: {
          type: String,
          default: ""
        },
        menu: {
          type: Array,
          default: []
        }
      }
    },
    style: {
      type: Object,
      default: {
        wrapperStyle: {},
        titleStyle: {},
        itemsStyle: {}
      }
    },
    menuItems: {
      type: Array,
      default: null
    }
  },
  setup(e) {
    return (i, o) => {
      var c, s, r, y;
      return l(), n("div", {
        class: "p-4 pt-0! md:pl-0! j-footer-menu",
        style: g(e.style.wrapperStyle)
      }, [
        e.data.title ? (l(), n("div", as, [
          a("h5", {
            style: g(e.style.titleStyle)
          }, w(e.data.title), 5)
        ])) : b("", !0),
        (l(), F(ls, {
          key: `${(c = e.menuItems) == null ? void 0 : c.length}-${(y = (r = (s = e.data) == null ? void 0 : s.menu) == null ? void 0 : r.items) == null ? void 0 : y.length}`,
          menu: e.menuItems || e.data.menu.items,
          style: g(e.style.itemsStyle)
        }, null, 8, ["menu", "style"]))
      ], 4);
    };
  }
}, Ni = /* @__PURE__ */ ne(os, [["__scopeId", "data-v-2ec0474f"]]), ns = ["aria-label", "href"], Wi = {
  __name: "JFooterImage",
  props: {
    data: {
      type: Object,
      default: {
        image: {
          type: String,
          default: ""
        }
      }
    },
    style: {
      type: Object,
      required: !1
    }
  },
  setup(e) {
    const i = e, { image: o, altText: c, clickable: s, link: r, title: y } = ae(i.data), { style: d } = ae(i), m = (f) => f ? f.type === "px" || f.type === "%" ? `${f.value}${f.type}` : `${f.type}` : "", u = (f) => f ? f.type === "px" || f.type === "%" ? `${f.value}${f.type}` : `${f.type}` : "", h = R(() => {
      var f, p;
      return {
        width: u((f = d.value) == null ? void 0 : f.width),
        height: m((p = d.value) == null ? void 0 : p.height)
      };
    });
    return R(() => {
      var f, p, v, S, j, $, N, k, M, x, T, O, E, I, A, le, Z, W, B, L, H, V, U;
      return {
        fontSize: `${(v = (p = (f = d.value) == null ? void 0 : f.captionStyle) == null ? void 0 : p.fontStyle) == null ? void 0 : v.weight}`,
        fontWeight: `${($ = (j = (S = d.value) == null ? void 0 : S.captionStyle) == null ? void 0 : j.fontStyle) == null ? void 0 : $.weight}`,
        fontFamily: `${(M = (k = (N = d.value) == null ? void 0 : N.captionStyle) == null ? void 0 : k.fontStyle) == null ? void 0 : M.family}`,
        fontStyle: `${(O = (T = (x = d.value) == null ? void 0 : x.captionStyle) == null ? void 0 : T.fontStyle) == null ? void 0 : O.style}`,
        color: `${(A = (I = (E = d.value) == null ? void 0 : E.captionStyle) == null ? void 0 : I.fontStyle) == null ? void 0 : A.color}`,
        padding: `${(Z = (le = d.value) == null ? void 0 : le.captionStyle) == null ? void 0 : Z.padding.top}px ${(B = (W = d.value) == null ? void 0 : W.captionStyle) == null ? void 0 : B.padding.right}px ${(H = (L = d.value) == null ? void 0 : L.captionStyle) == null ? void 0 : H.padding.left}px ${(U = (V = d.value) == null ? void 0 : V.captionStyle) == null ? void 0 : U.padding.bottom}px`
      };
    }), (f, p) => {
      const v = We("router-link");
      return l(), n("div", {
        class: "j-footer",
        style: g(h.value)
      }, [
        _(w(t(y)) + " ", 1),
        t(s) ? (l(), n(X, { key: 0 }, [
          e.data.linkType === 1 ? (l(), n("a", {
            key: 0,
            class: "cursor-pointer flex",
            target: "_blank",
            "aria-label": t(c),
            href: `https://${e.data.imgTo}`
          }, [
            D(t(st), {
              "image-src": t(o),
              alt: t(c)
            }, null, 8, ["image-src", "alt"])
          ], 8, ns)) : e.data.linkType === 2 ? (l(), F(v, {
            key: 1,
            to: e.data.imgTo ? e.data.imgTo : "/not-set",
            class: "cursor-pointer flex"
          }, {
            default: q(() => [
              D(t(st), {
                "image-src": t(o),
                alt: t(c)
              }, null, 8, ["image-src", "alt"])
            ]),
            _: 1
          }, 8, ["to"])) : b("", !0)
        ], 64)) : (l(), F(t(st), {
          key: 1,
          "image-src": t(o),
          alt: t(c)
        }, null, 8, ["image-src", "alt"]))
      ], 4);
    };
  }
}, ss = {}, rs = { class: "j-footer-sceleton w-full" };
function is(e, i) {
  return l(), n("div", rs, i[0] || (i[0] = [
    a("div", { class: "card w-full is-loading" }, [
      a("div", { class: "image" }),
      a("div", { class: "content" }, [
        a("h2"),
        a("p")
      ])
    ], -1)
  ]));
}
const Ri = /* @__PURE__ */ ne(ss, [["render", is]]), us = { class: "" }, cs = {
  __name: "JHeaderSidebar",
  props: {
    icon: {
      type: Object,
      default: {
        color: "",
        size: "18",
        name: ""
      }
    },
    style: {
      type: Object,
      default: {}
    },
    wrapperStyle: {
      type: Object,
      default: {}
    },
    wrapperClass: {
      type: String,
      default: "w-[80%]"
    },
    fixedWrapperClass: {
      type: String,
      default: "fixed"
    },
    headerClass: {
      type: String,
      default: ""
    },
    isOpen: {
      type: Boolean,
      required: !0
    },
    onToggle: {
      type: Function,
      required: !0
    },
    onOpen: {
      type: Function,
      default: () => {
      },
      required: !1
    },
    onClose: {
      type: Function,
      default: () => {
      },
      required: !1
    },
    slideDirection: {
      type: String,
      default: "right"
    },
    isShown: {
      type: Boolean,
      default: !0
    },
    isReactive: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const i = e, o = C(0), c = C(null);
    function s() {
      i.onOpen() || (i.onToggle(), i.isReactive && o.value++);
    }
    function r() {
      i.onClose();
    }
    const d = Fe(c, (m) => {
      d.isClickOutside(m, c) && r();
    });
    return (m, u) => (l(), n("div", {
      ref_key: "sidebarRef",
      ref: c
    }, [
      a("div", {
        onClick: u[0] || (u[0] = (h) => s()),
        style: g(e.style)
      }, [
        K(m.$slots, "button", {}, void 0, !0)
      ], 4),
      a("div", {
        class: J(["h-screen top-0 bg-white p-3 overflow-y-auto scroll", [
          e.fixedWrapperClass,
          e.isOpen ? `nav-open-${e.slideDirection}` : `nav-close-${e.slideDirection}`,
          e.slideDirection === "right" ? "left-0" : "right-0",
          { hidden: o.value === 0 }
        ]]),
        style: g({
          ...e.wrapperStyle,
          width: e.wrapperStyle.menuWidth
        })
      }, [
        a("div", {
          class: J(["w-full justify-between my-3 gap-5 items-center flex", e.headerClass])
        }, [
          a("div", us, [
            K(m.$slots, "header", {}, void 0, !0)
          ]),
          a("div", {
            onClick: u[1] || (u[1] = (h) => r())
          }, [
            K(m.$slots, "header-close", {}, () => [
              D(t(oe), { "ikone-name": "vpapps-font-close-cancel" })
            ], !0)
          ])
        ], 2),
        K(m.$slots, "default", {}, void 0, !0)
      ], 6)
    ], 512));
  }
}, ct = /* @__PURE__ */ ne(cs, [["__scopeId", "data-v-414e7623"]]), ds = { class: "j-submenu-wrapper submenu-parent" }, fs = { class: "menu-wrapper" }, ys = ["value"], ps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 8 6",
  fill: "none"
}, ms = ["fill"], vs = {
  class: "j-language-item flex items-center text-sm font-medium cursor-pointer whitespace-pre p-3 row-menu-item",
  value: "1"
}, gs = ["href", "aria-label"], hs = {
  __name: "JHeaderSubMenuItem",
  props: {
    label: {
      type: String,
      default: {
        color: "#FFF",
        size: "18",
        name: ""
      }
    },
    childItems: {
      type: Array,
      required: !1,
      default: "RouterLink"
    },
    firstLevel: {
      type: Boolean,
      required: !1,
      default: !1
    },
    parentLevel: {
      type: [Number],
      required: !1,
      default: "none"
    },
    icons: {
      type: Object,
      required: !1,
      default: () => ({
        props: {
          name: "vpapps-font-align-lines-left",
          size: 18
        },
        style: {
          size: "18px",
          color: "black"
        }
      })
    }
  },
  setup(e) {
    const i = e, { parentLevel: o, firstLevel: c } = ae(i), s = C(!1), r = (u) => {
      s.value ? d() : y();
    }, y = (u) => {
      s.value = !0;
    }, d = () => {
      s.value = !1;
    }, m = (u, h, f) => {
      if (h.relatedTarget && document.querySelector(`.menu-level-${h.relatedTarget.value}`) !== document.querySelector(`.menu-level-${u}`) && Le(() => {
        document.querySelector(`.menu-level-${u}`).focus(), document.querySelector(`.menu-level-${u}`).blur();
      }), !f && !h.relatedTarget) {
        document.querySelector(`.menu-level-${u}`).focus(), document.querySelector(`.menu-level-${u}`).blur();
        return;
      }
      (!h.relatedTarget || !h.relatedTarget.classList.contains("menu-related")) && d();
    };
    return (u, h) => {
      const f = We("RouterLink"), p = We("JHeaderSubMenuItem", !0);
      return l(), n("div", ds, [
        a("div", fs, [
          a("button", {
            class: J(["icon menu-btn icon-holder flex items-center justify-between menu-related", [
              t(c) ? null : "p-3 level-hover",
              `menu-level-${t(o)}`
            ]]),
            value: t(o),
            "aria-label": "Submenu",
            onKeydown: _e(d, ["esc"]),
            onBlur: h[0] || (h[0] = (v) => m(t(o), v, t(c))),
            onClick: h[1] || (h[1] = (v) => r(t(o)))
          }, [
            _(w(e.label) + " ", 1),
            a("span", {
              class: J([
                "dropdown-icon ml-3",
                s.value ? t(c) ? "active" : "half-active" : null
              ])
            }, [
              (l(), n("svg", ps, [
                a("path", {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M0.46967 4.80895C0.762563 5.08789 1.23744 5.08789 1.53033 4.80895L4 2.45688L6.46967 4.80895C6.76256 5.08789 7.23744 5.08789 7.53033 4.80895C7.82322 4.53 7.82322 4.07774 7.53033 3.79879L4.88388 1.27837C4.39573 0.81346 3.60427 0.81346 3.11612 1.27837L0.46967 3.79879C0.176777 4.07774 0.176777 4.53 0.46967 4.80895Z",
                  fill: e.icons.style.color ? e.icons.style.color : "#333"
                }, null, 8, ms)
              ]))
            ], 2)
          ], 42, ys),
          D(at, { name: "fade" }, {
            default: q(() => [
              s.value ? (l(), n("div", {
                key: 0,
                class: J(["j-submenu-dropdown-wrapper flex flex-col", t(c) ? null : "multilevel"])
              }, [
                (l(!0), n(X, null, re(e.childItems, (v) => {
                  var S;
                  return l(), n(X, null, [
                    (S = v.childItems) != null && S.length ? (l(), F(p, {
                      label: v.navigationLabel,
                      childItems: v.childItems,
                      "parent-level": t(o),
                      key: v.navigationLabel,
                      icons: e.icons
                    }, null, 8, ["label", "childItems", "parent-level", "icons"])) : (l(), n(X, { key: 0 }, [
                      v.itemTypeId === 3 ? (l(), n("div", {
                        class: "row-menu-item p-3",
                        key: v.navigationLabel
                      }, w(v.navigationLabel), 1)) : v.itemTypeId === 1 || v.itemLinkTypeId === 2 ? (l(), F(f, {
                        to: v.url ? v.url : "not-set",
                        key: v.navigationLabel,
                        "aria-label": v.navigationLabel
                      }, {
                        default: q(() => [
                          a("li", vs, w(v.navigationLabel), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "aria-label"])) : v.itemTypeId === 2 ? (l(), n("a", {
                        class: "cursor-pointer item p-3 row-menu-item",
                        href: v.url,
                        key: v.navigationLabel,
                        target: "_blank",
                        "aria-label": v.navigationLabel
                      }, w(v.navigationLabel), 9, gs)) : v.itemTypeId === 4 ? (l(), n("div", {
                        class: "p-3 row-menu-item",
                        key: v.navigationLabel
                      }, w(v.navigationLabel), 1)) : b("", !0)
                    ], 64))
                  ], 64);
                }), 256))
              ], 2)) : b("", !0)
            ]),
            _: 1
          })
        ])
      ]);
    };
  }
}, bs = ["href"], ws = {
  __name: "JHeaderMenuItems",
  props: {
    menuItems: {
      type: Array,
      required: !0
    },
    style: {
      type: Object,
      default: {}
    },
    icons: {
      type: Object,
      required: !1,
      default: () => ({
        props: {
          name: "vpapps-font-align-lines-left",
          size: 18
        },
        style: {
          size: "18px",
          color: "black"
        }
      })
    }
  },
  emits: ["closeSideBar"],
  setup(e, { emit: i }) {
    const o = e, { style: c, menuItems: s } = ae(o), r = (f) => {
      f.target.style.color = c.value.colorOnHover;
    }, y = (f) => {
      f.target.style.color = c.value.color;
    }, d = (f) => {
      f.target.style.color = c.value.colorOnActive;
    }, m = (f) => {
      f.target.style.color = c.value.color;
    }, u = i;
    function h() {
      u("closeSideBar");
    }
    return (f, p) => {
      const v = We("RouterLink");
      return l(), n("ul", $e(f.$attrs, { style: t(c) }), [
        (l(!0), n(X, null, re(t(s), (S, j) => {
          var $;
          return l(), n("li", {
            class: J(["menu-item", "parent-level-" + j]),
            key: "menu-item-" + S.id
          }, [
            ($ = S.childItems) != null && $.length ? (l(), F(hs, {
              key: 1,
              label: S.navigationLabel,
              childItems: S.childItems,
              firstLevel: "",
              "parent-level": j,
              onClick: h,
              icons: e.icons
            }, null, 8, ["label", "childItems", "parent-level", "icons"])) : (l(), n(X, { key: 0 }, [
              S.itemTypeId === 1 || S.itemLinkTypeId === 2 ? (l(), F(v, {
                key: 0,
                to: S.url ? S.url : "not-set",
                "aria-label": "HeaderInternalLink",
                onMouseenter: r,
                onMouseleave: y,
                onMousedown: d,
                onMouseup: m,
                onClick: h
              }, {
                default: q(() => [
                  _(w(S.navigationLabel), 1)
                ]),
                _: 2
              }, 1032, ["to"])) : S.itemTypeId === 2 ? (l(), n("a", {
                key: 1,
                class: "cursor-pointer item",
                href: S.url,
                "aria-label": "HeaderExternalLink",
                target: "_blank",
                onMouseenter: r,
                onMouseleave: y,
                onMousedown: d,
                onMouseup: m,
                onClick: h
              }, w(S.navigationLabel), 41, bs)) : (l(), n("div", {
                key: 2,
                onMouseenter: r,
                onMouseleave: y,
                onMousedown: d,
                onMouseup: m,
                onClick: h
              }, w(S.navigationLabel), 33))
            ], 64))
          ], 2);
        }), 128))
      ], 16);
    };
  }
}, $t = /* @__PURE__ */ ne(ws, [["__scopeId", "data-v-4e985e16"]]), xs = ["width", "height", "src"], ks = {
  __name: "JHeaderMenu",
  props: {
    breakpoint: {
      type: String,
      required: !0
    },
    data: {
      type: Object,
      required: !0
    },
    isOpen: {
      type: Boolean,
      required: !0
    },
    onToggle: {
      type: Function,
      required: !0
    },
    onMenuOpen: {
      type: Function,
      default: () => {
      },
      required: !1
    },
    onMenuClose: {
      type: Function,
      default: () => {
      },
      required: !1
    },
    menuItems: {
      type: Array,
      default: []
    },
    logo: {
      type: Object,
      default: null
    },
    isShown: {
      type: Boolean,
      default: !0
    },
    fixedWrapperClass: {
      type: String,
      default: "fixed"
    },
    logoStyle: {
      type: Object,
      required: !1,
      default: {
        width: 150,
        height: 0
      }
    },
    icons: {
      type: Object,
      required: !1,
      default: () => ({
        props: {
          name: "vpapps-font-align-lines-left",
          size: 18
        },
        style: {
          size: "18px",
          color: "black"
        }
      })
    },
    isNestedComponent: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["closeSideBar"],
  setup(e, { emit: i }) {
    const o = e, c = i, { breakpoint: s, data: r, icons: y, onToggle: d, isOpen: m, isNestedComponent: u } = ae(o), h = R(() => f.value ? he(ct) : "div"), f = R(
      () => (s.value === "mobile" || r.value.props.layout === "burger") && !u.value
    ), p = R(() => ({
      ...r.value.style.fontStyle,
      gap: r.value.style.gap,
      alignItems: r.value.style.alignItems
    })), v = (k) => {
      var M;
      k.target.style.color = y.value.style.colorOnHover, k.target.style.backgroundColor = (M = y.value.style) == null ? void 0 : M.backgroundColorOnHover;
    }, S = (k) => {
      var M;
      k.target.style.color = y.value.style.color, k.target.style.backgroundColor = (M = y == null ? void 0 : y.value.style) == null ? void 0 : M.backgroundColor;
    }, j = (k) => {
      var M;
      k.target.style.color = (M = y.value.style) == null ? void 0 : M.colorOnActive;
    }, $ = (k) => {
      var M;
      k.target.style.color = (M = y.value.style) == null ? void 0 : M.color;
    }, N = () => {
      d.value(!1), c("closeSideBar");
    };
    return (k, M) => (l(), F(ge(h.value), {
      "is-open": t(m),
      "on-toggle": t(d),
      "on-open": e.onMenuOpen,
      "on-close": e.onMenuClose,
      "slide-direction": t(r).props.slideDirection,
      "fixed-wrapper-class": e.fixedWrapperClass,
      "is-shown": e.isShown,
      "wrapper-class": `w-[${t(r).style.menuWidth || 100}%]`,
      style: g(t(r).style),
      class: "j-header-menu cursor-pointer",
      "wrapper-style": t(r).style,
      icon: { size: 18, color: p.value.color }
    }, Mt({
      button: q(() => [
        D(t(oe), {
          "ikone-name": t(y).props.name,
          "ikone-style": t(y).style,
          onMouseenter: v,
          onMouseleave: S,
          onMousedown: j,
          onMouseup: $
        }, null, 8, ["ikone-name", "ikone-style"])
      ]),
      default: q(() => [
        D($t, {
          class: J(["flex", f.value || t(u) ? "flex-col" : "flex-row"]),
          "menu-items": e.menuItems,
          style: g(p.value),
          icons: t(y),
          onCloseSideBar: N
        }, null, 8, ["menu-items", "class", "style", "icons"])
      ]),
      _: 2
    }, [
      e.logo ? {
        name: "header",
        fn: q(() => [
          (l(), F(ge(e.logo.customWrapper || "RouterLink"), {
            class: "w-full m-auto pointer",
            to: e.logo.url || "",
            href: e.logo.url || "",
            target: e.logo.customWrapper === "a" ? "_blank" : null
          }, {
            default: q(() => {
              var x, T;
              return [
                e.logo.source ? (l(), n("img", {
                  key: 0,
                  width: ((x = e.logo) == null ? void 0 : x.width) || e.logoStyle.width,
                  height: ((T = e.logo) == null ? void 0 : T.height) || e.logoStyle.height,
                  src: e.logo.source,
                  alt: "logo"
                }, null, 8, xs)) : b("", !0)
              ];
            }),
            _: 1
          }, 8, ["to", "href", "target"]))
        ]),
        key: "0"
      } : void 0
    ]), 1064, ["is-open", "on-toggle", "on-open", "on-close", "slide-direction", "fixed-wrapper-class", "is-shown", "wrapper-class", "style", "wrapper-style", "icon"]));
  }
}, Ss = { key: 0 }, dt = {
  __name: "JHeaderDropdown",
  props: {
    isOpen: {
      type: Boolean,
      required: !0
    },
    style: {
      type: Object,
      default: {}
    },
    wrapperClass: {
      type: String,
      default: ""
    },
    onToggle: {
      type: Function,
      required: !0
    },
    onOpen: {
      type: Function,
      default: () => {
      },
      required: !1
    },
    onClose: {
      type: Function,
      default: () => {
      },
      required: !1
    },
    style: {
      type: Object,
      default: {}
    }
  },
  setup(e) {
    const i = e, o = C(null);
    function c() {
      i.onOpen() || i.onToggle();
    }
    function s() {
      i.onClose();
    }
    const y = Fe(o, (d) => {
      y.isClickOutside(d, o) && s();
    });
    return (d, m) => (l(), n("div", {
      style: g(e.style),
      ref_key: "headerDropdownRef",
      ref: o
    }, [
      a("div", {
        onClick: m[0] || (m[0] = (u) => c())
      }, [
        K(d.$slots, "button")
      ]),
      D(at, { name: "fade" }, {
        default: q(() => [
          e.isOpen ? (l(), n("div", Ss, [
            K(d.$slots, "default")
          ])) : b("", !0)
        ]),
        _: 3
      })
    ], 4));
  }
}, Cs = { class: "flex gap-1 items-center" }, $s = { key: 1 }, Ts = {
  key: 0,
  class: "j-language-dropdown-wrapper"
}, Os = {
  __name: "JHeaderLanguage",
  props: {
    data: {
      type: Object,
      required: !0
    },
    notificationData: {
      type: Array,
      required: !1,
      default: null
    },
    isOpen: {
      type: Boolean,
      required: !0
    },
    onToggle: {
      type: Function,
      required: !0
    },
    onOpen: {
      type: Function,
      default: () => {
      },
      required: !1
    },
    onClose: {
      type: Function,
      default: () => {
      },
      required: !1
    },
    icons: {
      type: Object,
      required: !1,
      default: () => ({
        props: {
          name: "vpapps-font-align-lines-left",
          size: 18
        },
        style: {
          size: "18px",
          color: "black"
        }
      })
    }
  },
  emits: ["customEvent"],
  setup(e, { emit: i }) {
    const o = e, { data: c, icons: s } = ae(o), r = i;
    function y(f) {
      r("customEvent", { type: "search-option-click", event: f });
    }
    const d = (f) => {
      f.target.style.color = s.value.style.colorOnHover, f.target.style.backgroundColor = s.value.style.backgroundColorOnHover;
    }, m = (f) => {
      var p;
      f.target.style.color = s.value.style.color, f.target.style.backgroundColor = (p = s.value.style) == null ? void 0 : p.backgroundColor;
    }, u = (f) => {
      f.target.style.color = s.value.style.colorOnActive;
    }, h = (f) => {
      f.target.style.color = s.value.style.color;
    };
    return (f, p) => (l(), F(dt, {
      "is-open": e.isOpen,
      "on-toggle": e.onToggle,
      "on-open": e.onOpen,
      "on-close": e.onClose,
      class: "j-header-language relative",
      style: g(t(c).props.style),
      icon: t(c).icon.style
    }, {
      button: q(() => [
        a("div", Cs, [
          t(c).props.type === "text" || t(c).props.type === "icon-text" ? (l(), n("div", {
            key: 0,
            style: g(t(c).style.fontStyle)
          }, w(t(c).props.text), 5)) : b("", !0),
          t(c).props.type === "icon" || t(c).props.type === "icon-text" ? (l(), n("div", $s, [
            D(t(oe), {
              "ikone-name": t(s).props.name,
              "ikone-style": t(s).style,
              onMouseenter: d,
              onMouseleave: m,
              onMousedown: u,
              onMouseup: h
            }, null, 8, ["ikone-name", "ikone-style"])
          ])) : b("", !0)
        ])
      ]),
      default: q(() => [
        e.isOpen ? (l(), n("div", Ts, [
          a("li", {
            class: "j-language-item flex items-center text-xs font-normal cursor-pointer",
            onClick: y,
            value: "1"
          }, p[0] || (p[0] = [
            a("span", null, null, -1),
            _(" English ")
          ])),
          a("li", {
            class: "j-language-item flex items-center text-xs font-normal cursor-pointer",
            onClick: y,
            value: "2"
          }, p[1] || (p[1] = [
            a("span", null, null, -1),
            _(" Shqip ")
          ])),
          a("li", {
            class: "j-language-item flex items-center text-xs font-normal cursor-pointer",
            onClick: y,
            value: "3"
          }, p[2] || (p[2] = [
            a("span", null, null, -1),
            _(" Czech ")
          ]))
        ])) : b("", !0)
      ]),
      _: 1
    }, 8, ["is-open", "on-toggle", "on-open", "on-close", "style", "icon"]));
  }
}, qs = /* @__PURE__ */ ne(Os, [["__scopeId", "data-v-5f8b231d"]]);
function js(e) {
  const i = /* @__PURE__ */ new Date(), o = new Date(e), c = new Intl.RelativeTimeFormat("cs", {
    localeMatcher: "best fit",
    // other values: "lookup"
    numeric: "always",
    // other values: "auto"
    style: "long"
    // other values: "short" or "narrow"
  }), s = i.getTime() - o.getTime();
  return s < 60 * 1e3 ? c.format(-Math.floor(s / 1e3), "second") : s < 60 * 60 * 1e3 ? c.format(-Math.floor(s / (60 * 1e3)), "minute") : s < 24 * 60 * 60 * 1e3 ? c.format(-Math.floor(s / (60 * 60 * 1e3)), "hour") : s < 7 * 24 * 60 * 60 * 1e3 ? c.format(-Math.floor(s / (24 * 60 * 60 * 1e3)), "day") : s < 30 * 24 * 60 * 60 * 1e3 ? c.format(-Math.floor(s / (7 * 24 * 60 * 60 * 1e3)), "week") : s < 365 * 24 * 60 * 60 * 1e3 ? c.format(-Math.floor(s / (30 * 24 * 60 * 60 * 1e3)), "month") : c.format(-Math.floor(s / (365 * 24 * 60 * 60 * 1e3)), "year");
}
const Ms = { class: "flex gap-1 items-center" }, Is = { key: 1 }, Bs = { class: "flex items-center cursor-pointer gap-3" }, Fs = { class: "text-black" }, Ls = {
  key: 0,
  class: "notification-wrapper-title flex mb-1 justify-between"
}, Ds = {
  key: 1,
  class: "w-[95%] mt-4 h-px bg-slate-700 mx-auto"
}, As = ["value"], Hs = { class: "w-[60px] h-[50px] mr-2 mt-1" }, Es = { class: "w-full flex flex-col gap-1" }, Ns = { class: "notification-date flex justify-start text-sm font-medium breakword" }, Ws = { class: "notification-text text-left font-normal breakword" }, Rs = { class: "notification-date flex justify-start text-xs text-gray-600 leading-4" }, zs = {
  __name: "JHeaderNotifications",
  props: {
    data: {
      type: Object,
      required: !0
    },
    notificationData: {
      type: Array,
      required: !1,
      default: null
    },
    isOpen: {
      type: Boolean,
      required: !0
    },
    onToggle: {
      type: Function,
      required: !0
    },
    onOpen: {
      type: Function,
      default: () => {
      },
      required: !1
    },
    onClose: {
      type: Function,
      default: () => {
      },
      required: !1
    },
    icons: {
      type: Object,
      required: !1,
      default: () => ({
        props: {
          name: "vpapps-font-notification-alert",
          size: 18
        },
        style: {
          size: "18px",
          color: "black"
        }
      })
    },
    loadCallback: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    customWrapper: {
      type: String,
      required: !1,
      default: "RouterLink"
    },
    onNotificationReadCallback: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    breakpoint: {
      type: String,
      required: !0
    },
    isReactive: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["openNav"],
  setup(e, { emit: i }) {
    const o = e, {
      notificationData: c,
      loadCallback: s,
      onNotificationReadCallback: r,
      breakpoint: y,
      data: d,
      icons: m
    } = ae(o), u = R(() => y.value === "mobile"), h = R(() => y.value === "mobile" ? he(ct) : he(dt)), f = R(
      () => {
        var $;
        return (($ = c == null ? void 0 : c.value) == null ? void 0 : $.length) || "";
      }
    );
    ke(() => {
      Le(() => {
        const $ = document.querySelector("#load-more-notifications");
        s && s.value && $ && Be($, s.value);
      });
    });
    const p = ($) => {
      var N;
      $.target.style.color = m.value.style.colorOnHover, $.target.style.backgroundColor = (N = m.value.style) == null ? void 0 : N.backgroundColorOnHover;
    }, v = ($) => {
      var N;
      $.target.style.color = m.value.style.color, $.target.style.backgroundColor = (N = m.value.style) == null ? void 0 : N.backgroundColor;
    }, S = ($) => {
      var N;
      $.target.style.color = (N = m.value.style) == null ? void 0 : N.colorOnActive;
    }, j = ($) => {
      var N;
      $.target.style.color = (N = m.value.style) == null ? void 0 : N.color;
    };
    return ($, N) => (l(), F(ge(h.value), {
      "is-open": e.isOpen,
      "on-toggle": e.onToggle,
      "on-open": e.onOpen,
      "on-close": e.onClose,
      "slide-direction": t(d).props.slideDirection,
      "wrapper-class": "w-full",
      class: "j-header-notifications relative cursor-pointer",
      "header-class": "flex-row-reverse",
      style: g(t(d).style),
      icon: t(d).icon.style,
      "is-reactive": e.isReactive
    }, {
      button: q(() => [
        a("div", Ms, [
          t(d).props.type === "text" || t(d).props.type === "icon-text" ? (l(), n("div", {
            key: 0,
            style: g(t(d).style.fontStyle)
          }, w(t(d).props.text), 5)) : b("", !0),
          t(d).props.type === "icon" || t(d).props.type === "icon-text" ? (l(), n("div", Is, [
            D(t(oe), {
              "ikone-name": t(m).props.name,
              "ikone-style": t(m).style,
              onMouseenter: p,
              onMouseleave: v,
              onMousedown: S,
              onMouseup: j
            }, null, 8, ["ikone-name", "ikone-style"])
          ])) : b("", !0)
        ])
      ]),
      header: q(() => [
        a("a", {
          class: "pr-3 text-sm flex items-center text-[#455A82] cursor-pointer",
          onClick: N[0] || (N[0] = (k) => t(r)(""))
        }, " Označit vše jako zobrazené ")
      ]),
      "header-close": q(() => [
        a("a", Bs, [
          D(t(oe), { "ikone-name": "vpapps-font-chevron-line-left" }),
          a("span", Fs, "Notifikace " + w(f.value), 1)
        ])
      ]),
      default: q(() => {
        var k;
        return [
          fe(a("div", {
            class: J(u.value ? "" : "notification-suggestion-wrapper scroll")
          }, [
            u.value ? b("", !0) : (l(), n("div", Ls, [
              N[2] || (N[2] = a("div", { class: "title-name font-semibold text-sm" }, "Vaše notifikace", -1)),
              a("div", {
                class: "title-action font-normal text-xs pointer",
                onClick: N[1] || (N[1] = (M) => t(r)(""))
              }, " Označit vše jako zobrazené ")
            ])),
            u.value ? (l(), n("div", Ds)) : b("", !0),
            (k = t(c)) != null && k.length ? b("", !0) : (l(), n("div", {
              key: 2,
              class: J([u.value ? "mt-28" : "my-4", "flex flex-col w-full justify-center items-center"])
            }, N[3] || (N[3] = [
              a("img", {
                src: "https://agmipoby.blob.gjirafa.tech/Group%201000002592.png",
                alt: "",
                class: "mb-4"
              }, null, -1),
              a("p", { class: "text-sm pb-1 text-[#36435E] font-medium" }, " Nemáte žádné notifikace ", -1),
              a("p", { class: "text-xs px-5 text-center text-[#6E7B95]" }, " Upozorníme vás, jakmile se objeví něco nového. ", -1)
            ]), 2)),
            (l(!0), n(X, null, re(t(c), (M, x) => (l(), n("li", {
              class: J(["notification-list-item w-full leading-4", [
                u.value ? "w-full" : "mb-3",
                M.read ? "" : "notification-unread"
              ]]),
              key: x,
              value: M.source
            }, [
              a("div", {
                class: J(["m-0 flex", u.value ? "gap-4" : ""])
              }, [
                (l(), F(ge(e.customWrapper), {
                  class: "flex flex-row",
                  to: M.source,
                  onClick: (T) => t(r)(M.id)
                }, {
                  default: q(() => [
                    a("div", {
                      class: J(["suggestion-img-holder relative pl-1", [M.read ? null : "new", u.value ? "pl-2 " : ""]])
                    }, [
                      a("div", Hs, [
                        D(t(xe), {
                          alt: "notification-img",
                          "image-src": M.img,
                          class: J(
                            u.value ? "w-full min-h-[60px] max-h-[60px] min-w-[70px] max-w-[70px]  mx-auto rounded-md" : "w-full min-h-[50px] max-h-[50px] min-w-[60px] max-w-[60px]  mx-auto rounded-md"
                          )
                        }, null, 8, ["image-src", "class"])
                      ])
                    ], 2),
                    a("div", {
                      class: J(u.value ? "pl-4" : "  px-2")
                    }, [
                      a("div", Es, [
                        a("p", Ns, w(M.name), 1),
                        a("h5", Ws, w(M.text), 1),
                        a("p", Rs, w(t(js)(M.date)), 1)
                      ])
                    ], 2)
                  ]),
                  _: 2
                }, 1032, ["to", "onClick"]))
              ], 2)
            ], 10, As))), 128)),
            N[4] || (N[4] = a("div", { id: "load-more-notifications" }, null, -1))
          ], 2), [
            [be, e.isOpen]
          ])
        ];
      }),
      _: 1
    }, 40, ["is-open", "on-toggle", "on-open", "on-close", "slide-direction", "style", "icon", "is-reactive"]));
  }
}, Vs = /* @__PURE__ */ ne(zs, [["__scopeId", "data-v-bcf70687"]]), Js = { class: "flex gap-1 items-center" }, Ps = { key: 1 }, Us = ["src"], Gs = { class: "py-2" }, Zs = ["href"], Ks = ["src"], Xs = { class: "text-sm text-medium truncate" }, Qs = { class: "py-2" }, Ys = {
  __name: "JHeaderProfile",
  props: {
    icon: {
      type: Object,
      default: {
        color: "#FFF",
        size: "18",
        name: ""
      }
    },
    breakpoint: {
      type: String,
      required: !0
    },
    data: {
      type: Object,
      required: !0
    },
    isOpen: {
      type: Boolean,
      required: !0
    },
    onToggle: {
      type: Function,
      required: !0
    },
    onOpen: {
      type: Function,
      default: () => {
      },
      required: !1
    },
    onClose: {
      type: Function,
      default: () => {
      },
      required: !1
    },
    userData: {
      type: [Object, null],
      required: !0,
      default: {
        accountName: null,
        name: null,
        surname: null,
        accountPicture: null,
        accountProfileUrl: "/"
      }
    },
    logOutText: {
      type: String,
      default: "Log out"
    },
    loginCallback: {
      type: Function,
      required: !1,
      default: null
    },
    logoutCallback: {
      type: Function,
      required: !1,
      default: null
    },
    userProfileText: {
      type: String,
      required: !1,
      default: "User Profile"
    },
    isReactive: {
      type: Boolean,
      default: !0
    },
    icons: {
      type: Object,
      required: !1,
      default: () => ({
        props: {
          name: "vpapps-font-chevron-line-right",
          size: 18
        },
        style: {
          size: "18px",
          color: "black"
        }
      })
    }
  },
  emits: ["customEvent", "openNav"],
  setup(e, { emit: i }) {
    const o = e, { data: c, breakpoint: s, userData: r, isOpen: y, icons: d } = ae(o), { loginCallback: m, logoutCallback: u, onOpen: h, onToggle: f } = o, p = R(() => s.value === "mobile" ? he(ct) : he(dt)), v = R(() => s.value === "mobile");
    function S() {
      if (!r.value.name && m)
        return m(), !0;
    }
    const j = () => {
      u && u();
    }, $ = (x) => {
      var T;
      x.target.style.color = d.value.style.colorOnHover, x.target.style.backgroundColor = (T = d.value.style) == null ? void 0 : T.backgroundColorOnHover;
    }, N = (x) => {
      var T;
      x.target.style.color = d.value.style.color, x.target.style.backgroundColor = (T = d.value.style) == null ? void 0 : T.backgroundColor;
    }, k = (x) => {
      var T;
      x.target.style.color = (T = d.value.style) == null ? void 0 : T.colorOnActive;
    }, M = (x) => {
      var T;
      x.target.style.color = (T = d.value.style) == null ? void 0 : T.color;
    };
    return (x, T) => (l(), F(ge(p.value), {
      "is-open": t(y),
      "on-toggle": t(f),
      "on-open": S,
      "on-close": e.onClose,
      "slide-direction": t(c).props.slideDirection,
      "wrapper-class": "w-[90%]",
      class: "j-header-profile relative cursor-pointer",
      style: g(t(c).style),
      icon: t(c).icon.style,
      "is-reactive": e.isReactive
    }, {
      button: q(() => {
        var O, E, I, A;
        return [
          a("div", Js, [
            t(c).props.type === "text" || t(c).props.type === "icon-text" ? (l(), n("div", {
              key: 0,
              style: g(t(c).style.fontStyle)
            }, w(t(c).props.text), 5)) : b("", !0),
            t(c).props.type === "icon" || t(c).props.type === "icon-text" ? (l(), n("div", Ps, [
              t(r).accountPicture ? (l(), n("img", {
                key: 0,
                src: t(r).accountPicture,
                style: g({
                  minWidth: t(d).style.fontSize,
                  width: t(d).style.fontSize,
                  height: t(d).style.fontSize
                }),
                alt: "account-picture",
                class: "rounded-full"
              }, null, 12, Us)) : b("", !0),
              t(r).name && !t(r).accountPicture ? (l(), n("span", {
                key: 1,
                class: "flex items-center justify-center",
                style: g({
                  backgroundColor: "#F1F1F3",
                  minWidth: t(d).style.fontSize,
                  width: t(d).style.fontSize,
                  height: t(d).style.fontSize,
                  borderRadius: "100%",
                  fontSize: "10px",
                  fontFamily: "Inter !important",
                  lineHeight: "16px",
                  color: "#868693",
                  fontWeight: "600"
                })
              }, w((E = (O = t(r)) == null ? void 0 : O.name) == null ? void 0 : E.slice(0, 1).toUpperCase()) + w((A = (I = t(r)) == null ? void 0 : I.surname) == null ? void 0 : A.slice(0, 1).toUpperCase()), 5)) : b("", !0),
              !t(r).accountPicture && !t(r).name ? (l(), F(t(oe), {
                key: 2,
                "ikone-name": t(d).props.name,
                "ikone-style": t(d).style,
                onMouseenter: $,
                onMouseleave: N,
                onMousedown: k,
                onMouseup: M
              }, null, 8, ["ikone-name", "ikone-style"])) : b("", !0)
            ])) : b("", !0)
          ])
        ];
      }),
      header: q(() => [
        a("p", null, w(e.userProfileText), 1)
      ]),
      default: q(() => {
        var O, E, I, A;
        return [
          a("div", {
            class: J(["flex flex-col divide-y list-none text-black", v.value ? "" : "j-profile-dropdown-wrapper"])
          }, [
            a("li", Gs, [
              a("a", {
                class: "flex items-center gap-2 text-xs font-medium",
                href: t(r).accountProfileUrl,
                target: "_blank"
              }, [
                t(r).accountPicture ? (l(), n("img", {
                  key: 0,
                  src: t(r).accountPicture,
                  alt: "account-picture",
                  class: "w-6 h-6 rounded-full"
                }, null, 8, Ks)) : b("", !0),
                t(r).name && !t(r).accountPicture ? (l(), n("span", {
                  key: 1,
                  class: "flex items-center justify-center",
                  style: g({
                    backgroundColor: "#F1F1F3",
                    minWidth: t(d).style.fontSize,
                    width: t(d).style.fontSize,
                    height: t(d).style.fontSize,
                    borderRadius: "100%",
                    fontSize: "10px",
                    fontFamily: "Inter !important",
                    lineHeight: "16px",
                    color: "#868693",
                    fontWeight: "600"
                  })
                }, w((E = (O = t(r)) == null ? void 0 : O.name) == null ? void 0 : E.slice(0, 1).toUpperCase()) + w((A = (I = t(r)) == null ? void 0 : I.surname) == null ? void 0 : A.slice(0, 1).toUpperCase()), 5)) : b("", !0),
                !t(r).accountPicture && !t(r).name ? (l(), F(t(oe), {
                  key: 2,
                  "ikone-name": t(d).props.name,
                  "ikone-style": t(d).style
                }, null, 8, ["ikone-name", "ikone-style"])) : b("", !0),
                a("h1", Xs, w(t(r).name) + " " + w(t(r).surname), 1)
              ], 8, Zs)
            ]),
            a("li", Qs, [
              a("p", {
                class: "flex items-center gap-2 cursor-pointer text-xs font-medium",
                onClick: j
              }, [
                T[0] || (T[0] = a("svg", {
                  width: "18",
                  height: "18",
                  viewBox: "0 0 24 24",
                  fill: "currentcolor",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  a("path", {
                    d: "M20.25 6C20.25 4.75736 19.2426 3.75 18 3.75H6C4.75736 3.75 3.75 4.75736 3.75 6V18C3.75 19.2426 4.75736 20.25 6 20.25H18C19.2426 20.25 20.25 19.2426 20.25 18V17C20.25 16.5858 20.5858 16.25 21 16.25C21.4142 16.25 21.75 16.5858 21.75 17V18C21.75 20.0711 20.0711 21.75 18 21.75H6C3.92893 21.75 2.25 20.0711 2.25 18V6C2.25 3.92893 3.92893 2.25 6 2.25H18C20.0711 2.25 21.75 3.92893 21.75 6V7C21.75 7.41421 21.4142 7.75 21 7.75C20.5858 7.75 20.25 7.41421 20.25 7V6Z",
                    fill: "currentcolor"
                  }),
                  a("path", {
                    d: "M14.4697 6.46967C14.1768 6.76256 14.1768 7.23744 14.4697 7.53033L18.1893 11.25H6.00001C5.5858 11.25 5.25001 11.5858 5.25001 12C5.25001 12.4142 5.5858 12.75 6.00001 12.75H18.1893L14.4697 16.4697C14.1768 16.7626 14.1768 17.2374 14.4697 17.5303C14.7626 17.8232 15.2374 17.8232 15.5303 17.5303L21.0607 12L15.5303 6.46967C15.2374 6.17678 14.7626 6.17678 14.4697 6.46967Z",
                    fill: "currentcolor"
                  })
                ], -1)),
                _(" " + w(e.logOutText), 1)
              ])
            ])
          ], 2)
        ];
      }),
      _: 1
    }, 40, ["is-open", "on-toggle", "on-close", "slide-direction", "style", "icon", "is-reactive"]));
  }
}, _s = /* @__PURE__ */ ne(Ys, [["__scopeId", "data-v-304a222b"]]), er = ["value", "autofocus", "placeholder"], tr = { class: "search-suggestion-wrapper scroll" }, lr = {
  key: 0,
  class: "flex flex-col items-center justify-center p-5"
}, ar = ["value"], or = { class: "flex m-0" }, nr = { class: "suggestion-img-holder" }, sr = { class: "basis-full px-2" }, rr = { class: "text-left text-xs font-semibold" }, ir = { class: "flex justify-start text-xs text-gray-600" }, ur = {
  key: 0,
  class: "flex justify-center"
}, cr = {
  __name: "JHeaderSearch",
  props: {
    icon: {
      type: Object,
      default: {
        color: "#FFF",
        size: "18",
        name: ""
      }
    },
    data: {
      type: Object,
      required: !0
    },
    wrapperStyle: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    searchData: {
      type: Array,
      default: []
    },
    searchCallback: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    searchEnterCallback: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    customWrapper: {
      type: String,
      required: !1,
      default: "RouterLink"
    },
    settings: {
      type: Object,
      default: {}
    },
    breakpoint: {
      type: String,
      required: !0
    },
    isOpen: {
      type: Boolean,
      required: !0
    },
    onToggle: {
      type: Function,
      required: !0
    },
    onClose: {
      type: Function,
      default: () => {
      },
      required: !1
    },
    isOpenByDefault: {
      type: Boolean,
      default: !1
    },
    clientSearchValue: {
      type: String,
      required: !1,
      default: ""
    },
    icons: {
      type: Object,
      required: !1,
      default: () => ({
        props: {
          name: "vpapps-font-location-map-compass",
          size: 18
        },
        style: {
          size: "18px",
          color: "black"
        }
      })
    },
    noSearchDataText: {
      type: String,
      required: !1,
      default: "Žádné výsledky hledání"
    }
  },
  emits: ["onCloseSearch", "customEvent"],
  setup(e, { emit: i }) {
    var L, H;
    const o = e, c = i, {
      searchData: s,
      searchCallback: r,
      searchEnterCallback: y,
      data: d,
      clientSearchValue: m,
      icons: u
    } = ae(o), h = C(m.value), f = C(null), p = C(null), v = C(!0), S = C(null);
    function j(V) {
      const U = f.value;
      if (U) {
        v.value = !1;
        const te = U.offsetWidth;
        U.style.maxWidth = `${te}px`, U.style.transition = "max-width 0.2s ease-in-out", U.offsetWidth, U.style.maxWidth = "100px", setTimeout(() => {
          h.value = null, o.onClose(), U.style.maxWidth = "", U.style.transition = "", Le(() => {
            v.value = !0;
          });
        }, 200);
      }
    }
    function $() {
      S.value ? j() : o.onClose();
    }
    const k = Fe(f, (V) => {
      k.isClickOutside(V, f) && $();
    }), M = C(!1), x = C(null), T = () => {
      x.value = !1, c("onCloseSearch");
    };
    function O(V) {
      var U;
      h.value = (U = V.target) == null ? void 0 : U.value, h.value.trim().length > 0 && (x.value = !0, r && r.value && I(V));
    }
    let E = null;
    function I(V) {
      clearTimeout(E), M.value = !0, E = setTimeout(async () => {
        var U;
        await r.value((U = V.target) == null ? void 0 : U.value), M.value = !1;
      }, 1e3);
    }
    const A = () => {
      var U;
      const V = (U = h.value) == null ? void 0 : U.trim();
      V && V !== "" && (y && y.value && y.value(V), T(), p.value && p.value.blur());
    };
    ((H = (L = d.value) == null ? void 0 : L.props) == null ? void 0 : H.searchBoxOpenStatus) === "default" && o.onToggle();
    function le(V) {
      c("customEvent", { type: "search-option-click", event: V });
    }
    const Z = (V) => {
      var U;
      V.target.style.color = u.value.style.colorOnHover, V.target.style.backgroundColor = (U = u.value.style) == null ? void 0 : U.backgroundColorOnHover;
    }, W = (V) => {
      var U;
      V.target.style.color = u.value.style.color, V.target.style.backgroundColor = (U = u.value.style) == null ? void 0 : U.backgroundColor;
    }, B = (V) => {
      V.preventDefault();
    };
    return (V, U) => (l(), n("div", {
      class: J(["j-search j-header-search flex relative", e.isOpen || e.isOpenByDefault ? "flex-1" : "no-animation"]),
      ref_key: "searchRef",
      ref: f,
      style: g(e.wrapperStyle)
    }, [
      !e.isOpen && v.value ? (l(), n("div", {
        key: 0,
        class: J([
          "icon flex items-center cursor-pointer justify-end",
          e.isOpen || e.isOpenByDefault && "absolute h-full left-2 top-2/4 -translate-y-2/4"
        ]),
        onClick: U[0] || (U[0] = (te) => e.onToggle())
      }, [
        D(t(oe), {
          "ikone-name": t(u).props.name,
          "ikone-style": t(u).style,
          onMouseenter: Z,
          onMouseleave: W
        }, null, 8, ["ikone-name", "ikone-style"])
      ], 2)) : b("", !0),
      e.isOpen || e.isOpenByDefault ? (l(), n("div", {
        key: 1,
        class: "j-search-input",
        ref_key: "searchAnimationEl",
        ref: S
      }, [
        a("form", {
          role: "search",
          onSubmit: B,
          action: "/results",
          class: "h-full"
        }, [
          a("input", {
            type: "search",
            ref_key: "inputSearch",
            ref: p,
            "aria-label": "Search",
            onInput: O,
            value: h.value,
            onKeydown: [
              _e(T, ["esc"]),
              _e(A, ["enter"])
            ],
            onBlur: T,
            autofocus: e.isOpen,
            placeholder: t(d).props.placeholder || "Search video or show",
            maxlength: "200",
            style: g({
              backgroundColor: t(d).style.backgroundColor,
              color: t(d).style.color,
              ...t(d).style.placeholderColor ? { "--placeholder-color": t(d).style.placeholderColor } : {}
            })
          }, null, 44, er)
        ], 32),
        D(at, { name: "fade" }, {
          default: q(() => [
            fe(a("div", tr, [
              M.value ? (l(), n("div", lr, U[2] || (U[2] = [
                a("div", { class: "j-spinner" }, null, -1)
              ]))) : (l(), n(X, { key: 1 }, [
                (l(!0), n(X, null, re(t(s), (te, ue) => (l(), n("li", {
                  class: "mb-3",
                  onClick: le,
                  key: ue,
                  value: te.source
                }, [
                  a("div", or, [
                    (l(), F(ge(e.customWrapper), {
                      class: "flex",
                      to: te.source
                    }, {
                      default: q(() => [
                        a("div", nr, [
                          D(t(xe), {
                            "image-src": te.img,
                            style: g(te.imageStyle),
                            alt: "search-result-img"
                          }, null, 8, ["image-src", "style"])
                        ]),
                        a("div", sr, [
                          a("div", null, [
                            a("h5", rr, w(te.text), 1),
                            a("p", ir, w(te.date), 1)
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  ])
                ], 8, ar))), 128)),
                t(s).length <= 0 ? (l(), n("div", ur, w(e.noSearchDataText), 1)) : b("", !0)
              ], 64))
            ], 512), [
              [be, x.value]
            ])
          ]),
          _: 1
        }),
        a("div", {
          class: "absolute top-1/2 right-5 z-10 transform -translate-y-1/2 cursor-pointer p-3 pr-1",
          onClick: U[1] || (U[1] = Ke((te) => $(), ["stop"]))
        }, [
          D(t(oe), { "ikone-name": "vpapps-font-close-cancel" })
        ])
      ], 512)) : b("", !0)
    ], 6));
  }
}, dr = /* @__PURE__ */ ne(cr, [["__scopeId", "data-v-a60cab3b"]]), fr = {
  __name: "JHeaderLogo",
  props: {
    data: {
      type: Object,
      required: !0
    },
    customWrapper: {
      type: [String, Object],
      required: !1,
      default: "RouterLink"
    },
    style: {
      type: Object,
      required: !1
    },
    url: {
      type: String,
      default: ""
    },
    imgSource: {
      type: String,
      default: null
    },
    imgStyle: {
      type: Object,
      required: !1,
      default: {
        width: 150,
        height: 0
      }
    }
  },
  setup(e) {
    return (i, o) => (l(), n("div", {
      class: "logo flex j-header-logo",
      style: g(e.style)
    }, [
      (l(), F(ge(e.customWrapper), {
        class: "w-full h-full m-auto pointer",
        to: e.url,
        href: e.url,
        target: e.customWrapper === "a" ? "_blank" : null
      }, {
        default: q(() => [
          K(i.$slots, "image-src", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["to", "href", "target"]))
    ], 4));
  }
}, yr = /* @__PURE__ */ ne(fr, [["__scopeId", "data-v-a65ab817"]]), pr = {
  __name: "JSpacing",
  props: {
    isDivider: {
      type: Boolean,
      default: !1
    },
    style: {
      type: Object,
      default: {}
    },
    dividerStyle: {
      type: Object,
      default: {}
    }
  },
  setup(e) {
    return (i, o) => (l(), n("div", {
      class: J(["j-header-spacing", !e.isDivider && "grow"]),
      style: g(e.style)
    }, [
      e.isDivider ? (l(), n("div", {
        key: 0,
        style: g(e.dividerStyle)
      }, null, 4)) : b("", !0)
    ], 6));
  }
}, mr = {
  __name: "JHeaderSpacing",
  setup(e) {
    return (i, o) => (l(), F(pr, it(vt(i.$attrs)), null, 16));
  }
}, vr = { class: "container mx-auto flex items-center gap-2 flex-1" }, zi = {
  __name: "JHeader",
  props: {
    breakpoint: {
      type: String,
      required: !0
    },
    components: {
      type: Array,
      default: [
        {
          id: "menu-1689666471345673",
          type: "menu",
          props: {
            layout: "row",
            menuId: null,
            slideDirection: "right"
          },
          style: {
            alignment: "center",
            padding: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            },
            margin: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            },
            borderProperties: {
              show: !1,
              color: "transparent",
              radius: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
              }
            },
            backgroundHoverColor: "",
            backgroundColor: "",
            spacing: 4,
            fontProperties: {
              size: 14,
              weight: "500",
              family: "Inter",
              style: "Normal",
              color: ""
            },
            gradient: {
              show: !1,
              type: "linear-gradient",
              direction: 0,
              colors: [
                {
                  color: "",
                  position: 0
                },
                {
                  color: "",
                  position: 0
                }
              ]
            }
          },
          icon: {
            props: {
              name: "Search"
            },
            style: {
              size: 24,
              color: "",
              colorOnHover: "",
              colorOnActive: ""
            }
          },
          entityId: null
        },
        {
          id: "spacing-1689666516322224",
          type: "spacing",
          props: {},
          style: {},
          icon: null,
          entityId: null
        },
        {
          id: "languages-1689666506997623",
          type: "languages",
          props: {
            type: "icon"
          },
          style: {
            color: "",
            backgroundColorOnHover: "",
            padding: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            },
            margin: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            },
            borderProperties: {
              show: !1,
              color: "transparent",
              radius: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
              }
            },
            fontProperties: {
              size: 14,
              weight: "500",
              family: "Inter",
              style: "Normal",
              color: ""
            }
          },
          icon: {
            props: {
              name: "Languages"
            },
            style: {
              size: 24,
              color: "",
              colorOnHover: "",
              colorOnActive: ""
            }
          }
        },
        // {
        //     "id": "logo-1689666496592235",
        //     "type": "logo",
        //     "props": {
        //         "source": "",
        //         "linkType": 1,
        //         "url": "",
        //         "secondSource": ""
        //     },
        //     "style": {},
        //     "icon": null,
        //     "entityId": null
        // },
        {
          id: "profile-1689668102963421",
          type: "profile",
          props: {
            type: "icon"
          },
          style: {
            color: "",
            backgroundColorOnHover: "",
            padding: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            },
            margin: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            },
            borderProperties: {
              show: !1,
              color: "transparent",
              radius: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
              }
            },
            fontProperties: {
              size: 14,
              weight: "500",
              family: "Inter",
              style: "Normal",
              color: ""
            }
          },
          icon: {
            props: {
              name: "Profile"
            },
            style: {
              size: 24,
              color: "",
              colorOnHover: "",
              colorOnActive: ""
            }
          },
          entityId: null
        },
        {
          id: "search-1689666489564410",
          type: "search",
          props: {
            type: "icon",
            placeholder: "",
            noResultMessage: "",
            searchBoxOpenStatus: "click"
          },
          style: {
            color: "",
            backgroundColor: "",
            padding: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            },
            margin: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            },
            borderProperties: {
              show: !1,
              color: "transparent",
              radius: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
              }
            },
            fontProperties: {
              size: 14,
              weight: "500",
              family: "Inter",
              style: "Normal",
              color: ""
            }
          },
          icon: {
            props: {
              name: "Search"
            },
            style: {
              size: 24,
              color: "",
              colorOnHover: "",
              colorOnActive: ""
            }
          },
          entityId: null
        },
        {
          id: "notifications-1689666487311260",
          type: "notifications",
          props: {
            type: "icon"
          },
          style: {
            color: "",
            backgroundColorOnHover: "",
            padding: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            },
            margin: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            },
            borderProperties: {
              show: !1,
              color: "transparent",
              radius: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
              }
            },
            fontProperties: {
              size: 14,
              weight: "500",
              family: "Inter",
              style: "Normal",
              color: ""
            }
          },
          icon: {
            props: {
              name: "Notifications"
            },
            style: {
              size: 24,
              color: "",
              colorOnHover: "",
              colorOnActive: ""
            }
          },
          entityId: null
        }
      ]
    }
  },
  setup(e, { expose: i }) {
    const o = C(!1), c = C(!1), s = C(!1), r = C(!1), y = C(!1), d = C(!1);
    i({ onSearchToggle: u, isSearchOpen: c }), he(ks), he(yr), he(dr), he(Vs), he(_s), he(qs), he(mr), he(Dr), he($t);
    function m() {
      o.value = !o.value;
    }
    function u() {
      c.value = !c.value;
    }
    function h() {
      s.value = !s.value;
    }
    function f() {
      r.value = !r.value;
    }
    function p() {
      y.value = !y.value;
    }
    function v() {
      d.value = !d.value;
    }
    function S() {
      o.value = !1;
    }
    function j() {
      c.value = !1;
    }
    function $() {
      s.value = !1;
    }
    function N() {
      r.value = !1;
    }
    function k() {
      y.value = !1;
    }
    function M() {
      d.value = !1;
    }
    function x(E) {
      switch (E) {
        case "menu":
          return o.value;
        case "search":
          return c.value;
        case "profile":
          return s.value;
        case "languages":
          return r.value;
        case "notifications":
          return y.value;
        case "sidebar":
          return d.value;
        default:
          return !1;
      }
    }
    function T(E) {
      switch (E) {
        case "menu":
          return m;
        case "search":
          return u;
        case "profile":
          return h;
        case "languages":
          return f;
        case "notifications":
          return p;
        case "sidebar":
          return v;
        default:
          return () => {
          };
      }
    }
    function O(E) {
      switch (E) {
        case "menu":
          return S;
        case "search":
          return j;
        case "profile":
          return $;
        case "languages":
          return N;
        case "notifications":
          return k;
        case "sidebar":
          return M;
        default:
          return () => {
          };
      }
    }
    return (E, I) => (l(), n("div", {
      class: J(["flex items-center flex-1 header-wrapper p-3", [
        c.value && "is-search-open",
        y.value && "is-notification-open",
        s.value && "is-profile-open",
        r.value && "is-language-open",
        o.value && "is-menu-open",
        e.breakpoint
      ]])
    }, [
      a("div", vr, [
        (l(!0), n(X, null, re(e.components, (A) => K(E.$slots, A.type, {
          item: A,
          isOpen: x(A.type),
          onToggle: T(A.type),
          onClose: O(A.type)
        })), 256)),
        K(E.$slots, "drop-zone")
      ])
    ], 2));
  }
}, gr = {}, hr = { class: "j-header-sceleton w-full" };
function br(e, i) {
  return l(), n("div", hr, i[0] || (i[0] = [
    a("div", { class: "card w-full is-loading" }, [
      a("div", { class: "image" })
    ], -1)
  ]));
}
const Vi = /* @__PURE__ */ ne(gr, [["render", br]]), wr = ["src", "alt"], st = {
  __name: "JImage",
  props: {
    imageSrc: {
      type: String,
      required: !1,
      default: "https://ub1doy938d.gjirafa.net/media/zxgzzz/thumbnails/standart.jpg"
    },
    alt: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return (i, o) => (l(), n("img", $e({
      src: e.imageSrc,
      alt: e.alt ? e.alt : "name-img",
      class: "w-full"
    }, i.$attrs), null, 16, wr));
  }
}, xr = {
  __name: "JImageSceleton",
  props: {
    imageSrc: {
      type: String,
      required: !1,
      default: "https://ub1doy938d.gjirafa.net/media/zxgzzz/thumbnails/standart.jpg"
    }
  },
  setup(e) {
    return (i, o) => (l(), n("div", $e({
      src: "",
      class: "jimage-sceleton w-full"
    }, i.$attrs), null, 16));
  }
}, Ji = /* @__PURE__ */ ne(xr, [["__scopeId", "data-v-e0e4c3cd"]]), oe = {
  __name: "JIcon",
  props: {
    ikoneName: {
      type: String,
      required: !0,
      default: "vpapps-font-home"
    },
    ikoneStyle: {
      type: Object,
      default: () => ({
        color: "#9f9f9f",
        fontSize: "18px !important",
        backgroundColor: "transparent",
        borderColor: "#ccc",
        cursor: "pointer"
      })
    }
  },
  setup(e) {
    return (i, o) => (l(), n("span", {
      class: J(["j-icon relative", e.ikoneName]),
      style: g(e.ikoneStyle)
    }, null, 6));
  }
}, kr = {
  __name: "JImageContainer",
  props: {
    imageSrc: {
      type: String,
      required: !1,
      default: "https://ub1doy938d.gjirafa.net/media/zxgzzz/thumbnails/standart.jpg"
    },
    alt: {
      type: String,
      required: !0
    },
    customWrapper: {
      type: String,
      required: !1,
      default: "div"
    },
    wrapperStyle: {
      type: Object,
      default: {}
    },
    captionStyle: {
      type: Object,
      default: {}
    },
    imageStyle: {
      type: Object,
      default: {}
    },
    hasCaption: {
      type: Boolean,
      default: !1
    },
    caption: {
      type: String,
      default: ""
    },
    linkTo: {
      type: String,
      default: null
    },
    externalLinkTo: {
      type: String,
      default: null
    }
  },
  setup(e) {
    return (i, o) => (l(), F(ge(e.customWrapper), {
      style: g(e.wrapperStyle),
      to: e.linkTo,
      target: e.externalLinkTo ? "_blank" : null,
      href: e.externalLinkTo
    }, {
      default: q(() => [
        D(t(xe), {
          class: "image",
          "image-src": e.imageSrc,
          alt: e.alt,
          style: g(e.imageStyle)
        }, null, 8, ["image-src", "alt", "style"]),
        e.hasCaption ? (l(), n("div", {
          key: 0,
          style: g(e.captionStyle)
        }, [
          a("span", null, w(e.caption), 1)
        ], 4)) : b("", !0)
      ]),
      _: 1
    }, 8, ["style", "to", "target", "href"]));
  }
}, et = /* @__PURE__ */ ne(kr, [["__scopeId", "data-v-7cc27c46"]]), Sr = { class: "j-label-text cursor-pointer" }, Cr = {
  __name: "JLabel",
  props: {
    customWrapper: {
      type: String,
      required: !1,
      default: "div"
    },
    url: {
      type: String,
      required: !1,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    style: {
      type: Object,
      default: {}
    },
    labelStyle: {
      type: Object,
      default: {}
    }
  },
  setup(e) {
    Ie((r) => ({
      "63a4e1b4": c.value,
      "2a2f1348": s.value
    }));
    const i = e, { labelStyle: o } = ae(i), c = R(() => {
      var r, y;
      return ((r = o == null ? void 0 : o.value) == null ? void 0 : r.colorOnHover) || ((y = o == null ? void 0 : o.value) == null ? void 0 : y.color);
    }), s = R(() => {
      var r, y;
      return ((r = o == null ? void 0 : o.value) == null ? void 0 : r.colorOnActive) || ((y = o == null ? void 0 : o.value) == null ? void 0 : y.color);
    });
    return (r, y) => (l(), n("div", {
      style: g(e.style)
    }, [
      (l(), F(ge(e.customWrapper), {
        style: g(t(o)),
        to: e.customWrapper !== "a" && e.url ? e.url : "",
        href: e.customWrapper === "a" && e.url ? e.url : "",
        target: e.customWrapper === "a" ? "_blank" : null
      }, {
        default: q(() => [
          a("span", Sr, w(e.text), 1)
        ]),
        _: 1
      }, 8, ["style", "to", "href", "target"]))
    ], 4));
  }
}, Pi = /* @__PURE__ */ ne(Cr, [["__scopeId", "data-v-978754f1"]]), Ui = {
  __name: "JList",
  props: {
    numberOfItems: {
      type: Number,
      default: 0
    },
    orientation: {
      type: String,
      default: "horizontal"
    },
    hasLimit: {
      type: Boolean,
      default: !1
    },
    limit: {
      type: Number,
      default: 0
    },
    style: {
      type: Object,
      default: {}
    },
    buttonStyle: {
      type: Object,
      default: {}
    }
  },
  setup(e) {
    const i = e, o = {
      1: "grid-cols-1",
      2: "grid-cols-2",
      3: "grid-cols-3",
      4: "grid-cols-4",
      5: "grid-cols-5",
      6: "grid-cols-6",
      7: "grid-cols-7",
      8: "grid-cols-8",
      9: "grid-cols-9",
      10: "grid-cols-10",
      11: "grid-cols-11",
      12: "grid-cols-12"
    }, c = C(i.limit), s = R(() => {
      let m = "flex flex-wrap";
      return i.hasLimit && i.orientation === "horizontal" ? `grid ${o[i.limit]}` : (i.orientation === "vertical" && (m += " flex-col"), m);
    }), r = R(() => i.hasLimit && c.value < i.numberOfItems), y = R(() => i.hasLimit ? c.value : i.numberOfItems), d = () => {
      const m = c.value + 4;
      c.value = Math.min(m, i.numberOfItems);
    };
    return (m, u) => (l(), n("div", {
      class: "flex flex-col",
      style: g(e.style)
    }, [
      a("div", {
        class: J(s.value),
        style: g({ gap: e.style.gap })
      }, [
        (l(!0), n(X, null, re(y.value, (h) => (l(), n("div", { key: h }, [
          K(m.$slots, "item", { index: h })
        ]))), 128))
      ], 6),
      r.value ? (l(), F(t(He), {
        key: 0,
        type: "text",
        text: "Show More",
        "custom-wrapper": "div",
        version: "2",
        style: g(e.buttonStyle),
        onClick: d
      }, null, 8, ["style"])) : b("", !0)
    ], 4));
  }
}, nt = {
  __name: "JNavigatorWrapper",
  props: {
    data: {
      type: Object,
      required: !1,
      default: null
    }
  },
  setup(e) {
    const i = e, { data: o } = ae(i), c = {
      EXTERNAL_NEW_PAGE: 1,
      INTERNAL: 2,
      EXTERNAL: 3
    }, s = {};
    return !o.value || !o.value.active ? s.wrapperName = "div" : o.value.linkType === c.INTERNAL ? (s.wrapperName = "RouterLink", s.url = o.value.url) : o.value.linkType === c.EXTERNAL ? (s.wrapperName = "a", s.url = o.value.url) : o.value.linkType === c.EXTERNAL_NEW_PAGE ? (s.wrapperName = "a", s.target = "_blank", s.url = o.value.url) : s.wrapperName = "div", (r, y) => (l(), F(ge(s.wrapperName), {
      to: s.url,
      href: s.url,
      target: s.target
    }, {
      default: q(() => [
        K(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["to", "href", "target"]));
  }
};
function $r(e, i, o) {
  let c = !1, s = 0, r = 0;
  function y(u) {
    c = !0, s = u.clientX, u.preventDefault();
  }
  function d(u) {
    c && (r = u.clientX - s);
  }
  function m() {
    c = !1, r > 0 ? i() : r < 0 && o(), r = 0;
  }
  e.addEventListener("mousedown", y), e.addEventListener("mousemove", d), e.addEventListener("mouseup", m);
}
const Tr = {
  key: 0,
  class: "carousel-navigator-holder left flex h-100 items-center absolute left-0 bottom-0 top-0"
}, Or = {
  key: 1,
  class: "carousel-navigator-holder right flex h-100 items-center absolute right-0 bottom-0 top-0"
}, ft = {
  __name: "ScrollCarousel",
  props: {
    generalStyle: {
      type: Object,
      required: !1,
      default: {
        titleStyle: {},
        wrapperStyle: {
          backgroundColor: "transparent"
        },
        itemStyle: {
          backgroundColor: "white",
          color: "black"
        },
        hoverColors: {
          backgroundColor: "blue",
          color: "red",
          active: "#FFAB00"
        }
      }
    },
    icons: {
      type: Object,
      required: !1,
      default: () => ({
        props: {
          name: "vpapps-font-arrow-right",
          size: 18
        },
        style: {
          size: "18px",
          color: "black"
        }
      })
    },
    inline: {
      type: Boolean,
      required: !1,
      default: !0
    },
    allowButtonScroll: {
      type: Boolean,
      required: !1,
      default: !0
    },
    iconName: {
      type: String,
      default: "vpapps-font-chevron-line-left"
    }
  },
  setup(e) {
    const i = e, o = C(null), c = C(!1), s = C(!0), r = C(!1);
    C(null), C("#330000");
    const y = () => {
      v();
    }, d = () => {
      p();
    }, m = () => {
      rt(o.value).horizontal && (c.value = !0);
    };
    ke(() => {
      $r(o.value, y, d), i.allowButtonScroll && Be(o.value, m, null, !0);
    });
    function u(k, M, x) {
      const T = k.scrollLeft, O = performance.now();
      function E(A) {
        const Z = (A || performance.now()) - O, W = Math.floor(
          I(Z, T, M, x)
        );
        k.scrollLeft = W, Z < x && requestAnimationFrame(E);
      }
      function I(A, le, Z, W) {
        return A /= W / 2, A < 1 ? Z / 2 * A * A + le : (A--, -Z / 2 * (A * (A - 2) - 1) + le);
      }
      requestAnimationFrame(E);
    }
    function h(k) {
      return k.scrollLeft + 2 * k.clientWidth >= k.scrollWidth;
    }
    function f(k) {
      return k.scrollLeft <= k.clientWidth;
    }
    const p = () => {
      r.value = !0;
      const k = o.value.clientWidth;
      u(o.value, k, 600), h(o.value) ? s.value = !1 : s.value = !0;
    }, v = () => {
      s.value = !0;
      const k = o.value.clientWidth;
      u(o.value, -k, 600), f(o.value) ? r.value = !1 : r.value = !0;
    }, S = (k) => {
      const M = o.value;
      M.scrollLeft + 3 >= M.scrollWidth - M.offsetWidth ? (r.value = !0, s.value = !1) : M.scrollLeft === 0 ? (r.value = !1, s.value = !0) : (r.value = !0, s.value = !0);
    }, j = () => kt(S, 200), $ = (k) => {
      var M, x;
      k.target.style.backgroundColor = (M = i.icons.style) == null ? void 0 : M.backgroundColorOnHover, k.target.style.color = (x = i.icons.style) == null ? void 0 : x.colorOnHover;
    }, N = (k) => {
      var M, x;
      k.target.style.backgroundColor = (M = i.icons.style) == null ? void 0 : M.backgroundColor, k.target.style.color = (x = i.icons.style) == null ? void 0 : x.color;
    };
    return (k, M) => (l(), n("div", {
      class: "j-scroll-carousel-menu relative",
      style: g(e.generalStyle.wrapperStyle)
    }, [
      a("div", {
        class: J(["flex items-center j-scroll-carousel-menu-wrapper overflow-y-hidden", [e.inline ? "overflow-x-auto" : "flex-wrap"]]),
        ref_key: "menuHolderEl",
        ref: o,
        style: {
          justifyContent: "inherit",
          gap: "inherit",
          alignItems: "inherit"
        },
        onScroll: j
      }, [
        c.value && r.value && e.allowButtonScroll ? (l(), n("div", Tr, [
          D(t(oe), {
            "ikone-name": e.iconName,
            "ikone-style": e.icons.style,
            class: "z-10 flex items-center justify-center drop-shadow-lg cursor-pointer",
            onClick: v,
            onMouseenter: $,
            onMouseleave: N
          }, null, 8, ["ikone-name", "ikone-style"])
        ])) : b("", !0),
        K(k.$slots, "default"),
        c.value && s.value && e.allowButtonScroll ? (l(), n("div", Or, [
          D(t(oe), {
            "ikone-name": e.iconName,
            "ikone-style": e.icons.style,
            class: "z-10 flex items-center justify-center drop-shadow-lg cursor-pointer rotate-180",
            onClick: p,
            onMouseenter: $,
            onMouseleave: N
          }, null, 8, ["ikone-name", "ikone-style"])
        ])) : b("", !0)
      ], 34)
    ], 4));
  }
}, qr = { class: "j-page-menu" }, Gi = {
  __name: "JPageMenu",
  props: {
    menuItems: {
      type: Array,
      required: !1,
      default: []
    },
    blurColor: {
      type: [String, Number, null],
      required: !1,
      default: null
    },
    generalStyle: {
      type: Object,
      required: !1,
      default: {
        titleStyle: {},
        wrapperStyle: {
          backgroundColor: "green"
        },
        itemStyle: {
          backgroundColor: "white",
          color: "black"
        },
        iconSettings: {
          size: "42px",
          color: "black"
        },
        hoverColors: {
          backgroundColor: "blue",
          color: "red",
          active: "#FFAB00"
        }
      }
    },
    inline: {
      type: Boolean,
      required: !1,
      default: !0
    },
    allowButtonScroll: {
      type: Boolean,
      required: !1,
      default: !0
    },
    customWrapper: {
      type: [String, Object],
      required: !1,
      default: "RouterLink"
    }
  },
  setup(e) {
    Ie((u) => ({
      c936dbfc: t(m)
    }));
    const i = e, { blurColor: o } = ae(i), c = (u) => {
      var h, f, p, v;
      u.target.style.backgroundColor = (f = (h = i.generalStyle) == null ? void 0 : h.hoverColors) == null ? void 0 : f.backgroundColor, u.target.style.color = (v = (p = i.generalStyle) == null ? void 0 : p.hoverColors) == null ? void 0 : v.color;
    }, s = (u) => {
      var h, f, p, v;
      u.target.style.backgroundColor = (f = (h = i.generalStyle) == null ? void 0 : h.itemStyle) == null ? void 0 : f.backgroundColor, u.target.style.color = (v = (p = i.generalStyle) == null ? void 0 : p.itemStyle) == null ? void 0 : v.color;
    }, r = (u) => {
      var h, f;
      u.target.style.backgroundColor = (f = (h = i.generalStyle) == null ? void 0 : h.hoverColors) == null ? void 0 : f.active;
    }, y = (u) => {
      var h, f, p, v;
      u.target.style.backgroundColor = (f = (h = i.generalStyle) == null ? void 0 : h.itemStyle) == null ? void 0 : f.backgroundColor, u.target.style.color = (v = (p = i.generalStyle) == null ? void 0 : p.itemStyle) == null ? void 0 : v.color;
    }, d = (u) => u.isExternal ? "a" : u.url ? i.customWrapper : "div";
    let m = "";
    return o.value ? m = `${o.value} 10%,
  ${o.value.replace(")", "-c)")} 70%,
  rgba(255, 255, 255, 0) 100%` : m = "transparent, transparent", (u, h) => {
      var f;
      return l(), n("div", qr, [
        D(ft, {
          "general-style": e.generalStyle,
          icons: (f = e.generalStyle) == null ? void 0 : f.iconSettings,
          inline: e.inline
        }, {
          default: q(() => [
            (l(!0), n(X, null, re(e.menuItems, (p) => {
              var v, S;
              return l(), F(ge(d(p)), {
                key: p.id,
                href: p.isExternal || (v = p.url) != null && v.startsWith("#") ? p.url : void 0,
                to: !p.isExternal && p.url && !((S = p.url) != null && S.startsWith("#")) ? { path: p.url } : void 0,
                onMouseenter: c,
                onMouseleave: s,
                onMousedown: r,
                onMouseup: y,
                target: p.isExternal ? "_blank" : void 0,
                class: "j-scroll-carousel-item flex hover:bg-[#7483A1] hover:text-white mr-3 my-2 transition-colors whitespace-nowrap cursor-pointer",
                style: g(e.generalStyle.itemStyle)
              }, {
                default: q(() => [
                  _(w(p.displayName), 1)
                ]),
                _: 2
              }, 1064, ["href", "to", "target", "style"]);
            }), 128))
          ]),
          _: 1
        }, 8, ["general-style", "icons", "inline"])
      ]);
    };
  }
}, yt = {
  __name: "JProfileLetter",
  props: {
    name: {
      type: String,
      required: !0
    },
    profileStyle: {
      type: Object,
      required: !1,
      default: {
        backgroundColor: "#ECF2F4",
        color: "#11254A",
        borderRadius: "100%"
      }
    }
  },
  setup(e) {
    const i = e;
    function o() {
      return i.name.split(" ").filter(Boolean).slice(0, 2).map((r) => r[0].toUpperCase()).join("");
    }
    return (c, s) => (l(), n("div", {
      class: "flex justify-center items-center min-w-full min-h-full",
      style: g(e.profileStyle)
    }, w(o()), 5));
  }
}, jr = { class: "flex flex-col gap-1" }, Mr = { class: "flex" }, Ir = ["innerHTML"], Zi = {
  __name: "JRelatedGroup",
  props: {
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    showTitle: {
      type: Boolean,
      default: !0
    },
    showDescription: {
      type: Boolean,
      default: !0
    },
    showImage: {
      type: Boolean,
      default: !0
    },
    style: {
      type: Object,
      default: {
        gap: "20px"
      }
    },
    titleStyle: {
      type: Object,
      default: {}
    },
    descriptionStyle: {
      type: Object,
      default: {}
    },
    imageStyle: {
      type: Object,
      default: {}
    },
    imageSrc: {
      type: String,
      default: ""
    },
    engagements: {
      type: Array,
      default: []
    },
    isRedirect: {
      type: Boolean,
      default: !0
    },
    isImageRedirect: {
      type: Boolean,
      default: !0
    },
    isImageRounded: {
      type: Boolean,
      default: !0
    },
    url: {
      type: String,
      required: !1,
      default: ""
    }
  },
  setup(e) {
    const i = e, {
      showTitle: o,
      title: c,
      showDescription: s,
      description: r,
      showImage: y,
      style: d,
      titleStyle: m,
      descriptionStyle: u,
      imageSrc: h,
      engagements: f,
      isRedirect: p,
      url: v
    } = ae(i), S = (k) => {
      const {
        backgroundColor: M,
        backgroundColorOnHover: x,
        borderColor: T,
        borderColorOnHover: O
      } = d.value;
      k.target.style.backgroundColor = x || M, k.target.style.borderColor = O || T;
    }, j = (k) => {
      const { backgroundColor: M, borderColor: x } = d.value;
      k.target.style.backgroundColor = M, k.target.style.borderColor = x;
    }, $ = (k) => {
      const { colorOnHover: M } = m.value;
      k.target.style.color = M;
    }, N = (k) => {
      const { color: M } = m.value;
      k.target.style.color = M;
    };
    return (k, M) => (l(), n("div", null, [
      a("div", {
        class: "flex",
        style: g(t(d)),
        onMouseenter: S,
        onMouseleave: j
      }, [
        t(y) ? (l(), F(ge(e.isImageRedirect && t(v) ? "RouterLink" : "div"), {
          key: 0,
          class: J(["w-12 h-12 bg-[#ECF2F4] aspect-square", e.isImageRounded && "rounded-full"]),
          to: t(v),
          style: g(e.imageStyle)
        }, {
          default: q(() => [
            t(h) ? (l(), F(xe, {
              key: 0,
              "image-src": t(h),
              alt: "group-img",
              class: "rounded-full w-full h-full object-cover"
            }, null, 8, ["image-src"])) : b("", !0)
          ]),
          _: 1
        }, 8, ["class", "to", "style"])) : b("", !0),
        a("div", {
          class: "grow flex flex-col justify-center",
          style: g({ gap: t(d).gap })
        }, [
          t(o) ? (l(), n("div", {
            key: 0,
            class: "flex flex-wrap justify-between",
            onMouseenter: $,
            onMouseleave: N,
            style: g(t(m))
          }, [
            a("div", jr, [
              (l(), F(ge(t(p) && t(v) ? "RouterLink" : "span"), {
                to: t(v),
                style: g({ fontWeight: t(m).fontWeight }),
                class: "font-main"
              }, {
                default: q(() => [
                  _(w(t(c)), 1)
                ]),
                _: 1
              }, 8, ["to", "style"]))
            ]),
            a("div", null, [
              K(k.$slots, "engagements", {}, () => [
                a("div", Mr, [
                  (l(!0), n(X, null, re(t(f), (x) => (l(), F(t(He), {
                    key: x.id,
                    data: x,
                    type: x.props.type,
                    "custom-wrapper": x.props.linkType === 1 ? "a" : "RouterLink",
                    "link-type": x.props.linkType,
                    style: g(x.style),
                    icon: x.icon,
                    text: x.props.text,
                    url: x.props.url
                  }, null, 8, ["data", "type", "custom-wrapper", "link-type", "style", "icon", "text", "url"]))), 128))
                ])
              ])
            ])
          ], 36)) : b("", !0),
          t(s) && t(r) ? K(k.$slots, "description", { key: 1 }, () => [
            a("div", {
              style: g(t(u)),
              innerHTML: t(r)
            }, null, 12, Ir)
          ]) : b("", !0)
        ], 4)
      ], 36)
    ]));
  }
}, Ki = {
  __name: "JRow",
  props: {
    alignment: {
      type: Object,
      default: {
        horizontal: null,
        vertical: null
      }
    },
    xAlignment: {
      type: [String, null],
      default: null
    },
    yAlignment: {
      type: [String, null],
      default: null
    },
    isContainer: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  setup(e) {
    const i = e, o = {
      left: "justify-start",
      right: "justify-end",
      center: "justify-center"
    }, c = {
      top: "items-start",
      bottom: "items-end",
      center: "items-center"
    }, s = R(() => {
      const { xAlignment: r, yAlignment: y } = i;
      return `${r ? o[r] : ""}${y ? " " + c[y] : ""}`;
    });
    return (r, y) => (l(), n("div", {
      class: J(["j-row w-full relative flex flex-wrap", [s.value, e.isContainer ? "container px-3 mx-auto" : null]])
    }, [
      K(r.$slots, "default")
    ], 2));
  }
}, Br = { class: "j-show-case" }, Xi = {
  __name: "JShowCase",
  props: {
    banner: {
      type: Object,
      requied: !0
    },
    grid: {
      type: Object,
      required: !0
    },
    layoutType: {
      type: Number,
      requied: !1,
      default: 1
    },
    title: {
      type: String,
      requied: !1,
      default: null
    },
    titleStyle: {
      type: Object,
      requied: !1,
      default: null
    },
    navigationData: {
      type: Object,
      required: !1,
      default: null
    },
    newItemText: {
      type: String,
      default: "New"
    },
    buttonCustomWrapper: {
      type: [String, Object],
      required: !1,
      default: "div"
    }
  },
  setup(e) {
    const i = e, { titleStyle: o } = ae(i), c = R(() => {
      if (i.layoutType === 1)
        return "ascend";
      if (i.layoutType === 2)
        return "descend";
      if (i.layoutType === 3)
        return "rightward";
      if (i.layoutType === 4)
        return "leftward";
    }), s = (y) => {
      y.target.style.color = o.value.colorOnHover || o.value.color;
    }, r = (y) => {
      y.target.style.color = o.value.color;
    };
    return (y, d) => (l(), n("div", Br, [
      D(t(nt), {
        data: e.navigationData,
        class: "flex"
      }, {
        default: q(() => [
          a("h1", {
            style: g(t(o)),
            onMouseenter: s,
            onMouseleave: r
          }, w(e.title), 37)
        ]),
        _: 1
      }, 8, ["data"]),
      a("div", {
        class: J(["j-show-case-holder", c.value])
      }, [
        K(y.$slots, "banner", { banner: e.banner }, () => [
          D(t(Yt), {
            data: e.banner.data,
            "has-overlay": e.banner.hasOverlay,
            "title-style": e.banner.titleStyle,
            customWrapper: e.banner.customWrapper,
            "wrapper-style": e.banner.wrapperStyle,
            "content-classes": e.banner.contentClasses,
            contentStyle: e.banner.contentStyle,
            "description-style": e.banner.descriptionStyle,
            autoplay: e.banner.autoplay,
            buttons: e.banner.buttons,
            canControlAudio: e.banner.canControlAudio,
            buttonCustomWrapper: e.buttonCustomWrapper
          }, null, 8, ["data", "has-overlay", "title-style", "customWrapper", "wrapper-style", "content-classes", "contentStyle", "description-style", "autoplay", "buttons", "canControlAudio", "buttonCustomWrapper"])
        ]),
        K(y.$slots, "grid", { grid: e.grid }, () => [
          D(t(tt), {
            data: e.grid.data,
            "widget-identifier": -1,
            "wrapper-style": { ...e.grid.wrapperStyle },
            "number-of-columns": e.grid.numberOfColumns,
            "content-wrapper-style": e.grid.contentWrapperStyle,
            "card-style": e.grid.cardStyle,
            "new-item-text": e.newItemText
          }, {
            "card-image": q(({ image: m, style: u, filmstrip: h, alt: f }) => [
              D(t(xe), {
                imageSrc: m,
                alt: "Video Card Placeholder",
                class: "w-full",
                style: g(u),
                "no-lazy-image": ""
              }, null, 8, ["imageSrc", "style", "alt"]),
              e.grid.cardStyle.isFilmstrip ? (l(), F(t(Yn), {
                key: 0,
                src: h,
                "switch-time": 0.5,
                style: g({ ...u, backgroundColor: "unset" })
              }, null, 8, ["src", "style"])) : b("", !0)
            ]),
            _: 1
          }, 8, ["data", "wrapper-style", "number-of-columns", "content-wrapper-style", "card-style", "new-item-text"])
        ])
      ], 2)
    ]));
  }
}, Fr = { ref: "sidebar" }, Lr = {
  __name: "JSidebar",
  props: {
    icon: {
      type: Object,
      default: {
        color: "",
        size: "18",
        name: ""
      }
    },
    style: {
      type: Object,
      default: {}
    },
    wrapperStyle: {
      type: Object,
      default: {}
    },
    wrapperClass: {
      type: String,
      default: "w-[80%]"
    },
    fixedWrapperClass: {
      type: String,
      default: "fixed"
    },
    headerClass: {
      type: String,
      default: ""
    },
    isOpen: {
      type: Boolean,
      required: !0
    },
    onToggle: {
      type: Function,
      required: !0
    },
    onOpen: {
      type: Function,
      default: () => {
      },
      required: !1
    },
    onClose: {
      type: Function,
      default: () => {
      },
      required: !1
    },
    slideDirection: {
      type: String,
      default: "right"
    },
    isShown: {
      type: Boolean,
      default: !0
    },
    counter: {
      type: Number,
      default: 0
    },
    mainIconName: {
      type: String,
      default: "vpapps-font-menu-three-lines"
    },
    mainIconStyle: {
      type: Object,
      default: {}
    },
    closeIconName: {
      type: String,
      default: "vpapps-font-close-cancel"
    },
    closeIconStyle: {
      type: Object,
      default: {}
    },
    overlayStyle: {
      type: Object,
      default: {}
    },
    teleportDisabled: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const i = e, o = C(0), c = C(null), s = C(), r = R(() => {
      const p = i.slideDirection === "right" ? "left-0" : "right-0";
      let v;
      return o.value ? v = i.isOpen ? `nav-open-${i.slideDirection}` : `nav-close-${i.slideDirection}` : v = `nav-hidden-${i.slideDirection}`, `${i.fixedWrapperClass} ${p} ${v}`;
    });
    ke(() => {
      c.value && (s.value = Fe(c, m));
    });
    function y() {
      o.value++, i.onOpen() || i.onToggle();
    }
    function d() {
      i.onClose();
    }
    const m = (p) => {
      s.value.isClickOutside(p, c) && d();
    }, u = (p, v) => {
      p.target.querySelector(".j-icon") && (p.target.querySelector(".j-icon").style.color = v == null ? void 0 : v.colorOnHover, p.target.querySelector(".j-icon").style.backgroundColor = v == null ? void 0 : v.backgroundColorOnHover);
    }, h = (p, v) => {
      p.target.querySelector(".j-icon") && (p.target.querySelector(".j-icon").style.color = v.colorOnActive, p.target.querySelector(".j-icon").style.backgroundColor = v.backgroundColorOnActive);
    }, f = (p, v) => {
      p.target.querySelector(".j-icon") && (p.target.querySelector(".j-icon").style.color = v == null ? void 0 : v.color, p.target.querySelector(".j-icon").style.backgroundColor = v == null ? void 0 : v.backgroundColor);
    };
    return (p, v) => (l(), n("div", Fr, [
      a("div", {
        class: "cursor-pointer",
        onClick: v[0] || (v[0] = (S) => y()),
        onMouseenter: v[1] || (v[1] = (S) => u(S, e.mainIconStyle)),
        onMouseleave: v[2] || (v[2] = (S) => f(S, e.mainIconStyle)),
        onMousedown: v[3] || (v[3] = (S) => h(S, e.mainIconStyle)),
        onMouseup: v[4] || (v[4] = (S) => f(S, e.mainIconStyle))
      }, [
        K(p.$slots, "button", {}, () => [
          D(t(oe), {
            "ikone-name": e.mainIconName,
            "ikone-style": e.mainIconStyle
          }, null, 8, ["ikone-name", "ikone-style"])
        ], !0)
      ], 32),
      (l(), F(ot, {
        disabled: e.teleportDisabled || !e.isOpen,
        to: "body"
      }, [
        e.isOpen ? (l(), n("div", {
          key: 0,
          class: J(["sidebar-wrapper-bg h-screen w-screen top-0 overflow-y-auto fixed z-111", [
            e.fixedWrapperClass,
            e.slideDirection === "right" ? "left-0" : "right-0"
          ]]),
          style: g(e.overlayStyle),
          onClick: v[5] || (v[5] = (S) => d())
        }, null, 6)) : b("", !0),
        a("div", {
          class: J(["sidebar-wrapper h-screen top-0 overflow-y-auto scroll flex flex-col", r.value]),
          style: g(e.style)
        }, [
          a("div", {
            class: J(["w-full justify-between items-center flex", e.headerClass]),
            style: g({ gap: e.style.gap })
          }, [
            a("div", null, [
              K(p.$slots, "header", {}, void 0, !0)
            ]),
            a("div", {
              class: "cursor-pointer",
              onClick: v[6] || (v[6] = (S) => d()),
              onMouseenter: v[7] || (v[7] = (S) => u(S, e.closeIconStyle)),
              onMouseleave: v[8] || (v[8] = (S) => f(S, e.closeIconStyle)),
              onMousedown: v[9] || (v[9] = (S) => h(S, e.closeIconStyle)),
              onMouseup: v[10] || (v[10] = (S) => f(S, e.closeIconStyle))
            }, [
              K(p.$slots, "header-close", {}, () => [
                D(t(oe), {
                  "ikone-name": e.closeIconName,
                  "ikone-style": e.closeIconStyle
                }, null, 8, ["ikone-name", "ikone-style"])
              ], !0)
            ], 32)
          ], 6),
          K(p.$slots, "default", {}, void 0, !0)
        ], 6)
      ], 8, ["disabled"]))
    ], 512));
  }
}, Dr = /* @__PURE__ */ ne(Lr, [["__scopeId", "data-v-fe063b20"]]), Ar = {
  key: 0,
  class: "slider-tracker slider-tracker container mx-auto absolute left-0 right-0"
}, Hr = { class: "slider-indicators" }, Er = ["onClick"], Nr = {
  __name: "JSlider",
  props: {
    slides: {
      type: Array,
      required: !0
    },
    autoSlide: {
      type: Boolean,
      required: !1,
      default: !1
    },
    scrollInterval: {
      type: [Number, String],
      required: !1,
      default: !1
    },
    activeSlide: {
      type: Number,
      required: !1,
      default: 0
    },
    animationTime: {
      type: String,
      required: !1,
      default: ".6s"
    },
    showArrows: {
      type: Boolean,
      required: !1,
      default: !0
    },
    showDots: {
      type: Boolean,
      required: !1,
      default: !0
    },
    icons: {
      type: Object,
      required: !1,
      default: () => ({
        props: {
          name: "vpapps-font-arrow-right",
          size: 18
        },
        style: {
          size: "18px",
          color: "black"
        }
      })
    }
  },
  emits: ["customClickEvent"],
  setup(e, { emit: i }) {
    Ie((Z) => ({
      "08489e7e": u.value
    }));
    const o = e, { slides: c, autoSlide: s, scrollInterval: r, showIndicators: y, icons: d } = ae(o), m = C(o.activeSlide), u = C(o.animationTime), h = C($(c.value, m.value)), f = C(null), p = C(!1), v = C(""), S = C(!1), j = C(null);
    function $(Z, W) {
      return (W % Z.length + Z.length) % Z.length;
    }
    const N = R(() => c.value.map((Z, W) => (W === h.value ? Z.active = !0 : Z.active = !1, Z)));
    function k(Z, W = -1) {
      p.value || (p.value = !0, v.value = Z, W === -1 ? m.value += Z === "slide-left" ? 1 : -1 : m.value = W, h.value = $(c.value, m.value), Z === "slide-right" ? h.value + 1 === c.value.length ? f.value = "flex-row-reverse" : f.value = "justify-end" : Z === "slide-left" && (h.value === 0 ? f.value = "flex-row-reverse justify-end" : f.value = ""));
    }
    const M = () => k("slide-right"), x = () => k("slide-left");
    function T() {
      p.value = !1;
    }
    ke(() => {
      s.value && (j.value = setInterval(() => {
        S.value || x();
      }, r.value * 1e3));
    }), lt(() => {
      clearInterval(j.value);
    });
    function O(Z) {
      Z !== h.value && (h.value < Z ? k("slide-left", Z) : k("slide-right", Z));
    }
    const E = () => {
      s.value && (S.value = !0, clearInterval(j.value), j.value = null);
    }, I = () => {
      s.value && (S.value = !1, !j.value && (j.value = setInterval(() => {
        S.value || x();
      }, r.value * 1e3)));
    }, A = (Z) => {
      var W;
      Z.target.style.backgroundColor = (W = d.value.style) == null ? void 0 : W.backgroundColorOnHover, Z.target.style.color = d.value.style.colorOnHover;
    }, le = (Z) => {
      var W, B;
      Z.target.style.backgroundColor = (W = d.value.style) == null ? void 0 : W.backgroundColor, Z.target.style.color = (B = d.value.style) == null ? void 0 : B.color;
    };
    return (Z, W) => (l(), n("div", {
      class: "j-slider",
      onMouseover: E,
      onMouseleave: I
    }, [
      D(It, {
        name: "slide",
        onAfterEnter: T,
        tag: "div",
        class: J(["j-slider-wrapper", [v.value, f.value]])
      }, {
        default: q(() => [
          (l(!0), n(X, null, re(N.value, (B, L) => fe((l(), n("div", {
            key: L,
            class: "slide-page"
          }, [
            K(Z.$slots, "slide", {
              slide: B,
              index: L
            })
          ])), [
            [be, B.active]
          ])), 128))
        ]),
        _: 3
      }, 8, ["class"]),
      e.showDots ? (l(), n("div", Ar, [
        a("ol", Hr, [
          (l(!0), n(X, null, re(t(c), (B, L) => (l(), n("li", {
            class: J(["slide-indicator", h.value === L ? "active" : null]),
            onClick: (H) => O(L),
            key: L
          }, null, 10, Er))), 128))
        ])
      ])) : b("", !0),
      e.showArrows ? (l(), n("button", {
        key: 1,
        class: "button-slide button-slide-left",
        "aria-label": "Previous Slide",
        onClick: M
      }, [
        D(t(oe), {
          "ikone-name": "vpapps-font-chevron-line-left",
          "ikone-style": t(d).style,
          onMouseover: A,
          onMouseleave: le
        }, null, 8, ["ikone-style"])
      ])) : b("", !0),
      e.showArrows ? (l(), n("button", {
        key: 2,
        class: "button-slide button-slide-right",
        onClick: x,
        "aria-label": "Next Slide"
      }, [
        D(t(oe), {
          "ikone-name": "vpapps-font-chevron-line-right",
          "ikone-style": t(d).style,
          onMouseover: A,
          onMouseleave: le
        }, null, 8, ["ikone-style"])
      ])) : b("", !0)
    ], 32));
  }
}, Wr = { class: "flex items-center gap-3 social-items relative z-10" }, Rr = {
  key: 0,
  class: "social-item h-full"
}, zr = ["onClick"], Vr = {
  __name: "JSocialMedia",
  props: {
    // items: {
    //   type: Array,
    //   default: [],
    //   required: true,
    // },
    data: {
      type: Object,
      default: {
        items: {
          type: Array,
          default: [],
          required: !0
        }
      }
    },
    customWrapper: {
      type: String,
      default: "a"
    }
  },
  setup(e) {
    const i = e, o = (c, s) => {
      i.customWrapper !== "div" && (window.open(s, "_blank"), c.preventDefault());
    };
    return (c, s) => (l(), n("ul", Wr, [
      (l(!0), n(X, null, re(e.data.items, (r, y) => (l(), n(X, {
        key: `social-item-${y}`
      }, [
        r && r.url ? (l(), n("li", Rr, [
          a("div", {
            onClick: (d) => o(d, r.url),
            class: "z-10 cursor-pointer w-8 h-8"
          }, [
            D(xe, {
              imageSrc: r.icon,
              alt: `${r.name} Logo`,
              class: "w-full h-auto aspect-square"
            }, null, 8, ["imageSrc", "alt"])
          ], 8, zr)
        ])) : b("", !0)
      ], 64))), 128))
    ]));
  }
}, Tt = /* @__PURE__ */ ne(Vr, [["__scopeId", "data-v-14c16df9"]]), Jr = ["aria-label", "onClick", "onMouseover"], Pr = { class: "flex-1" }, Qi = {
  __name: "JTab",
  props: {
    tabs: {
      type: Array,
      required: !0
    },
    activeTab: {
      type: Number,
      required: !1,
      default: 0
    },
    wrapperClasses: {
      type: String,
      default: "justify-start"
    },
    wrapperStyle: {
      type: Object,
      default: {}
    },
    tabItemStyle: {
      type: Object,
      default: {}
    },
    onTabClickCallback: {
      type: Function,
      required: !1,
      default: null
    },
    // orientation of tab items
    isVertical: {
      type: Boolean,
      default: !1
    },
    // multiple tab items style - row or carousel
    isCarousel: {
      type: Boolean,
      default: !1
    },
    // defines the position of tab items: 1 - top, 2- bottom, 3 - left or 4 - right
    layoutType: {
      type: Number,
      default: 1
    },
    changeOnHover: {
      type: Boolean,
      required: !1,
      default: !1
    },
    iconsStyle: {
      type: Object,
      default: {}
    }
  },
  setup(e) {
    Ie((O) => ({
      "8d08990e": m.value,
      c728adf2: u.value
    }));
    const i = e, { onTabClickCallback: o } = i, { isVertical: c, isCarousel: s, changeOnHover: r, tabItemStyle: y } = ae(i), d = C(i.activeTab), m = C(y.value.backgroundColorOnActive), u = C(y.value.colorOnActive), h = R(
      () => c.value || !s.value ? "div" : he(ft)
    ), f = R(
      () => {
        var O, E;
        return ((E = (O = i.iconsStyle) == null ? void 0 : O.props) == null ? void 0 : E.name) || "vpapps-font-chevron-line-left";
      }
    ), p = (O, E, I, A) => {
      A && A.active && (console.log(O, E, I, A), A.linkType === 1 || A.linkType === 2 || console.log("linkType not supported", A.linkType)), o && o({ tabIndex: E, tabName: I }), d.value = E;
    }, v = (O, E, I, A) => {
      r.value && p(E, I, A);
    }, S = (O) => {
      switch (O) {
        case "ContentSlider":
          return he(di);
        case "ContentGrid":
          return he(tt);
        case "ContentSingle":
          return he(yi);
        case "ContentCarousel":
          return he(xi);
        default:
          return he(tt);
      }
    }, j = (O) => {
      y.value.backgroundColorOnHover && (O.target.style.backgroundColor = y.value.backgroundColorOnHover), y.value.colorOnHover && (O.target.style.color = y.value.colorOnHover), y.value.borderColorOnHover && (O.target.style.borderColor = y.value.borderColorOnHover);
    }, $ = (O) => {
      y.value.backgroundColor && (O.target.style.backgroundColor = y.value.backgroundColor), y.value.color && (O.target.style.color = y.value.color), y.value.borderColor && (O.target.style.borderColor = y.value.borderColor);
    }, N = (O) => {
      y.value.backgroundColorOnActive && (O.target.style.backgroundColor = y.value.backgroundColorOnActive), y.value.colorOnActive && (O.target.style.color = y.value.colorOnActive);
    }, k = (O) => {
      y.value.backgroundColor && (O.target.style.backgroundColor = y.value.backgroundColor), y.value.color && (O.target.style.color = y.value.color);
    }, M = (O) => {
      switch (O) {
        case 2:
          return "flex-col-reverse";
        case 3:
          return "flex-row";
        case 4:
          return "flex-row-reverse";
        default:
          return "flex-col";
      }
    }, x = (O) => {
      var I, A;
      return !r.value || !O.linkData || !((I = O.linkData) != null && I.linkType) ? "div" : ((A = O == null ? void 0 : O.linkData) == null ? void 0 : A.linkType) === 1 ? "a" : "RouterLink";
    }, T = (O) => {
      var I, A;
      return !r.value || !((I = O == null ? void 0 : O.linkData) != null && I.linkType) ? "" : ((A = O == null ? void 0 : O.linkData) == null ? void 0 : A.linkType) === 1 ? "href" : "to";
    };
    return (O, E) => (l(), n("div", {
      class: J(["j-tab flex", M(e.layoutType)])
    }, [
      a("div", {
        class: J(["j-tab-wrapper", e.wrapperClasses])
      }, [
        (l(), F(ge(h.value), {
          style: g(e.wrapperStyle),
          icons: e.iconsStyle,
          class: J(["j-tab-actions", t(c) ? "flex flex-col" : "flex flex-wrap w-full"]),
          "icon-name": f.value
        }, {
          default: q(() => [
            (l(!0), n(X, null, re(e.tabs, (I, A) => {
              var le, Z;
              return l(), F(ge(x(I)), it({
                key: A,
                [T(I) || ""]: (le = I == null ? void 0 : I.linkData) == null ? void 0 : le.url,
                target: (Z = I == null ? void 0 : I.linkData) != null && Z.linkType && t(r) === 1 ? "_blank" : ""
              }), {
                default: q(() => [
                  a("button", {
                    class: J(["j-tab-action-btn w-full", d.value === A ? "active" : null]),
                    "aria-label": I.name,
                    style: g(t(y)),
                    onClick: (W) => p(O.data, A, I.name, I == null ? void 0 : I.linkData),
                    onMouseleave: $,
                    onMousedown: N,
                    onMouseup: k,
                    onMouseover: (W) => v(O.$e, O.data, A, I.name),
                    onMouseenter: j
                  }, w(I.name), 47, Jr)
                ]),
                _: 2
              }, 1040, ["target"]);
            }), 128))
          ]),
          _: 1
        }, 8, ["style", "icons", "class", "icon-name"]))
      ], 2),
      a("div", Pr, [
        (l(!0), n(X, null, re(e.tabs, (I, A) => fe((l(), n("div", { key: A }, [
          K(O.$slots, "tab", {
            tab: I,
            titleWrapperStyle: I.titleWrapperStyle
          }, () => [
            (l(), F(ge(S(I.type)), {
              data: I.data || [],
              widgetIdentifier: I.id,
              titleWrapperStyle: I.titleWrapperStyle
            }, null, 8, ["data", "widgetIdentifier", "titleWrapperStyle"]))
          ])
        ], 512)), [
          [be, d.value === A]
        ])), 128))
      ])
    ], 2));
  }
}, Ur = { class: "user-engagements flex mt-3" }, Ot = {
  __name: "JUserEngagements",
  props: {
    subscribe: {
      type: Boolean,
      required: !1,
      default: !1
    },
    like: {
      type: Boolean,
      required: !1,
      default: !1
    },
    dislike: {
      type: Boolean,
      required: !1,
      default: !1
    },
    watchLater: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: ["customClickEvent"],
  setup(e, { emit: i }) {
    const o = e, { subscribe: c, like: s, dislike: r, watchLater: y } = ae(o), d = i, m = (u) => {
      d("customClickEvent", u);
    };
    return (u, h) => (l(), n("div", Ur, [
      t(c) ? (l(), F(se, {
        key: 0,
        "icon-name": "favorite",
        onClick: h[0] || (h[0] = (f) => m("subscribe")),
        variant: "primary",
        active: !1,
        class: "mb-1 mr-2 flex",
        "aria-label": "Add to favorite"
      }, {
        default: q(() => [
          a("span", null, [
            D(t(oe), { "ikone-name": "vpapps-font-heart-favorite" })
          ]),
          h[4] || (h[4] = a("p", { class: "ml-1" }, "FAVORITE", -1))
        ]),
        _: 1,
        __: [4]
      })) : b("", !0),
      t(y) ? (l(), F(se, {
        key: 1,
        onClick: h[1] || (h[1] = (f) => m("watchLater")),
        "icon-name": "favorite",
        variant: "primary",
        active: !1,
        class: "mb-1 mr-2 flex",
        "aria-label": "Add to watch later"
      }, {
        default: q(() => [
          a("span", null, [
            D(t(oe), { "ikone-name": "vpapps-font-clock-time-alarm-check" })
          ])
        ]),
        _: 1
      })) : b("", !0),
      t(s) ? (l(), F(se, {
        key: 2,
        onClick: h[2] || (h[2] = (f) => m("like")),
        "icon-name": "favorite",
        variant: "primary",
        active: !1,
        class: "mb-1 mr-2 flex",
        "aria-label": "Like"
      }, {
        default: q(() => [
          a("span", null, [
            D(t(oe), { "ikone-name": "vpapps-font-thumbs-up-like" })
          ])
        ]),
        _: 1
      })) : b("", !0),
      t(r) ? (l(), F(se, {
        key: 3,
        onClick: h[3] || (h[3] = (f) => m("dislike")),
        "icon-name": "favorite",
        variant: "primary",
        active: !1,
        class: "mb-1 mr-2 flex",
        "aria-label": "Dislike"
      }, {
        default: q(() => [
          a("span", null, [
            D(t(oe), { "ikone-name": "vpapps-font-thumbs-down-dislike" })
          ])
        ]),
        _: 1
      })) : b("", !0)
    ]));
  }
}, Gr = ["id"], Zr = {
  key: 0,
  class: "flex w-full flex-row gap-1 items-center mb-2"
}, Kr = { class: "flex flex-wrap items-center gap-5 ml-auto justify-end" }, Xr = {
  key: 0,
  class: "flex gap-2 items-center"
}, Qr = { class: "contents" }, Yr = {
  key: 0,
  class: "col-span-full flex justify-center"
}, _r = ["id"], ei = {
  name: "jvp-grid",
  inheritAttrs: !1,
  customOptions: {}
}, ti = /* @__PURE__ */ Object.assign(ei, {
  props: {
    id: {
      type: [Number, String],
      required: !1
    },
    data: {
      type: Array,
      required: !0
    },
    widgetIdentifier: {
      type: [String, Number],
      required: !1,
      default: -1
    },
    loadMoreCallback: {
      type: Function,
      required: !1
    },
    customWrapper: {
      type: String,
      required: !1,
      default: "RouterLink"
    },
    title: {
      type: String,
      required: !1,
      default: ""
    },
    titleStyle: {
      type: Object,
      required: !1,
      default: {}
    },
    wrapperStyle: {
      type: Object,
      required: !1,
      default: {}
    },
    sortByText: {
      type: String,
      required: !1,
      default: "Sort By"
    },
    spacing: {
      type: Number,
      required: !1,
      default: 8
    },
    numberOfColumns: {
      type: Number,
      required: !1,
      default: 6
    },
    contentWrapperStyle: {
      type: Object,
      required: !1,
      default: {
        gap: "10px"
      }
    },
    cardStyle: {
      type: Object,
      default: {
        titleStyle: {},
        infoboxFontStyle: {},
        infoboxStyle: {},
        infoboxWrapperStyle: {},
        style: {},
        imageStyle: {},
        infoboxClasses: "",
        order: "col",
        showTitle: !1,
        showAuthor: !1,
        showViews: !1,
        showDate: !1,
        showThumbnail: !1,
        showTimeDuration: !1
      }
    },
    selectedFilter: {
      type: [Number, String],
      default: 1
    },
    filterOptions: {
      type: Array,
      default: []
    },
    filterContentCallback: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    navigationData: {
      type: Object,
      required: !1,
      default: null
    },
    icons: {
      type: Object,
      required: !1,
      default: () => ({
        props: {
          name: "vpapps-font-filter-sort-descending",
          size: 18
        },
        style: {
          size: "18px",
          color: "black"
        }
      })
    },
    breakpoint: {
      type: String,
      required: !1,
      default: "desktop"
    },
    button: {
      type: Object,
      required: !1,
      default: null
    },
    showButton: {
      type: Boolean,
      required: !1,
      default: !1
    },
    newItemText: {
      type: String,
      default: "New"
    },
    showLoadMoreButton: {
      type: Boolean,
      default: !1
    },
    loadMoreButtonData: {
      type: Object,
      default: null
    },
    showInfiniteScroll: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: i }) {
    const o = e, {
      data: c,
      widgetIdentifier: s,
      loadMoreCallback: r,
      selectedFilter: y,
      filterContentCallback: d,
      titleStyle: m,
      showLoadMoreButton: u
    } = ae(o), h = C(y.value), f = R(() => `grid-cols-${o.numberOfColumns}`), p = ($) => {
      $.target.style.color = m.value.colorOnHover || m.value.color;
    }, v = ($) => {
      $.target.style.color = m.value.color;
    };
    function S() {
      r.value();
    }
    function j() {
      const $ = document.querySelector(`#el-widget-${s == null ? void 0 : s.value}`);
      r.value && $ && Be($, r.value);
    }
    return ke(() => {
      Le(() => {
        u.value || j();
      });
    }), ($, N) => (l(), n("div", {
      class: "j-content-grid-wrapper",
      id: `j-grid-${e.id}`,
      style: g(e.wrapperStyle)
    }, [
      e.title || e.filterOptions.length ? (l(), n("div", Zr, [
        D(t(nt), { data: e.navigationData }, {
          default: q(() => [
            e.title ? (l(), n("p", {
              key: 0,
              class: "contents",
              style: g(t(m)),
              onMouseenter: p,
              onMouseleave: v
            }, w(e.title), 37)) : b("", !0)
          ]),
          _: 1
        }, 8, ["data"]),
        a("div", Kr, [
          e.filterOptions.length ? (l(), n("div", Xr, [
            a("span", {
              style: g({
                color: t(m).color || "#334155"
              })
            }, [
              D(t(oe), {
                "ikone-name": "vpapps-font-filter-sort-descending",
                "ikone-style": e.icons.style
              }, null, 8, ["ikone-style"])
            ], 4),
            D(t(Qe), {
              modelValue: h.value,
              "onUpdate:modelValue": N[0] || (N[0] = (k) => h.value = k),
              options: e.filterOptions,
              "option-value": "id",
              "option-label": "name",
              class: "sort-filters",
              "drop-down-style": {
                color: t(m).color,
                backgroundColor: "white"
              },
              onChange: t(d)
            }, null, 8, ["modelValue", "options", "drop-down-style", "onChange"])
          ])) : b("", !0),
          a("div", null, [
            e.showButton ? K($.$slots, "button", { key: 0 }, () => {
              var k, M, x, T, O, E, I, A;
              return [
                (l(), F(t(He), {
                  class: "z-10",
                  key: (k = e.button) == null ? void 0 : k.id,
                  data: e.button,
                  type: (M = e.button) == null ? void 0 : M.props.type,
                  "custom-wrapper": ((T = (x = e.button) == null ? void 0 : x.props) == null ? void 0 : T.linkType) === 1 ? "a" : e.customWrapper,
                  style: g((O = e.button) == null ? void 0 : O.style),
                  icon: (E = e.button) == null ? void 0 : E.icon,
                  text: (I = e.button) == null ? void 0 : I.props.text,
                  url: (A = e.button) == null ? void 0 : A.props.url,
                  textBeforeIcon: !0
                }, null, 8, ["data", "type", "custom-wrapper", "style", "icon", "text", "url"]))
              ];
            }, !0) : b("", !0)
          ])
        ])
      ])) : b("", !0),
      a("div", {
        class: J(["j-content-grid grid grid-cols-1 last:mb-0", [f.value]]),
        style: g(e.contentWrapperStyle)
      }, [
        (l(!0), n(X, null, re(t(c), (k, M) => {
          var x, T;
          return l(), n("div", {
            class: "content-wrapper",
            key: M
          }, [
            D(t(Xe), {
              cardStyle: e.cardStyle.style,
              order: e.cardStyle.order,
              infoboxFontStyle: e.cardStyle.infoboxFontStyle,
              infoboxStyle: e.cardStyle.infoboxStyle,
              infoboxClasses: e.cardStyle.infoboxClasses,
              infoboxWrapperStyle: e.cardStyle.infoboxWrapperStyle,
              "thumbnail-style": e.cardStyle.thumbnailStyle,
              titleStyle: e.cardStyle.titleStyle,
              showTitle: e.cardStyle.showTitle,
              title: k.title,
              showAuthor: e.cardStyle.showAuthor,
              author: k.author,
              showViews: !1,
              views: "00K Views",
              showDate: e.cardStyle.showDate,
              date: k.startDate,
              showThumbnail: e.cardStyle.showThumbnail,
              showTimeDuration: e.cardStyle.showTimeDuration,
              timeDuration: k.timeDuration,
              mediaid: k.mediaid,
              url: k.url,
              isRedirect: k.isRedirect,
              customWrapper: e.customWrapper,
              breakpoint: e.breakpoint,
              "show-parent-group": e.cardStyle.showParentGroup,
              "parent-group-style": e.cardStyle.parentGroupStyle,
              "parent-group-name": (x = k.parentGroup) == null ? void 0 : x.name,
              "parent-group-url": (T = k.parentGroup) == null ? void 0 : T.url,
              "show-progress-bar": e.cardStyle.showProgressBar,
              "progress-bar-config": e.cardStyle.progressBarStyle,
              "progress-bar-value": k.progressBarValue,
              "is-new": k.isNew,
              "new-item-text": e.newItemText
            }, {
              image: q(() => [
                K($.$slots, "card-image", $e({ ref_for: !0 }, {
                  image: k.img,
                  style: e.cardStyle.imageStyle,
                  filmstrip: k.filmstrip,
                  index: M,
                  alt: k.title
                }), () => [
                  D(t(xe), {
                    imageSrc: k.img,
                    alt: k.title,
                    class: "w-full",
                    style: g(e.cardStyle.imageStyle)
                  }, null, 8, ["imageSrc", "alt", "style"])
                ], !0)
              ]),
              badge: q(() => [
                (l(!0), n(X, null, re($.formatedBadges, (O, E) => (l(), n(X, null, [
                  O.classes ? (l(), F(t(Ee), {
                    key: E,
                    style: g(O.style),
                    class: J(O.classes)
                  }, {
                    default: q(() => [
                      _(w(O.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["style", "class"])) : b("", !0)
                ], 64))), 256))
              ]),
              _: 2
            }, 1032, ["cardStyle", "order", "infoboxFontStyle", "infoboxStyle", "infoboxClasses", "infoboxWrapperStyle", "thumbnail-style", "titleStyle", "showTitle", "title", "showAuthor", "author", "showDate", "date", "showThumbnail", "showTimeDuration", "timeDuration", "mediaid", "url", "isRedirect", "customWrapper", "breakpoint", "show-parent-group", "parent-group-style", "parent-group-name", "parent-group-url", "show-progress-bar", "progress-bar-config", "progress-bar-value", "is-new", "new-item-text"])
          ]);
        }), 128)),
        a("div", Qr, [
          t(u) ? (l(), n("div", Yr, [
            K($.$slots, "loadMoreButton", {}, () => [
              e.loadMoreButtonData ? (l(), F(t(He), {
                key: 0,
                class: "z-10",
                "custom-wrapper": "div",
                type: e.loadMoreButtonData.props.type,
                style: g(e.loadMoreButtonData.style),
                icon: e.loadMoreButtonData.icon,
                text: e.loadMoreButtonData.props.text,
                onClick: S
              }, null, 8, ["type", "style", "icon", "text"])) : b("", !0)
            ], !0)
          ])) : b("", !0),
          t(s) != -1 && e.showInfiniteScroll ? (l(), n("div", {
            key: 1,
            id: `el-widget-${t(s)}`
          }, null, 8, _r)) : b("", !0)
        ])
      ], 6)
    ], 12, Gr));
  }
}), tt = /* @__PURE__ */ ne(ti, [["__scopeId", "data-v-32298800"]]), li = {
  key: 0,
  class: "flex w-full flex-row gap-1 items-center mb-2"
}, ai = { class: "basis-1/2" }, oi = {
  key: 0,
  class: "flex flex-wrap items-center gap-2 ml-auto basis-1/2 justify-end"
}, ni = ["id"], si = {
  __name: "JContentGridSceleton",
  props: {
    data: {
      type: Array,
      required: !0
    },
    widgetIdentifier: {
      type: [String, Number],
      required: !1
    },
    loadMoreCallback: {
      type: Function,
      required: !1
    },
    customWrapper: {
      type: String,
      required: !1,
      default: "RouterLink"
    },
    title: {
      type: String,
      required: !1,
      default: ""
    },
    titleStyle: {
      type: Object,
      required: !1,
      default: {}
    },
    wrapperStyle: {
      type: Object,
      required: !1,
      default: {
        padding: "10px"
      }
    },
    sortByText: {
      type: String,
      required: !1,
      default: "Sort By"
    },
    spacing: {
      type: Number,
      required: !1,
      default: 8
    },
    numberOfColumns: {
      type: Number,
      required: !1,
      default: 6
    },
    contentWrapperStyle: {
      type: Object,
      required: !1,
      default: {
        gap: "10px"
      }
    },
    cardStyle: {
      type: Object,
      default: {
        titleStyle: {},
        infoboxFontStyle: {},
        infoboxStyle: {},
        infoboxWrapperStyle: {},
        style: {},
        imageStyle: {},
        infoboxClasses: "",
        order: "col",
        showTitle: !1,
        showAuthor: !1,
        showViews: !1,
        showDate: !1,
        showThumbnail: !1,
        showTimeDuration: !1
      }
    },
    selectedFilter: {
      type: [Number, String],
      default: 1
    },
    filterOptions: {
      type: Array,
      default: []
    },
    filterContentCallback: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    navigationData: {
      type: Object,
      required: !1,
      default: null
    },
    breakpoint: {
      type: String,
      required: !1,
      default: "desktop"
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: i }) {
    const o = e, {
      data: c,
      widgetIdentifier: s,
      loadMoreCallback: r,
      selectedFilter: y,
      filterContentCallback: d
    } = ae(o), m = C(y.value), u = R(() => `grid-cols-${o.numberOfColumns}`);
    return (h, f) => (l(), n("div", {
      class: "j-content-grid-sceleton j-content-grid-wrapper",
      style: g(e.wrapperStyle)
    }, [
      e.title || e.filterOptions.length ? (l(), n("div", li, [
        a("div", ai, [
          e.title ? (l(), n("h3", {
            key: 0,
            style: g(e.titleStyle),
            class: "j-content-grid-sceleton-title contents"
          }, w(e.title), 5)) : b("", !0)
        ]),
        e.filterOptions.length ? (l(), n("div", oi, [
          a("span", {
            style: g({
              color: e.titleStyle.color ? e.titleStyle.color : "#334155"
            })
          }, [
            D(t(oe), { "ikone-name": "vpapps-font-filter-sort-descending" })
          ], 4),
          D(t(Qe), {
            modelValue: m.value,
            "onUpdate:modelValue": f[0] || (f[0] = (p) => m.value = p),
            options: [],
            "option-value": "id",
            "option-label": "name",
            class: "sort-filters",
            "drop-down-style": {
              color: e.titleStyle.color,
              backgroundColor: "white"
            },
            onChange: t(d)
          }, null, 8, ["modelValue", "drop-down-style", "onChange"])
        ])) : b("", !0)
      ])) : b("", !0),
      a("div", {
        class: J(["j-content-grid grid grid-cols-1 last:mb-0", [u.value]]),
        style: g(e.contentWrapperStyle)
      }, [
        (l(!0), n(X, null, re(t(c), (p, v) => (l(), n("div", {
          class: "content-wrapper",
          key: v
        }, [
          D(t(wt), {
            cardStyle: e.cardStyle.style,
            order: e.cardStyle.order,
            infoboxFontStyle: e.cardStyle.infoboxFontStyle,
            infoboxStyle: e.cardStyle.infoboxStyle,
            infoboxClasses: e.cardStyle.infoboxClasses,
            infoboxWrapperStyle: e.cardStyle.infoboxWrapperStyle,
            titleStyle: e.cardStyle.titleStyle,
            showTitle: e.cardStyle.showTitle,
            title: p.title,
            showAuthor: e.cardStyle.showAuthor,
            author: p.author,
            showViews: !1,
            views: "00K Views",
            showDate: e.cardStyle.showDate,
            date: p.startDate,
            showThumbnail: e.cardStyle.showThumbnail,
            showTimeDuration: e.cardStyle.showTimeDuration,
            timeDuration: p.timeDuration,
            mediaid: p.mediaid,
            url: p.url,
            isRedirect: p.isRedirect,
            customWrapper: e.customWrapper,
            breakpoint: e.breakpoint
          }, {
            image: q(() => [
              K(h.$slots, "card-image", $e({ ref_for: !0 }, {
                image: p.img,
                style: e.cardStyle.imageStyle,
                filmstrip: p.filmstrip
              }), () => [
                a("div", {
                  class: "w-full",
                  style: g(e.cardStyle.imageStyle)
                }, null, 4)
              ], !0)
            ]),
            badge: q(() => [
              (l(!0), n(X, null, re(h.formatedBadges, (S, j) => (l(), n(X, null, [
                S.classes ? (l(), F(t(Ee), {
                  key: j,
                  style: g(S.style),
                  class: J(S.classes)
                }, {
                  default: q(() => [
                    _(w(S.name), 1)
                  ]),
                  _: 2
                }, 1032, ["style", "class"])) : b("", !0)
              ], 64))), 256))
            ]),
            _: 2
          }, 1032, ["cardStyle", "order", "infoboxFontStyle", "infoboxStyle", "infoboxClasses", "infoboxWrapperStyle", "titleStyle", "showTitle", "title", "showAuthor", "author", "showDate", "date", "showThumbnail", "showTimeDuration", "timeDuration", "mediaid", "url", "isRedirect", "customWrapper", "breakpoint"])
        ]))), 128)),
        a("div", {
          id: `el-widget-${t(s)}`
        }, null, 8, ni)
      ], 6)
    ], 4));
  }
}, Yi = /* @__PURE__ */ ne(si, [["__scopeId", "data-v-5e90814d"]]), ri = {
  key: 0,
  class: "flex w-full flex-row gap-1 items-center mb-2"
}, ii = { class: "flex flex-wrap items-center gap-5 ml-auto justify-end" }, ui = {
  key: 0,
  class: "flex gap-2 items-center"
}, ci = {
  __name: "JContentSlider",
  props: {
    data: {
      type: Object,
      required: !1
    },
    customWrapper: {
      type: String,
      required: !1,
      default: "RouterLink"
    },
    icons: {
      type: Object,
      required: !1,
      default: () => ({
        props: {
          name: "vpapps-font-arrow-right",
          size: 18
        },
        style: {
          size: "18px",
          color: "black"
        }
      })
    },
    title: {
      type: String,
      required: !1,
      default: ""
    },
    titleStyle: {
      type: Object,
      required: !1,
      default: {}
    },
    wrapperStyle: {
      type: Object,
      required: !1,
      default: {
        padding: "10px"
      }
    },
    spacing: {
      type: Number,
      required: !1,
      default: 8
    },
    cardStyle: {
      type: Object,
      default: {
        titleStyle: {},
        infoboxFontStyle: {},
        infoboxStyle: {},
        infoboxWrapperStyle: {},
        style: {},
        imageStyle: {},
        infoboxClasses: "",
        order: "col",
        showTitle: !1,
        showAuthor: !1,
        showViews: !1,
        showDate: !1,
        showThumbnail: !1,
        showTimeDuration: !1
      }
    },
    selectedFilters: {
      type: Array,
      default: []
    },
    filterOptions: {
      type: Array,
      default: []
    },
    breakpoint: {
      type: String,
      required: !1,
      default: "desktop"
    },
    button: {
      type: Object,
      required: !1,
      default: null
    },
    showButton: {
      type: Boolean,
      required: !1,
      default: !1
    },
    newItemText: {
      type: String,
      default: "New"
    }
  },
  setup(e) {
    const i = e, { selectedFilters: o, titleStyle: c } = ae(i), s = [
      {
        title: "Shows 2",
        timeDuration: "00:00",
        publishdate: "Invalid Date",
        img: null,
        component: "JCard",
        url: "content/undefined"
      },
      {
        title: "Gaming",
        timeDuration: "00:00",
        publishdate: "Invalid Date",
        img: null,
        component: "JCard",
        url: "content/undefined"
      },
      {
        title: "General",
        timeDuration: "00:00",
        publishdate: "Invalid Date",
        img: null,
        component: "JCard",
        url: "content/undefined"
      },
      {
        title: "Music",
        timeDuration: "00:00",
        publishdate: "Invalid Date",
        img: null,
        component: "JCard",
        url: "content/undefined"
      },
      {
        title: "Cars",
        timeDuration: "00:00",
        publishdate: "Invalid Date",
        img: null,
        component: "JCard",
        url: "content/undefined"
      },
      {
        title: "6 mars season",
        timeDuration: "00:00",
        publishdate: "Invalid Date",
        img: null,
        component: "JCard",
        url: "content/undefined"
      },
      {
        title: "test fat",
        timeDuration: "00:00",
        publishdate: "Invalid Date",
        img: null,
        component: "JCard",
        url: "content/undefined"
      },
      {
        title: "Smartphones",
        timeDuration: "00:00",
        publishdate: "Invalid Date",
        img: null,
        component: "JCard",
        url: "content/undefined"
      }
    ], r = (d) => {
      d.target.style.color = c.value.colorOnHover || c.value.color;
    }, y = (d) => {
      d.target.style.color = c.value.color;
    };
    return (d, m) => (l(), n("div", {
      class: "j-content-slider h-full",
      style: g(e.wrapperStyle)
    }, [
      e.title || e.filterOptions.length ? (l(), n("div", ri, [
        e.title ? (l(), n("p", {
          key: 0,
          class: "contents",
          style: g(t(c)),
          onMouseenter: r,
          onMouseleave: y
        }, w(e.title), 37)) : b("", !0),
        a("div", ii, [
          e.filterOptions.length ? (l(), n("div", ui, [
            a("span", {
              style: g({
                color: t(c).color || "#334155"
              })
            }, [
              D(t(oe), {
                "ikone-name": "vpapps-font-filter-sort-descending",
                "ikone-style": e.icons.style
              }, null, 8, ["ikone-style"])
            ], 4),
            D(t(Qe), {
              modelValue: t(o),
              "onUpdate:modelValue": m[0] || (m[0] = (u) => Bt(o) ? o.value = u : null),
              options: e.filterOptions,
              class: "sort-filters",
              "drop-down-style": {
                color: t(c).color,
                backgroundColor: "white"
              }
            }, null, 8, ["modelValue", "options", "drop-down-style"])
          ])) : b("", !0),
          a("div", null, [
            e.showButton ? K(d.$slots, "button", { key: 0 }, () => {
              var u, h, f, p, v, S, j, $;
              return [
                (l(), F(t(He), {
                  class: "z-10",
                  key: (u = e.button) == null ? void 0 : u.id,
                  data: e.button,
                  type: (h = e.button) == null ? void 0 : h.props.type,
                  "custom-wrapper": ((p = (f = e.button) == null ? void 0 : f.props) == null ? void 0 : p.linkType) === 1 ? "a" : e.customWrapper,
                  style: g((v = e.button) == null ? void 0 : v.style),
                  icon: (S = e.button) == null ? void 0 : S.icon,
                  text: (j = e.button) == null ? void 0 : j.props.text,
                  url: ($ = e.button) == null ? void 0 : $.props.url,
                  textBeforeIcon: !0
                }, null, 8, ["data", "type", "custom-wrapper", "style", "icon", "text", "url"]))
              ];
            }, !0) : b("", !0)
          ])
        ])
      ])) : b("", !0),
      D(t(Nr), {
        slides: s,
        autoSlide: !1,
        scrollInterval: 7,
        activeSlide: 0,
        animationTime: "1s",
        showIndicators: !1,
        icons: e.icons
      }, {
        slide: q((u) => {
          var h, f;
          return [
            e.cardStyle ? (l(), F(t(Xe), {
              key: 0,
              cardStyle: e.cardStyle.style,
              order: e.cardStyle.order,
              infoboxFontStyle: e.cardStyle.infoboxFontStyle,
              infoboxStyle: e.cardStyle.infoboxStyle,
              infoboxClasses: e.cardStyle.infoboxClasses,
              infoboxWrapperStyle: e.cardStyle.infoboxWrapperStyle,
              "thumbnail-style": e.cardStyle.thumbnailStyle,
              titleStyle: e.cardStyle.titleStyle,
              showTitle: e.cardStyle.showTitle,
              title: u.slide.title,
              showAuthor: e.cardStyle.showAuthor,
              author: u.slide.author,
              showViews: e.cardStyle.showViews,
              views: u.slide.views,
              showDate: e.cardStyle.showDate,
              date: u.slide.startDate,
              showThumbnail: e.cardStyle.showThumbnail,
              showTimeDuration: e.cardStyle.showTimeDuration,
              timeDuration: u.slide.timeDuration,
              customWrapper: e.customWrapper,
              url: u.slide.url,
              breakpoint: e.breakpoint,
              "show-parent-group": e.cardStyle.showParentGroup,
              "parent-group-style": e.cardStyle.parentGroupStyle,
              "parent-group-name": (h = u.slide.parentGroup) == null ? void 0 : h.name,
              "parent-group-url": (f = u.slide.parentGroup) == null ? void 0 : f.url,
              "show-progress-bar": e.cardStyle.showProgressBar,
              "progress-bar-config": e.cardStyle.progressBarStyle,
              "progress-bar-value": u.slide.progressBarValue,
              "is-new": u.slide.isNew,
              "new-item-text": e.newItemText
            }, {
              image: q(() => [
                D(t(xe), {
                  imageSrc: u.slide.IMG,
                  alt: u.slide.title,
                  class: "w-full",
                  style: g(e.cardStyle.imageStyle)
                }, null, 8, ["imageSrc", "alt", "style"])
              ]),
              badge: q(() => [
                (l(!0), n(X, null, re(d.formatedBadges, (p, v) => (l(), n(X, null, [
                  p.classes ? (l(), F(t(Ee), {
                    key: v,
                    style: g(p.style),
                    class: J(p.classes)
                  }, {
                    default: q(() => [
                      _(w(p.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["style", "class"])) : b("", !0)
                ], 64))), 256))
              ]),
              _: 2
            }, 1032, ["cardStyle", "order", "infoboxFontStyle", "infoboxStyle", "infoboxClasses", "infoboxWrapperStyle", "thumbnail-style", "titleStyle", "showTitle", "title", "showAuthor", "author", "showViews", "views", "showDate", "date", "showThumbnail", "showTimeDuration", "timeDuration", "customWrapper", "url", "breakpoint", "show-parent-group", "parent-group-style", "parent-group-name", "parent-group-url", "show-progress-bar", "progress-bar-config", "progress-bar-value", "is-new", "new-item-text"])) : b("", !0)
          ];
        }),
        _: 1
      }, 8, ["icons"])
    ], 4));
  }
}, di = /* @__PURE__ */ ne(ci, [["__scopeId", "data-v-802c24da"]]), fi = { class: "flex" }, yi = {
  __name: "JContentSingle",
  props: {
    data: {
      type: Object,
      required: !0
    },
    title: {
      type: String,
      required: !1,
      default: ""
    },
    customWrapper: {
      type: String,
      required: !1,
      default: "RouterLink"
    },
    titleStyle: {
      type: Object,
      required: !1,
      default: { fontWeight: "bold" }
    },
    wrapperStyle: {
      type: Object,
      required: !1,
      default: {
        padding: "10px"
      }
    },
    cardStyle: {
      type: Object,
      default: {
        titleStyle: {},
        infoboxFontStyle: {},
        infoboxStyle: {},
        infoboxWrapperStyle: {},
        style: {},
        imageStyle: {},
        infoboxClasses: "",
        order: "col",
        showTitle: !1,
        showAuthor: !1,
        showViews: !1,
        showDate: !1,
        showThumbnail: !1,
        showTimeDuration: !1
      }
    },
    breakpoint: {
      type: String,
      required: !1,
      default: "desktop"
    },
    newItemText: {
      type: String,
      default: "New"
    }
  },
  setup(e) {
    const i = e, { data: o, customWrapper: c, titleStyle: s } = ae(i), r = (d) => {
      d.target.style.color = s.value.colorOnHover || s.value.color;
    }, y = (d) => {
      d.target.style.color = s.value.color;
    };
    return (d, m) => {
      var u, h;
      return t(o) ? (l(), n("div", {
        key: 0,
        class: "j-content-single",
        style: g(e.wrapperStyle)
      }, [
        a("div", fi, [
          e.title ? (l(), n("h3", {
            key: 0,
            class: "mb-2",
            style: g(t(s)),
            onMouseenter: r,
            onMouseleave: y
          }, w(e.title), 37)) : b("", !0)
        ]),
        D(t(Xe), {
          cardStyle: e.cardStyle.style,
          order: e.cardStyle.order,
          infoboxFontStyle: e.cardStyle.infoboxFontStyle,
          infoboxStyle: e.cardStyle.infoboxStyle,
          infoboxClasses: e.cardStyle.infoboxClasses,
          infoboxWrapperStyle: e.cardStyle.infoboxWrapperStyle,
          "thumbnail-style": e.cardStyle.thumbnailStyle,
          titleStyle: e.cardStyle.titleStyle,
          showTitle: e.cardStyle.showTitle,
          title: t(o).title,
          showAuthor: e.cardStyle.showAuthor,
          author: t(o).author,
          showViews: e.cardStyle.showViews,
          views: t(o).views,
          showDate: e.cardStyle.showDate,
          date: t(o).startDate,
          showThumbnail: e.cardStyle.showThumbnail,
          showTimeDuration: e.cardStyle.showTimeDuration,
          timeDuration: t(o).timeDuration,
          mediaid: t(o).mediaid,
          url: t(o).url,
          customWrapper: t(c),
          breakpoint: e.breakpoint,
          "show-parent-group": e.cardStyle.showParentGroup,
          "parent-group-style": e.cardStyle.parentGroupStyle,
          "parent-group-name": (u = t(o).parentGroup) == null ? void 0 : u.name,
          "parent-group-url": (h = t(o).parentGroup) == null ? void 0 : h.url,
          "show-progress-bar": e.cardStyle.showProgressBar,
          "progress-bar-config": e.cardStyle.progressBarStyle,
          "progress-bar-value": t(o).progressBarValue,
          "is-new": t(o).isNew,
          "new-item-text": e.newItemText
        }, {
          image: q(() => [
            D(t(xe), {
              imageSrc: t(o).img,
              alt: "Video Card Placeholder",
              class: "w-full",
              style: g(e.cardStyle.imageStyle)
            }, null, 8, ["imageSrc", "style"])
          ]),
          badge: q(() => [
            (l(!0), n(X, null, re(d.formatedBadges, (f, p) => (l(), n(X, null, [
              f.classes ? (l(), F(t(Ee), {
                key: p,
                style: g(f.style),
                class: J(f.classes)
              }, {
                default: q(() => [
                  _(w(f.name), 1)
                ]),
                _: 2
              }, 1032, ["style", "class"])) : b("", !0)
            ], 64))), 256))
          ]),
          _: 1
        }, 8, ["cardStyle", "order", "infoboxFontStyle", "infoboxStyle", "infoboxClasses", "infoboxWrapperStyle", "thumbnail-style", "titleStyle", "showTitle", "title", "showAuthor", "author", "showViews", "views", "showDate", "date", "showThumbnail", "showTimeDuration", "timeDuration", "mediaid", "url", "customWrapper", "breakpoint", "show-parent-group", "parent-group-style", "parent-group-name", "parent-group-url", "show-progress-bar", "progress-bar-config", "progress-bar-value", "is-new", "new-item-text"])
      ], 4)) : b("", !0);
    };
  }
}, pi = {
  class: "j-content-carousel",
  id: "j-carousel"
}, mi = {
  key: 0,
  class: "flex w-full flex-row gap-4 items-center mb-2"
}, vi = { class: "flex flex-wrap items-center gap-5 ml-auto justify-end" }, gi = {
  key: 0,
  class: "flex gap-2 items-center"
}, hi = { class: "j-content-grid block flex-nowrap" }, bi = {
  name: "jvp-carousel",
  inheritAttrs: !1,
  customOptions: {}
}, wi = /* @__PURE__ */ Object.assign(bi, {
  props: {
    data: {
      type: Array,
      required: !0
    },
    widgetIdentifier: {
      type: [String, Number],
      required: !1
    },
    loadMoreCallback: {
      type: Function,
      required: !1
    },
    customWrapper: {
      type: String,
      required: !1,
      default: "RouterLink"
    },
    icons: {
      type: Object,
      required: !1,
      default: () => ({
        props: {
          name: "vpapps-font-arrow-right",
          size: 18
        },
        style: {
          size: "18px",
          color: "black"
        }
      })
    },
    title: {
      type: String,
      required: !1,
      default: ""
    },
    titleStyle: {
      type: Object,
      required: !1,
      default: {}
    },
    sortByText: {
      type: String,
      required: !1,
      default: "Sort By"
    },
    spacing: {
      type: Number,
      required: !1,
      default: 8
    },
    numberOfColumns: {
      type: Number,
      required: !1,
      default: 6
    },
    contentWrapperStyle: {
      type: Object,
      required: !1,
      default: {
        gap: "10px"
      }
    },
    blurColor: {
      type: [String, Number, null],
      required: !1,
      default: null
    },
    cardStyle: {
      type: Object,
      default: {
        titleStyle: {},
        infoboxFontStyle: {},
        infoboxStyle: {},
        infoboxWrapperStyle: {},
        style: {},
        imageStyle: {},
        infoboxClasses: "",
        order: "col",
        showTitle: !1,
        showAuthor: !1,
        showViews: !1,
        showDate: !1,
        showThumbnail: !1,
        showTimeDuration: !1
      }
    },
    selectedFilter: {
      type: [Number, String],
      default: 1
    },
    filterOptions: {
      type: Array,
      default: []
    },
    filterContentCallback: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    generalStyle: {
      type: Object,
      required: !1,
      default: {
        titleStyle: {},
        wrapperStyle: {
          backgroundColor: "transparent"
        },
        itemStyle: {
          backgroundColor: "white",
          color: "black"
        },
        hoverColors: {
          backgroundColor: "blue",
          color: "red",
          active: "#FFAB00"
        }
      }
    },
    navigationData: {
      type: Object,
      required: !1,
      default: null
    },
    breakpoint: {
      type: String,
      required: !1,
      default: "desktop"
    },
    button: {
      type: Object,
      required: !1,
      default: null
    },
    showButton: {
      type: Boolean,
      required: !1,
      default: !1
    },
    newItemText: {
      type: String,
      default: "New"
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: i }) {
    Ie(($) => ({
      "9fde819e": t(v)
    }));
    const o = e, {
      data: c,
      icons: s,
      blurColor: r,
      widgetIdentifier: y,
      loadMoreCallback: d,
      selectedFilter: m,
      filterContentCallback: u,
      titleStyle: h,
      button: f
    } = ae(o), p = C(m.value);
    let v = "";
    r.value ? v = `${r.value} 5%,
  ${r.value.replace(")", "-c)")} 40%,
  rgba(255, 255, 255, 0) 100%` : v = "transparent, transparent";
    const S = ($) => {
      $.target.style.color = h.value.colorOnHover || h.value.color;
    }, j = ($) => {
      $.target.style.color = h.value.color;
    };
    return ke(() => {
      Le(() => {
        if (!d.value) return;
        const $ = document.querySelector(`#el-widget-${y.value}`);
        Be($, d.value);
      });
    }), ($, N) => (l(), n("div", pi, [
      e.title || e.filterOptions.length ? (l(), n("div", mi, [
        D(t(nt), { data: e.navigationData }, {
          default: q(() => [
            e.title ? (l(), n("p", {
              key: 0,
              class: "contents",
              style: g(t(h)),
              onMouseenter: S,
              onMouseleave: j
            }, w(e.title), 37)) : b("", !0)
          ]),
          _: 1
        }, 8, ["data"]),
        a("div", vi, [
          e.filterOptions.length ? (l(), n("div", gi, [
            a("span", {
              style: g({
                color: t(h).color || "#334155"
              })
            }, [
              D(t(oe), {
                "ikone-name": "vpapps-font-filter-sort-descending",
                style: g(t(s).style)
              }, null, 8, ["style"])
            ], 4),
            D(t(Qe), {
              modelValue: p.value,
              "onUpdate:modelValue": N[0] || (N[0] = (k) => p.value = k),
              options: e.filterOptions,
              "option-value": "id",
              "option-label": "name",
              class: "sort-filters",
              "drop-down-style": {
                color: t(h).color,
                backgroundColor: "white"
              },
              onChange: t(u)
            }, null, 8, ["modelValue", "options", "drop-down-style", "onChange"])
          ])) : b("", !0),
          a("div", null, [
            e.showButton ? K($.$slots, "button", { key: 0 }, () => {
              var k, M, x, T, O, E, I, A;
              return [
                (l(), F(t(He), {
                  class: "z-10",
                  key: (k = t(f)) == null ? void 0 : k.id,
                  data: t(f),
                  type: (M = t(f)) == null ? void 0 : M.props.type,
                  "custom-wrapper": ((T = (x = t(f)) == null ? void 0 : x.props) == null ? void 0 : T.linkType) === 1 ? "a" : e.customWrapper,
                  style: g((O = t(f)) == null ? void 0 : O.style),
                  icon: (E = t(f)) == null ? void 0 : E.icon,
                  text: (I = t(f)) == null ? void 0 : I.props.text,
                  url: (A = t(f)) == null ? void 0 : A.props.url,
                  textBeforeIcon: !0
                }, null, 8, ["data", "type", "custom-wrapper", "style", "icon", "text", "url"]))
              ];
            }, !0) : b("", !0)
          ])
        ])
      ])) : b("", !0),
      a("div", hi, [
        D(ft, {
          style: g(e.contentWrapperStyle),
          "general-style": e.generalStyle,
          icons: t(s)
        }, {
          default: q(() => [
            (l(!0), n(X, null, re(t(c), (k, M) => {
              var x, T;
              return l(), n("div", {
                class: "content-wrapper",
                style: g({
                  minWidth: `${100 / e.numberOfColumns}%`,
                  width: `${100 / e.numberOfColumns}%`
                }),
                key: M
              }, [
                D(t(Xe), {
                  cardStyle: e.cardStyle.style,
                  order: e.cardStyle.order,
                  infoboxFontStyle: e.cardStyle.infoboxFontStyle,
                  infoboxStyle: e.cardStyle.infoboxStyle,
                  infoboxClasses: e.cardStyle.infoboxClasses,
                  infoboxWrapperStyle: e.cardStyle.infoboxWrapperStyle,
                  "thumbnail-style": e.cardStyle.thumbnailStyle,
                  titleStyle: e.cardStyle.titleStyle,
                  showTitle: e.cardStyle.showTitle,
                  title: k.title,
                  showAuthor: e.cardStyle.showAuthor,
                  author: k.author,
                  showViews: !1,
                  views: "00K Views",
                  showDate: e.cardStyle.showDate,
                  date: k.startDate,
                  showThumbnail: e.cardStyle.showThumbnail,
                  showTimeDuration: e.cardStyle.showTimeDuration,
                  timeDuration: k.timeDuration,
                  mediaid: k.mediaid,
                  url: k.url,
                  isRedirect: k.isRedirect,
                  customWrapper: e.customWrapper,
                  breakpoint: e.breakpoint,
                  "show-parent-group": e.cardStyle.showParentGroup,
                  "parent-group-style": e.cardStyle.parentGroupStyle,
                  "parent-group-name": (x = k.parentGroup) == null ? void 0 : x.name,
                  "parent-group-url": (T = k.parentGroup) == null ? void 0 : T.url,
                  "show-progress-bar": e.cardStyle.showProgressBar,
                  "progress-bar-config": e.cardStyle.progressBarStyle,
                  "progress-bar-value": k.progressBarValue,
                  "is-new": k.isNew,
                  "new-item-text": e.newItemText
                }, {
                  image: q(() => [
                    K($.$slots, "card-image", $e({ ref_for: !0 }, {
                      image: k.img,
                      style: e.cardStyle.imageStyle,
                      filmstrip: k.filmstrip,
                      index: M,
                      alt: k.title
                    }), () => [
                      D(t(xe), {
                        imageSrc: k.img,
                        alt: k.title,
                        class: "w-full",
                        "no-lazy-image": M < 3,
                        style: g(e.cardStyle.imageStyle)
                      }, null, 8, ["imageSrc", "alt", "no-lazy-image", "style"])
                    ], !0)
                  ]),
                  badge: q(() => [
                    (l(!0), n(X, null, re($.formatedBadges, (O, E) => (l(), n(X, null, [
                      O.classes ? (l(), F(t(Ee), {
                        key: E,
                        style: g(O.style),
                        class: J(O.classes)
                      }, {
                        default: q(() => [
                          _(w(O.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["style", "class"])) : b("", !0)
                    ], 64))), 256))
                  ]),
                  _: 2
                }, 1032, ["cardStyle", "order", "infoboxFontStyle", "infoboxStyle", "infoboxClasses", "infoboxWrapperStyle", "thumbnail-style", "titleStyle", "showTitle", "title", "showAuthor", "author", "showDate", "date", "showThumbnail", "showTimeDuration", "timeDuration", "mediaid", "url", "isRedirect", "customWrapper", "breakpoint", "show-parent-group", "parent-group-style", "parent-group-name", "parent-group-url", "show-progress-bar", "progress-bar-config", "progress-bar-value", "is-new", "new-item-text"])
              ], 4);
            }), 128))
          ]),
          _: 3
        }, 8, ["style", "general-style", "icons"])
      ])
    ]));
  }
}), xi = /* @__PURE__ */ ne(wi, [["__scopeId", "data-v-e0b853f1"]]), ki = { class: "j-content-carousel" }, Si = {
  key: 0,
  class: "flex w-full flex-row gap-1 items-center mb-2"
}, Ci = {
  key: 0,
  class: "flex flex-wrap items-center gap-2 ml-auto basis-1/2 justify-end"
}, $i = { class: "j-content-grid block flex-nowrap" }, Ti = {
  __name: "JContentCarouselSkeleton",
  props: {
    data: {
      type: Array,
      required: !0
    },
    widgetIdentifier: {
      type: [String, Number],
      required: !1
    },
    loadMoreCallback: {
      type: Function,
      required: !1
    },
    customWrapper: {
      type: String,
      required: !1,
      default: "RouterLink"
    },
    icons: {
      type: Object,
      required: !1,
      default: () => ({
        props: {
          name: "vpapps-font-arrow-right",
          size: 18
        },
        style: {
          size: "18px",
          color: "black"
        }
      })
    },
    title: {
      type: String,
      required: !1,
      default: ""
    },
    titleStyle: {
      type: Object,
      required: !1,
      default: {}
    },
    sortByText: {
      type: String,
      required: !1,
      default: "Sort By"
    },
    spacing: {
      type: Number,
      required: !1,
      default: 8
    },
    numberOfColumns: {
      type: Number,
      required: !1,
      default: 6
    },
    contentWrapperStyle: {
      type: Object,
      required: !1,
      default: {
        gap: "10px"
      }
    },
    blurColor: {
      type: [String, Number, null],
      required: !1,
      default: null
    },
    cardStyle: {
      type: Object,
      default: {
        titleStyle: {},
        infoboxFontStyle: {},
        infoboxStyle: {},
        infoboxWrapperStyle: {},
        style: {},
        imageStyle: {},
        infoboxClasses: "",
        order: "col",
        showTitle: !1,
        showAuthor: !1,
        showViews: !1,
        showDate: !1,
        showThumbnail: !1,
        showTimeDuration: !1
      }
    },
    selectedFilter: {
      type: [Number, String],
      default: 1
    },
    filterOptions: {
      type: Array,
      default: []
    },
    filterContentCallback: {
      type: Function,
      required: !1,
      default: () => {
      }
    },
    generalStyle: {
      type: Object,
      required: !1,
      default: {
        titleStyle: {},
        wrapperStyle: {
          backgroundColor: "transparent"
        },
        itemStyle: {
          backgroundColor: "white",
          color: "black"
        },
        hoverColors: {
          backgroundColor: "blue",
          color: "red",
          active: "#FFAB00"
        }
      }
    },
    navigationData: {
      type: Object,
      required: !1,
      default: null
    },
    breakpoint: {
      type: String,
      required: !1,
      default: "desktop"
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: i }) {
    const o = e, {
      data: c,
      icons: s,
      blurColor: r,
      widgetIdentifier: y,
      loadMoreCallback: d,
      selectedFilter: m,
      filterContentCallback: u
    } = ae(o), h = C(m.value);
    return ke(() => {
      Le(() => {
        if (!d.value) return;
        const f = document.querySelector(`#el-widget-${y.value}`);
        Be(f, d.value);
      });
    }), R(() => `grid-cols-${o.numberOfColumns}`), (f, p) => (l(), n("div", ki, [
      e.title || e.filterOptions.length ? (l(), n("div", Si, [
        D(t(nt), {
          data: e.navigationData,
          class: "basis-1/2"
        }, {
          default: q(() => [
            e.title ? (l(), n("p", {
              key: 0,
              style: g(e.titleStyle),
              class: "contents"
            }, w(e.title), 5)) : b("", !0)
          ]),
          _: 1
        }, 8, ["data"]),
        e.filterOptions.length ? (l(), n("div", Ci, [
          a("span", {
            style: g({
              color: e.titleStyle.color ? e.titleStyle.color : "#334155"
            })
          }, [
            D(t(oe), {
              "ikone-name": "vpapps-font-filter-sort-descending",
              style: g(t(s).style)
            }, null, 8, ["style"])
          ], 4),
          D(t(Qe), {
            modelValue: h.value,
            "onUpdate:modelValue": p[0] || (p[0] = (v) => h.value = v),
            options: e.filterOptions,
            "option-value": "id",
            "option-label": "name",
            class: "sort-filters",
            "drop-down-style": {
              color: e.titleStyle.color,
              backgroundColor: "white"
            },
            onChange: t(u)
          }, null, 8, ["modelValue", "options", "drop-down-style", "onChange"])
        ])) : b("", !0)
      ])) : b("", !0),
      a("div", $i, [
        a("div", {
          style: g(e.contentWrapperStyle),
          class: "flex overflow-hidden"
        }, [
          (l(!0), n(X, null, re(t(c), (v, S) => (l(), n("div", {
            class: "content-wrapper",
            style: g({
              minWidth: `${100 / e.numberOfColumns}%`,
              width: `${100 / e.numberOfColumns}%`
            }),
            key: S
          }, [
            D(t(wt), {
              cardStyle: e.cardStyle.style,
              order: e.cardStyle.order,
              infoboxFontStyle: e.cardStyle.infoboxFontStyle,
              infoboxStyle: e.cardStyle.infoboxStyle,
              infoboxClasses: e.cardStyle.infoboxClasses,
              infoboxWrapperStyle: e.cardStyle.infoboxWrapperStyle,
              titleStyle: e.cardStyle.titleStyle,
              showTitle: e.cardStyle.showTitle,
              title: v.title,
              showAuthor: e.cardStyle.showAuthor,
              author: v.author,
              showViews: !1,
              views: "00K Views",
              showDate: e.cardStyle.showDate,
              date: v.startDate,
              showThumbnail: e.cardStyle.showThumbnail,
              showTimeDuration: e.cardStyle.showTimeDuration,
              timeDuration: v.timeDuration,
              mediaid: v.mediaid,
              url: v.url,
              isRedirect: v.isRedirect,
              customWrapper: e.customWrapper,
              breakpoint: e.breakpoint
            }, {
              image: q(() => [
                a("div", {
                  class: "w-full",
                  style: g(e.cardStyle.imageStyle)
                }, null, 4)
              ]),
              badge: q(() => [
                (l(!0), n(X, null, re(f.formatedBadges, (j, $) => (l(), n(X, null, [
                  j.classes ? (l(), F(t(Ee), {
                    key: $,
                    style: g(j.style),
                    class: J(j.classes)
                  }, {
                    default: q(() => [
                      _(w(j.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["style", "class"])) : b("", !0)
                ], 64))), 256))
              ]),
              _: 2
            }, 1032, ["cardStyle", "order", "infoboxFontStyle", "infoboxStyle", "infoboxClasses", "infoboxWrapperStyle", "titleStyle", "showTitle", "title", "showAuthor", "author", "showDate", "date", "showThumbnail", "showTimeDuration", "timeDuration", "mediaid", "url", "isRedirect", "customWrapper", "breakpoint"])
          ], 4))), 128))
        ], 4)
      ])
    ]));
  }
}, _i = /* @__PURE__ */ ne(Ti, [["__scopeId", "data-v-8f8ef056"]]), Oi = { class: "j-widget flex flex-wrap" }, eu = {
  __name: "JWidget",
  emits: ["customEvent"],
  setup(e, { emit: i }) {
    const o = i, c = (s) => {
      o("customEvent", s);
    };
    return (s, r) => (l(), n("div", Oi, [
      D(t(tt), { onCustomEvent: c })
    ]));
  }
};
export {
  Ee as JBadge,
  Yt as JBanner,
  Mi as JBannerSceleton,
  se as JButton,
  Xe as JCard,
  wt as JCardSceleton,
  Ii as JChat,
  Pl as JChatInput,
  ba as JChatOptions,
  da as JChatParticipants,
  ta as JChatRow,
  Bi as JCol,
  Ba as JCommentInput,
  Fi as JComments,
  xi as JContentCarousel,
  _i as JContentCarouselSkeleton,
  Li as JContentDetails,
  tt as JContentGrid,
  Yi as JContentGridSceleton,
  yi as JContentSingle,
  di as JContentSlider,
  He as JCustomButton,
  dl as JCustomButtonSceleton,
  Di as JDetails,
  Qe as JDropdown,
  Yn as JFilmStrip,
  Ai as JFollowingMedia,
  Hi as JFooter,
  Wi as JFooterImage,
  Ei as JFooterLabel,
  Ni as JFooterMenu,
  Ri as JFooterSceleton,
  qs as JHeaderLanguageV2,
  yr as JHeaderLogoV2,
  ks as JHeaderMenuV2,
  Vs as JHeaderNotificationsV2,
  _s as JHeaderProfileV2,
  Vi as JHeaderSceleton,
  dr as JHeaderSearchV2,
  mr as JHeaderSpacingV2,
  zi as JHeaderV2,
  oe as JIcon,
  st as JImage,
  et as JImageContainer,
  Ji as JImageSceleton,
  Pi as JLabel,
  Ui as JList,
  nt as JNavigatorWrapper,
  Gi as JPageMenu,
  xe as JPertaciImage,
  yt as JProfileLetter,
  Zi as JRelatedGroup,
  Ki as JRow,
  Xi as JShowCase,
  Dr as JSidebar,
  Nr as JSlider,
  Tt as JSocialMedia,
  pr as JSpacing,
  Qi as JTab,
  Ot as JUserEngagements,
  eu as JWidget,
  ji as VButton
};
